(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+olq":
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__("LCnx"); // eslint-disable-line
module.exports = utils;

/***/ }),

/***/ "/w7L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "13C1":
/***/ (function(module, exports) {

var haversine = function () {
  var RADII = {
    km: 6371,
    mile: 3960,
    meter: 6371000,
    nmi: 3440

    // convert to radians
  };var toRad = function toRad(num) {
    return num * Math.PI / 180;
  };

  // convert coordinates to standard format based on the passed format option
  var convertCoordinates = function convertCoordinates(format, coordinates) {
    switch (format) {
      case '[lat,lon]':
        return { latitude: coordinates[0], longitude: coordinates[1] };
      case '[lon,lat]':
        return { latitude: coordinates[1], longitude: coordinates[0] };
      case '{lon,lat}':
        return { latitude: coordinates.lat, longitude: coordinates.lon };
      case '{lat,lng}':
        return { latitude: coordinates.lat, longitude: coordinates.lng };
      case 'geojson':
        return { latitude: coordinates.geometry.coordinates[1], longitude: coordinates.geometry.coordinates[0] };
      default:
        return coordinates;
    }
  };

  return function haversine(startCoordinates, endCoordinates, options) {
    options = options || {};

    var R = options.unit in RADII ? RADII[options.unit] : RADII.km;

    var start = convertCoordinates(options.format, startCoordinates);
    var end = convertCoordinates(options.format, endCoordinates);

    var dLat = toRad(end.latitude - start.latitude);
    var dLon = toRad(end.longitude - start.longitude);
    var lat1 = toRad(start.latitude);
    var lat2 = toRad(end.latitude);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    if (options.threshold) {
      return options.threshold > R * c;
    }

    return R * c;
  };
}();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = haversine;
}

/***/ }),

/***/ "1Jly":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key in rest) {
      delete rest[key];
    }
  }
  return rest;
};

exports.default = omit;

/***/ }),

/***/ "1bfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);

/***/ }),

/***/ "2JJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {} /* Nothing to set */

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events,
      names = [],
      name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event,
      available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;
      case 2:
        return listeners.fn.call(listeners.context, a1), true;
      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;
      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);break;
        case 2:
          listeners[i].fn.call(listeners[i].context, a1);break;
        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);break;
        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this),
      evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true),
      evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt],
      events = [];

  if (fn) {
    if (listeners.fn) {
      if (listeners.fn !== fn || once && !listeners.once || context && listeners.context !== context) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}

/***/ }),

/***/ "2aWH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;

/***/ }),

/***/ "2gTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "2xOb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _eventemitter = __webpack_require__("2JJl");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MarkerDispatcher = function (_EventEmitter) {
  _inherits(MarkerDispatcher, _EventEmitter);

  function MarkerDispatcher(gmapInstance) {
    _classCallCheck(this, MarkerDispatcher);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.gmapInstance = gmapInstance;
    return _this;
  }

  MarkerDispatcher.prototype.getChildren = function getChildren() {
    return this.gmapInstance.props.children;
  };

  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
    return this.gmapInstance.mouse_;
  };

  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
    return this.gmapInstance.updateCounter_;
  };

  MarkerDispatcher.prototype.dispose = function dispose() {
    this.gmapInstance = null;
    this.removeAllListeners();
  };

  return MarkerDispatcher;
}(_eventemitter2.default);

exports.default = MarkerDispatcher;

/***/ }),

/***/ "3bIi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("YdsM");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "3f5l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var style = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var GoogleMapMap = function (_Component) {
  _inherits(GoogleMapMap, _Component);

  function GoogleMapMap() {
    _classCallCheck(this, GoogleMapMap);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false; // disable react on this div
  };

  GoogleMapMap.prototype.render = function render() {
    var registerChild = this.props.registerChild;

    return _react2.default.createElement('div', { ref: registerChild, style: style });
  };

  return GoogleMapMap;
}(_react.Component);

exports.default = GoogleMapMap;

/***/ }),

/***/ "3mJm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZzxP");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js??ref--5-2!../node_modules/postcss-loader/lib/index.js??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js??ref--5-2!../node_modules/postcss-loader/lib/index.js??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5S8c":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");
var startOfYear = __webpack_require__("SInJ");
var differenceInCalendarDays = __webpack_require__("7dmj");

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(dirtyDate) {
  var date = parse(dirtyDate);
  var diff = differenceInCalendarDays(date, startOfYear(date));
  var dayOfYear = diff + 1;
  return dayOfYear;
}

module.exports = getDayOfYear;

/***/ }),

/***/ "7/2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "7L22":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");
var startOfISOWeek = __webpack_require__("Rrov");

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear(dirtyDate) {
  var date = parse(dirtyDate);
  var year = date.getFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = getISOYear;

/***/ }),

/***/ "7dmj":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("GCdn");

var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);

  var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
  var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

module.exports = differenceInCalendarDays;

/***/ }),

/***/ "7oLP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _google_map = __webpack_require__("zszy");

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _google_map2.default;

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BXyq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var normalizeHeaderName = __webpack_require__("M8l6");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("KRuG");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("KRuG");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/***/ }),

/***/ "BtxX":
/***/ (function(module, exports) {

(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(this);

/***/ }),

/***/ "CFBi":
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate(argument) {
  return argument instanceof Date;
}

module.exports = isDate;

/***/ }),

/***/ "CnKR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  // eslint-disable-next-line no-self-compare
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;
/* src: https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js */

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "ED/T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "GCdn":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  var date = parse(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = startOfDay;

/***/ }),

/***/ "GZEH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rbush = __webpack_require__("tMOH");

var _rbush2 = _interopRequireDefault(_rbush);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var toBBox = function toBBox(p) {
  return [p.x, p.y, p.x, p.y];
};
var compareMinX = function compareMinX(a, b) {
  return a.x - b.x;
};
var compareMinY = function compareMinY(a, b) {
  return a.y - b.y;
};

exports.default = function (nodeSize) {
  var tree = (0, _rbush2.default)(nodeSize);
  tree.toBBox = toBBox;
  tree.compareMinX = compareMinX;
  tree.compareMinY = compareMinY;
  return tree;
};

/***/ }),

/***/ "H6Qo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/preact-habitat/dist/preact-habitat.es.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Removes `-` fron a string and capetalize the letter after
 * example: data-props-hello-world =>  dataPropsHelloWorld
 * Used for props passed from host DOM element
 * @param  {String} str string
 * @return {String} Capetalized string
 */
var camelcasize = function camelcasize(str) {
  return str.replace(/-([a-z])/gi, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * [getExecutedScript internal widget to provide the currently executed script]
 * @param  {document} document [Browser document object]
 * @return {HTMLElement}     [script Element]
 */
var getExecutedScript = function getExecutedScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  }();
};

/**
 * Get the props from a host element's data attributes
 * @param  {Element} tag The host element
 * @return {Object}  props object to be passed to the component
 */
var collectPropsFromElement = function collectPropsFromElement(element, defaultProps) {
  if (defaultProps === void 0) defaultProps = {};

  var attrs = element.attributes;

  var props = _extends({}, defaultProps);

  // collect from element
  Object.keys(attrs).forEach(function (key) {
    if (attrs.hasOwnProperty(key)) {
      var dataAttrName = attrs[key].name;
      if (!dataAttrName || typeof dataAttrName !== "string") {
        return false;
      }
      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
      propName = camelcasize(propName);
      if (dataAttrName !== propName) {
        var propValue = attrs[key].nodeValue;
        props[propName] = propValue;
      }
    }
  });

  // check for child script text/props or application/json
  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
    var propsObj = {};
    if (scrp.hasAttribute('type')) {
      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") {
        return;
      }
      try {
        propsObj = JSON.parse(scrp.innerHTML);
      } catch (e) {
        throw new Error(e);
      }
      _extends(props, propsObj);
    }
  });

  return props;
};

var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript) {
  var scriptTagAttrs = currentScript.attributes;
  var selector = null;
  // check for another props attached to the tag
  Object.keys(scriptTagAttrs).forEach(function (key) {
    if (scriptTagAttrs.hasOwnProperty(key)) {
      var dataAttrName = scriptTagAttrs[key].name;
      if (dataAttrName === 'data-mount-in') {
        selector = scriptTagAttrs[key].nodeValue;
      }
    }
  });
  return selector;
};

/**
 * Return array of 0 or more elements that will host our widget
 * @param  {id} attrId the data widget id attribute the host should have
 * @param  {document} scope  Docuemnt object or DOM Element as a scope
 * @return {Array}        Array of matching habitats
 */
var widgetDOMHostElements = function widgetDOMHostElements(ref) {
  var selector = ref.selector;
  var inline = ref.inline;
  var clientSpecified = ref.clientSpecified;

  var hostNodes = [];
  var currentScript = getExecutedScript();

  if (inline === true) {
    var parentNode = currentScript.parentNode;
    hostNodes.push(parentNode);
  }
  if (clientSpecified === true && !selector) {
    // user did not specify where to mount - get it from script tag attributes
    selector = getHabitatSelectorFromClient(currentScript);
  }
  if (selector) {
    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
      hostNodes.push(queriedTag);
    });
  }
  return hostNodes;
};

/**
 * preact render function that will be queued if the DOM is not ready
 * and executed immeidatly if DOM is ready
 */
var preact_habitat_es_preactRender = function preactRender(widget, hostElements, root, cleanRoot, defaultProps) {
  hostElements.forEach(function (elm) {
    var hostNode = elm;
    if (hostNode._habitat) {
      return;
    }
    hostNode._habitat = true;
    var props = collectPropsFromElement(elm, defaultProps) || defaultProps;
    if (cleanRoot) {
      hostNode.innerHTML = "";
    }
    return Object(preact_min["render"])(Object(preact_min["h"])(widget, props), hostNode, root);
  });
};

var habitat = function habitat(Widget) {
  // Widget represents the Preact component we need to mount
  var widget = Widget;
  // preact root render helper
  var root = null;

  var render$$1 = function render$$1(ref) {
    if (ref === void 0) ref = {};
    var selector = ref.selector;if (selector === void 0) selector = null;
    var inline = ref.inline;if (inline === void 0) inline = false;
    var clean = ref.clean;if (clean === void 0) clean = false;
    var clientSpecified = ref.clientSpecified;if (clientSpecified === void 0) clientSpecified = false;
    var defaultProps = ref.defaultProps;if (defaultProps === void 0) defaultProps = {};

    var elements = widgetDOMHostElements({
      selector: selector,
      inline: inline,
      clientSpecified: clientSpecified
    });
    var loaded = function loaded() {
      if (elements.length > 0) {
        var elements$1 = widgetDOMHostElements({
          selector: selector,
          inline: inline,
          clientSpecified: clientSpecified
        });

        return preact_habitat_es_preactRender(widget, elements$1, root, clean, defaultProps);
      }
    };
    loaded();
    document.addEventListener("DOMContentLoaded", loaded);
    document.addEventListener("load", loaded);
  };

  return { render: render$$1 };
};

/* harmony default export */ var preact_habitat_es = (habitat);
//# sourceMappingURL=preact-habitat.es.js.map
// CONCATENATED MODULE: ../node_modules/preact-router/dist/preact-router.es.js


var EMPTY$1 = {};

function preact_router_es_assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var preact_router_es_Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					preact_router_es_assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(preact_min["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(preact_min["Component"]);

var preact_router_es_Link = function Link(props) {
	return Object(preact_min["h"])('a', preact_router_es_assign({ onClick: handleLinkClick }, props));
};

var preact_router_es_Route = function Route(props) {
	return Object(preact_min["h"])(props.component, props);
};

preact_router_es_Router.subscribers = subscribers;
preact_router_es_Router.getCurrentUrl = getCurrentUrl;
preact_router_es_Router.route = route;
preact_router_es_Router.Router = preact_router_es_Router;
preact_router_es_Router.Route = preact_router_es_Route;
preact_router_es_Router.Link = preact_router_es_Link;

/* harmony default export */ var preact_router_es = (preact_router_es_Router);
//# sourceMappingURL=preact-router.es.js.map
// EXTERNAL MODULE: ../node_modules/history/createHashHistory.js
var createHashHistory = __webpack_require__("nqnI");
var createHashHistory_default = /*#__PURE__*/__webpack_require__.n(createHashHistory);

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__("dZBD");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./helpers/classnames.js
var hasOwn = {}.hasOwnProperty;

/* harmony default export */ var classnames = (function () {
    for (var _len = arguments.length, classnames = Array(_len), _key = 0; _key < _len; _key++) {
        classnames[_key] = arguments[_key];
    }

    var classes = [];

    for (var _iterator = classnames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var x = _ref;

        var type = typeof x;
        if (type === 'string' && x !== '') {
            classes.push(x);
        }
        if (type === 'object') {
            for (var key in x) {
                if (hasOwn.call(x, key) && x[key]) {
                    classes.push(key);
                }
            }
        }
    }
    return classes.join(' ');
});
// EXTERNAL MODULE: ../node_modules/date-fns/parse/index.js
var parse = __webpack_require__("ajCz");
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);

// EXTERNAL MODULE: ../node_modules/date-fns/format/index.js
var format = __webpack_require__("Vy4H");
var format_default = /*#__PURE__*/__webpack_require__.n(format);

// CONCATENATED MODULE: ./helpers/timeString.js



/**
 * Given an array of timeslots, display a string describing the events'
 * occurrences over time.
 *
 * @param {Array<Object>} - timeslots
 * @return {String}
 */

var parseUNIX = function parseUNIX(timestamp) {
  return new Date(timestamp * 1000);
};

var timeString_timeString = function timeString(timeslots) {
  if (typeof timeslots === "string") {
    return timeslots;
  }
  var dateFormat = 'MMM Do';

  if (timeslots && timeslots.length === 1) {
    var _timeslots$ = timeslots[0],
        start_date = _timeslots$.start_date,
        end_date = _timeslots$.end_date;

    var startDate = format_default()(parseUNIX(start_date), dateFormat);
    var endDate = format_default()(parseUNIX(end_date), dateFormat);

    if (startDate === endDate) {
      return startDate;
    } else {
      return startDate + ' - ' + endDate;
    }
  } else if (timeslots && timeslots.length > 1) {
    var _start_date = timeslots[0].start_date;
    var _end_date = timeslots[timeslots.length - 1].end_date;

    var _startDate = format_default()(parseUNIX(_start_date), dateFormat);
    var _endDate = format_default()(parseUNIX(_end_date), dateFormat);
    if (_startDate === _endDate) {
      return timeslots.length + ' shifts on ' + _startDate;
    }
    return timeslots.length + ' shifts between ' + _startDate + ' - ' + _endDate;
  }
};

/* harmony default export */ var helpers_timeString = (timeString_timeString);
// CONCATENATED MODULE: ./helpers/eventMeta.js


/**
 * Given a location and sponsor object, outputs a string that represents both
 * sets of data.
 *
 * @param {Object} - { location<Object>, sponsor<Object> }
 * @return {String}
 */
var eventMeta = function eventMeta(_ref) {
  var location = _ref.location,
      _ref$sponsor = _ref.sponsor,
      sponsor = _ref$sponsor === undefined ? {} : _ref$sponsor;


  if (!location) {
    return '';
  }

  var _sponsor$candidate_na = sponsor.candidate_name,
      candidate_name = _sponsor$candidate_na === undefined ? '' : _sponsor$candidate_na,
      _sponsor$name = sponsor.name,
      name = _sponsor$name === undefined ? '' : _sponsor$name;


  var output = [];

  //console.log({location})

  if (typeof location.venue !== 'undefined' && location.venue.length) {
    output.push(location.venue);
  } else {
    var address_lines = location.address_lines,
        locality = location.locality,
        region = location.region,
        full_address = location.full_address;

    if (full_address) {
      output.push(full_address);
    } else if (address_lines && address_lines.length && address_lines.join("")) {
      var address = address_lines.filter(function (a) {
        return a.trim() !== '';
      });
      output.push('' + address.concat(locality, region).join(', '));
    }
  }

  if (candidate_name && candidate_name.length || name && name.length) {
    output.push('Hosted by ' + (candidate_name || name));
  }

  return output.length && output.length > 1 ? output.join(' / ') : output[0];
};

var eventMeta_cityState = function cityState(_ref2) {
  var _ref2$location = _ref2.location,
      location = _ref2$location === undefined ? {} : _ref2$location;
  var locality = location.locality,
      region = location.region,
      postal_code = location.postal_code;


  if (locality && (region || postal_code)) {
    return Object(preact_min["h"])(
      'span',
      null,
      locality,
      ', ',
      region || postal_code
    );
  }
};

var eventMeta_cityStateHost = function cityStateHost(_ref3) {
  var _ref3$location = _ref3.location,
      location = _ref3$location === undefined ? {} : _ref3$location,
      _ref3$sponsor = _ref3.sponsor,
      sponsor = _ref3$sponsor === undefined ? {} : _ref3$sponsor;


  if (!location) {
    return '';
  }

  var locality = location.locality,
      region = location.region,
      postal_code = location.postal_code;
  var _sponsor$candidate_na2 = sponsor.candidate_name,
      candidate_name = _sponsor$candidate_na2 === undefined ? '' : _sponsor$candidate_na2,
      _sponsor$name2 = sponsor.name,
      name = _sponsor$name2 === undefined ? '' : _sponsor$name2;

  var host = '';

  if (candidate_name && candidate_name.length || name && name.length) {
    host = 'Hosted by ' + (candidate_name || name);
  }

  if (locality && (region || postal_code)) {
    return Object(preact_min["h"])(
      'span',
      null,
      locality,
      ', ',
      region || postal_code,
      ' ',
      host ? '/ ' + host : ''
    );
  }
};

/* harmony default export */ var helpers_eventMeta = (eventMeta);
// CONCATENATED MODULE: ./helpers/index.js






var cleanUrl = function cleanUrl(string) {
    return String(string).replace(/(https?:\/\/)|(\/)+/g, '$1$2');
};

var cleanEntities = function cleanEntities(string) {
    return string.replace(/\u2018|\ufffd|\u201b/g, '&lsquo;').replace(/\u2013/g, String.fromCharCode(8211)).replace(/u2019/g, String.fromCharCode(8217)).replace(/\u2019/g, String.fromCharCode(8217)).replace(/\u201a/g, '&sbquo;').replace(/\u201c/g, '&ldquo;').replace(/\u201d/g, '&rdquo;').replace(/&amp;/g, String.fromCharCode(38)).replace(/&#038;/g, String.fromCharCode(38)).replace(/&#8217;/g, String.fromCharCode(8217)).replace(/&ndash;/g, String.fromCharCode(8211)).replace(/\u2014/g, String.fromCharCode(8212)).replace(/&mdash;/g, String.fromCharCode(8212)).replace(/\u2026/g, String.fromCharCode(8230));
};

var helpers__ref = Object(preact_min["h"])('br', null);

var helpers__ref2 = Object(preact_min["h"])('br', null);

var helpers_splitLines = function splitLines() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return string.split('\n\n').map(function (item, key) {
        return Object(preact_min["h"])(
            'span',
            { key: key },
            item,
            helpers__ref,
            helpers__ref2
        );
    });
};

var cleanAndSplitString = function cleanAndSplitString(string) {
    return helpers_splitLines(cleanEntities(string));
};

if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}

var sanitizeParameterString = function sanitizeParameterString() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return String(str).replace(/\?/g, '').split('&').map(function (str) {
        return str.split('=').map(encodeURIComponent).join('=');
    }).join('&');
};

var appendParameterString = function appendParameterString(href, parameters) {
    return parameters ? href + (href.indexOf('?') > -1 ? '&' : '?') + parameters : href;
};

var connectAddThis = function connectAddThis() {
    setTimeout(function () {
        if (window.addthis && typeof window.addthis.toolbox === "function") {
            window.addthis.toolbox('.wem__event-actions__social');
        }
    }, 100);
};

//gup :: String -> String
function gup(name) {
    name = String(name).replace(/(\[|\])/g, "\\$1");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.href);
    return results === null ? "" : results[1];
}

var scrollToWidgetTop = function scrollToWidgetTop() {
    var $maybeAlert = document.querySelector('.ok-to-alert .alert-bar');
    var $maybeTop = document.querySelector('.top');
    var $widget = document.querySelector('[data-widget-host="we-mobilize"]');
    var headerHeight = 0;

    var rect = $widget.getBoundingClientRect();

    if ($maybeTop && window.getComputedStyle) {
        headerHeight = window.getComputedStyle($maybeTop).position === 'sticky' ? -75 : 0;
    }

    //const targetY = window.scrollY + rect.top - (window.innerHeight - $widget.offsetHeight);
    // window.scroll(0, targetY - (
    //   $maybeHeader && ($maybeHeader.offsetHeight + $maybeHeader.offsetTop)||0)
    // );
    //console.log(headerHeight + ($maybeAlert ? $maybeAlert.offsetHeight : 0))
    //scroll internal widget
    window.scroll(0, headerHeight + ($maybeAlert ? $maybeAlert.offsetHeight : 0)); //scroll window
};

var capitalize = function capitalize(string) {
    return String(string).charAt(0).toUpperCase() + String(string).slice(1).toLowerCase();
};

var sanitizeCategory = function sanitizeCategory(string) {
    return String(string).replace(/_/g, ' ').split(' ').map(capitalize).join(' ');
};

var slugify = function slugify(string) {
    return string ? String(string).trim().replace(/\s/g, '-') // turn spaces into slugs
    .replace(/[^\w-]+/g, '') // remove non-letters/dashes
    .replace(/--+$/, "-") // remove trailing --
    .toLowerCase() : '';
};


// EXTERNAL MODULE: ../node_modules/haversine/haversine.js
var haversine = __webpack_require__("13C1");
var haversine_default = /*#__PURE__*/__webpack_require__.n(haversine);

// CONCATENATED MODULE: ./helpers/filters.js




var filters_parseUNIX = function parseUNIX(timestamp) {
  return new Date(timestamp * 1000);
};

var parseDateStamp = function parseDateStamp(datestamp) {
  var _datestamp$split = datestamp.split(/\D/),
      year = _datestamp$split[0],
      month = _datestamp$split[1],
      day = _datestamp$split[2];

  return new Date(year, month - 1, day);
};
var filters_dateFormat = 'YYYYDDDD';

var filters_parseDateStampToDay = function parseDateStampToDay(datestamp) {
  return datestamp && format_default()(parseDateStamp(datestamp), filters_dateFormat) || '';
};

var isCategory = function isCategory(category) {
  return function (event) {
    return category === event.event_type;
  };
};

var isVirtualOnly = function isVirtualOnly(event) {
  return event.is_virtual;
};

var onlyNonVirtual = function onlyNonVirtual(event) {
  return !event.is_virtual;
};

var filters__isOnOrAfter = function _isOnOrAfter(YYYYDDDD) {
  return function (event) {
    return format_default()(filters_parseUNIX(event.last_day || event.first_day), filters_dateFormat) >= YYYYDDDD;
  };
}; //in progress, but idea is that we sort into dates, then can by distance

var isOnOrAfter = function isOnOrAfter(datestamp) {
  return filters__isOnOrAfter(filters_parseDateStampToDay(datestamp));
};

var filters_getDistanceFromOrigin = function getDistanceFromOrigin(origin) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return function (events) {
    return events.reduce(function (acc, event) {
      var distanceFromSearch = haversine_default()(origin, event.location.location, {
        unit: 'mile'
      });
      event.distanceFromSearch = distanceFromSearch;
      if (distanceFromSearch < threshold) {
        acc.push(event);
      }
      return acc;
    }, []);
  };
};

//distance
var byDistance = function byDistance(events) {
  return events.sort(function (a, b) {
    return a.distanceFromSearch - b.distanceFromSearch;
  });
};

//sorts by day, then distance within day
var filters_byDayThenDistance = function byDayThenDistance(events) {
  return events.sort(function (a, b) {
    return format_default()(filters_parseUNIX(a.last_day || a.first_day), filters_dateFormat) - format_default()(filters_parseUNIX(b.last_day || b.first_day), filters_dateFormat) || a.distanceFromSearch - b.distanceFromSearch;
  });
};

var defaultFilters = {
  fromOrigin: false,
  fromDay: false,
  byCategory: false,
  virtualOnly: true
};

var refilterEvents = function refilterEvents(events, _ref) {
  var fromOrigin = _ref.fromOrigin,
      fromDay = _ref.fromDay,
      byCategory = _ref.byCategory,
      virtualOnly = _ref.virtualOnly;

  var tempevents = [];

  console.log('filters', events, { fromOrigin: fromOrigin, fromDay: fromDay, byCategory: byCategory, virtualOnly: virtualOnly });

  //filters
  if (byCategory && fromDay) {
    tempevents = events.filter(function (x) {
      return isCategory(byCategory)(x) && isOnOrAfter(fromDay)(x);
    });
  } else if (fromDay) {
    tempevents = events.filter(isOnOrAfter(fromDay));
  } else if (byCategory) {
    tempevents = events.filter(isCategory(byCategory));
  } else {
    tempevents = [].concat(events); //just clone all events
  }

  console.log(tempevents.filter(isVirtualOnly).length + ' vs ' + events.length);
  return virtualOnly ? tempevents.filter(isVirtualOnly) : tempevents.filter(onlyNonVirtual);
};
// CONCATENATED MODULE: ./components/Icons/Icons.js
var Icons__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var namespaced = { 'xml:space': "preserve" };

var Icons__ref = Object(preact_min["h"])(
  'title',
  null,
  'Close Button'
);

var Icons__ref2 = Object(preact_min["h"])(
  'desc',
  null,
  'Round button with X inside'
);

var Icons__ref3 = Object(preact_min["h"])('polygon', { fill: 'currentColor', points: '97,10.5 89.6,3.1 50.1,42.6 50.1,42.6 50,42.6 10.4,3.1 3,10.5 42.5,50 3,89.5 10.4,96.9 50,57.4 50.1,57.4 50.1,57.4 89.6,96.9 97,89.5 57.5,50 ' });

var Icons_CloseButton = function CloseButton() {
  return Object(preact_min["h"])(
    'svg',
    Icons__extends({ version: '1.1', id: 'Layer_1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', viewBox: '0 0 100 100', style: 'enable-background:new 0 0 100 100;' }, namespaced),
    Icons__ref,
    Icons__ref2,
    Icons__ref3
  );
};
var Icons_Caret = function Caret(_ref4) {
  var _ref4$strokewidth = _ref4.strokewidth,
      strokewidth = _ref4$strokewidth === undefined ? 4 : _ref4$strokewidth;
  return Object(preact_min["h"])(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 31 46' },
    Object(preact_min["h"])('path', { stroke: 'currentColor', fill: 'transparent', 'stroke-width': strokewidth, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', d: 'M5.7 39.3l16.6-16.9L5.7 5.3' })
  );
};

var Icons_PlainStar = function PlainStar(_ref5) {
  var _ref5$strokewidth = _ref5.strokewidth,
      strokewidth = _ref5$strokewidth === undefined ? 0 : _ref5$strokewidth;
  return Object(preact_min["h"])(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', version: '1.1', 'data-icon': 'star', viewBox: '0 0 32 32', x: '0px', y: '0px' },
    Object(preact_min["h"])('path', { fill: 'currentColor', 'stroke-width': strokewidth, d: 'M16 0l-3.906 12h-12.094l9.813 7.188-3.813 11.813 10-7.313 10 7.313-3.813-11.813 9.813-7.188h-12.094l-3.906-12z' })
  );
};

var _ref7 = Object(preact_min["h"])(
  'filter',
  { id: 'dropshadow', height: '120%' },
  Object(preact_min["h"])('feGaussianBlur', { 'in': 'SourceAlpha', stdDeviation: '2' }),
  Object(preact_min["h"])('feOffset', { dx: '2', dy: '2', result: 'offsetblur' }),
  Object(preact_min["h"])(
    'feComponentTransfer',
    null,
    Object(preact_min["h"])('feFuncA', { type: 'linear', slope: '0.3' })
  ),
  Object(preact_min["h"])(
    'feMerge',
    null,
    Object(preact_min["h"])('feMergeNode', null),
    Object(preact_min["h"])('feMergeNode', { 'in': 'SourceGraphic' })
  )
);

var Icons_Star = function Star(_ref6) {
  var _ref6$strokewidth = _ref6.strokewidth,
      strokewidth = _ref6$strokewidth === undefined ? 2 : _ref6$strokewidth;
  return Object(preact_min["h"])(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', 'data-icon': 'star', viewBox: '0 0 32 32', x: '0px', y: '0px' },
    _ref7,
    Object(preact_min["h"])('path', { style: 'filter:url(#dropshadow)', stroke: '#fff', 'stroke-width': strokewidth, d: 'M16 0l-3.906 12h-12.094l9.813 7.188-3.813 11.813 10-7.313 10 7.313-3.813-11.813 9.813-7.188h-12.094l-3.906-12z' })
  );
};

var _ref9 = Object(preact_min["h"])(
  'svg',
  { version: '1.1', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 11 14' },
  Object(preact_min["h"])('path', { style: 'filter:url(#dropshadow)', fill: 'currentColor', d: 'M10.5 0q0.203 0 0.352 0.148t0.148 0.352v13q0 0.203-0.148 0.352t-0.352 0.148h-10q-0.203 0-0.352-0.148t-0.148-0.352v-13q0-0.203 0.148-0.352t0.352-0.148h10zM4 2.25v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18zM4 4.25v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18zM4 6.25v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18zM4 8.25v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18zM3 10.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM3 8.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM3 6.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM3 4.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM3 2.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM7 12.75v-1.5q0-0.109-0.070-0.18t-0.18-0.070h-2.5q-0.109 0-0.18 0.070t-0.070 0.18v1.5q0 0.109 0.070 0.18t0.18 0.070h2.5q0.109 0 0.18-0.070t0.070-0.18zM7 8.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM7 6.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM7 4.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM7 2.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM9 10.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM9 8.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM9 6.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM9 4.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18zM9 2.75v-0.5q0-0.109-0.070-0.18t-0.18-0.070h-0.5q-0.109 0-0.18 0.070t-0.070 0.18v0.5q0 0.109 0.070 0.18t0.18 0.070h0.5q0.109 0 0.18-0.070t0.070-0.18z' })
);

var Building = function Building(_ref8) {
  var color = _ref8.color;
  return _ref9;
};

var _ref10 = Object(preact_min["h"])(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', 'aria-labelledby': 'title', role: 'img', width: '14', height: '16' },
  Object(preact_min["h"])(
    'title',
    { id: 'title' },
    'Priority Flag'
  ),
  Object(preact_min["h"])('path', { fill: 'currentColor', d: 'M11.125 5.5L13.9 1.8c.113-.151.132-.354.047-.523C13.862 1.108 13.689 1 13.5 1H1V.5C1 .224.776 0 .5 0S0 .224 0 .5v15c0 .276.224.5.5.5s.5-.224.5-.5V10h12.5c.189 0 .362-.107.447-.276s.067-.372-.047-.524l-2.775-3.7z' })
);

var Flag = function Flag() {
  return _ref10;
};
// CONCATENATED MODULE: ./components/EventActions/EventActions.js
var EventActions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var EventActions__ref2 = Object(preact_min["h"])(Icons_Caret, { strokewidth: '6' });

var EventActions_CardAction = function CardAction(_ref) {
  var browser_url = _ref.browser_url,
      local_url = _ref.local_url,
      is_wp_item = _ref.is_wp_item,
      children = _ref.children,
      isDetailCard = _ref.isDetailCard,
      title = _ref.title,
      has_rsvp_url = _ref.has_rsvp_url,
      _ref$link_source = _ref.link_source,
      link_source = _ref$link_source === undefined ? '' : _ref$link_source;

  var type = 'rsvp';
  if (!browser_url) {
    return null;
  }
  if (is_wp_item && (!local_url && !browser_url || !has_rsvp_url)) {
    return null;
  }
  if (children && String(children[0]).toLowerCase() !== 'rsvp') {
    type = 'details';
    if (isDetailCard && is_wp_item) {
      return null;
    }
  }
  var href = appendParameterString(type === 'details' && local_url ? local_url : browser_url, link_source);
  return Object(preact_min["h"])(
    'a',
    { onClick: function onClick(e) {
        return e.stopPropagation();
      }, 'class': 'wem__event-actions__url wem__event-actions__url-' + type, href: href, target: !is_wp_item ? "_blank" : null },
    children,
    ' ',
    EventActions__ref2
  );
};

var EventActions__ref4 = Object(preact_min["h"])('i', { 'class': 'fa fab fa-facebook-f', target: '_blank' });

var EventActions__ref5 = Object(preact_min["h"])('i', { 'class': 'fa fab fa-twitter' });

var EventActions__ref6 = Object(preact_min["h"])('i', { 'class': 'fa fas fa-envelope' });

var EventActions_CardSocial = function CardSocial(_ref3) {
  var browser_url = _ref3.browser_url,
      local_url = _ref3.local_url,
      title = _ref3.title;


  var encoded_url = encodeURIComponent(browser_url);
  var encoded_title = encodeURIComponent(title);

  var emailProps = {
    'addthis:title': title,
    'addthis:url': browser_url,
    'addthis:ui_email_note': 'Note',
    target: 'blank',
    title: 'Email',
    href: 'mailto:?subject=' + encoded_title + '&body=' + encoded_url,
    onClick: function onClick(e) {
      if (window.addthis && window.addthis_config) {
        addthis_config.ui_email_note = browser_url;
      }
    }
  };

  return Object(preact_min["h"])(
    'div',
    { 'class': 'wem__event-actions__social' },
    Object(preact_min["h"])(
      'a',
      { 'class': 'wem__event-actions__social-link social-pop', href: 'http://www.facebook.com/sharer.php?u=' + encoded_url },
      EventActions__ref4
    ),
    Object(preact_min["h"])(
      'a',
      { 'class': 'wem__event-actions__social-link social-pop', href: 'http://twitter.com/intent/tweet?text=' + encoded_title + '&url=' + encoded_url, target: '_blank' },
      EventActions__ref5
    ),
    Object(preact_min["h"])(
      'a',
      EventActions__extends({ 'class': 'wem__event-actions__social-link addthis_button_email' }, emailProps),
      EventActions__ref6
    )
  );
};

var EventActions_EventActions = function EventActions(eventprops) {
  var nosocial = eventprops.nosocial,
      has_rsvp_url = eventprops.has_rsvp_url,
      is_wp_item = eventprops.is_wp_item,
      browser_url = eventprops.browser_url,
      local_url = eventprops.local_url;


  var className = classnames("wem__event-actions", { '--no-url': is_wp_item && (!local_url && !browser_url || !has_rsvp_url) });

  return Object(preact_min["h"])(
    'div',
    { 'class': className },
    Object(preact_min["h"])(
      EventActions_CardAction,
      eventprops,
      'Event Details'
    ),
    Object(preact_min["h"])(
      EventActions_CardAction,
      eventprops,
      'RSVP'
    ),
    !nosocial && Object(preact_min["h"])(EventActions_CardSocial, eventprops)
  );
};

/* harmony default export */ var components_EventActions_EventActions = (EventActions_EventActions);
// CONCATENATED MODULE: ./components/EventCard/index.js
var EventCard__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EventCard__ref = Object(preact_min["h"])(
  'span',
  null,
  '\u2026'
);

var EventCard_truncate = function truncate(n) {
  return function (string) {
    return Object(preact_min["h"])(
      'span',
      null,
      string.substr(0, n - 1).trim(),
      string.length > n ? EventCard__ref : ''
    );
  };
};

var EventCard__ref2 = Object(preact_min["h"])(
  'span',
  { 'class': '' },
  'Virtual Event \u2014 '
);

var EventCard__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'wem_event-card__priority-icon', title: 'Highest Priority' },
  Object(preact_min["h"])(Icons_PlainStar, null)
);

var EventCard_EventCard = function (_Component) {
  _inherits(EventCard, _Component);

  function EventCard() {
    var _temp, _this, _ret;

    _classCallCheck(this, EventCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          base_path = _this$props.base_path,
          event = _this$props.event,
          setEvent = _this$props.setEvent;
      var id = event.id,
          post_id = event.post_id,
          slug = event.slug,
          is_wp_item = event.is_wp_item,
          title = event.title;

      var newroute = cleanUrl((post_id || id) + '/' + slugify(title));
      setEvent(event);
      route(newroute);
      scrollToWidgetTop();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EventCard.prototype.render = function render(props) {
    var event = props.event,
        show_images = props.show_images,
        isVirtual = props.isVirtual,
        _props$itemHeight = props.itemHeight,
        itemHeight = _props$itemHeight === undefined ? 290 : _props$itemHeight,
        _props$link_source = props.link_source,
        link_source = _props$link_source === undefined ? '' : _props$link_source;
    var _event$browser_url = event.browser_url,
        browser_url = _event$browser_url === undefined ? '' : _event$browser_url,
        location = event.location,
        sponsor = event.sponsor,
        _event$summary = event.summary,
        summary = _event$summary === undefined ? '' : _event$summary,
        timeslots = event.timeslots,
        title = event.title,
        _event$description = event.description,
        description = _event$description === undefined ? '' : _event$description,
        _event$is_virtual = event.is_virtual,
        is_virtual = _event$is_virtual === undefined ? false : _event$is_virtual,
        post_id = event.post_id,
        id = event.id,
        is_wp_item = event.is_wp_item,
        _event$high_priority = event.high_priority,
        high_priority = _event$high_priority === undefined ? false : _event$high_priority,
        featured_image_url = event.featured_image_url,
        _event$priority = event.priority,
        priority = _event$priority === undefined ? false : _event$priority;


    var className = 'wem__event wem__event-card' + (show_images && featured_image_url ? ' --has-image' : '');

    var hasImage = show_images && featured_image_url;

    var cleanTitle = cleanEntities(title);

    var isLongTitle = cleanTitle.length > 70;

    var titleClass = 'wem__event-card__title h5' + (isLongTitle ? ' wem_long_title' : '');

    var descriptionLimit = isVirtual && hasImage ? cleanTitle.length >= 39 ? 85 : 130 : 140;

    var descriptionLimitShort = isVirtual && hasImage ? cleanTitle.length >= 39 ? 65 : 90 : 108;

    return Object(preact_min["h"])(
      'div',
      { 'class': className, onClick: this.onClick, id: post_id || id, style: { height: itemHeight } },
      Object(preact_min["h"])(
        'div',
        { 'class': 'wem__event-card__details' },
        Object(preact_min["h"])(
          'h6',
          { 'class': 'wem__event-card__date h6' },
          is_virtual && EventCard__ref2,
          helpers_timeString(timeslots)
        ),
        high_priority && EventCard__ref3,
        Object(preact_min["h"])(
          'h3',
          { 'class': titleClass },
          cleanTitle
        ),
        Object(preact_min["h"])(
          'strong',
          { 'class': 'wem__event-card__meta city-state' },
          eventMeta_cityStateHost({ location: location, sponsor: sponsor })
        ),
        (summary || description) && Object(preact_min["h"])(
          'p',
          { 'class': 'wem__event-card__description description-short' },
          EventCard_truncate(descriptionLimitShort)(cleanEntities(summary || description))
        ),
        (summary || description) && Object(preact_min["h"])(
          'p',
          { 'class': 'wem__event-card__description description-long' },
          EventCard_truncate(descriptionLimit)(cleanEntities(summary || description))
        ),
        Object(preact_min["h"])(components_EventActions_EventActions, EventCard__extends({ link_source: link_source }, event))
      ),
      show_images && featured_image_url && Object(preact_min["h"])(
        'figure',
        { 'class': 'wem__event-card__image' },
        Object(preact_min["h"])('img', { src: featured_image_url })
      )
    );
  };

  return EventCard;
}(preact_min["Component"]);

/* harmony default export */ var components_EventCard = (EventCard_EventCard);
// CONCATENATED MODULE: ./components/Loader/index.js



function Loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Loader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Loader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// class Loader extends Component {
//   render() {
//     return (
//       <div class="wem__loader">
//         <i class="wem__loader__icon fa fas fa-spinner" />
//       </div>
//     );
//   }
// }

var Loader__ref = Object(preact_min["h"])(
  'div',
  { 'class': 'wem__loader__icon' },
  Object(preact_min["h"])('div', { style: 'width:100%;height:100%', 'class': 'lds-dual-ring' })
);

var Loader_Loader = function (_Component) {
  Loader__inherits(Loader, _Component);

  function Loader() {
    Loader__classCallCheck(this, Loader);

    return Loader__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Loader.prototype.render = function render(props) {
    var highZIndex = props.highZIndex,
        style = props.style;

    var className = classnames("wem__loader", { high: highZIndex });
    return Object(preact_min["h"])(
      'div',
      { 'class': className, style: style },
      Loader__ref
    );
  };

  return Loader;
}(preact_min["Component"]);

/* harmony default export */ var components_Loader = (Loader_Loader);
// CONCATENATED MODULE: ./components/EventDetail/index.js
var EventDetail__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function EventDetail__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventDetail__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventDetail__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EventDetail__ref2 = Object(preact_min["h"])(Icons_CloseButton, null);

var EventDetail__ref3 = Object(preact_min["h"])(
  'span',
  { 'class': '' },
  'Virtual Event \u2014 '
);

var EventDetail__ref4 = Object(preact_min["h"])(
  'div',
  { 'class': 'wem_event-card__priority-icon', title: 'Highest Priority' },
  Object(preact_min["h"])(Icons_PlainStar, null)
);

var EventDetail__ref5 = Object(preact_min["h"])('hr', null);

var EventDetail__ref6 = Object(preact_min["h"])(
  'h4',
  { 'class': 'wem__event-detail__headline' },
  'Where'
);

var EventDetail__ref7 = Object(preact_min["h"])(
  'h4',
  { 'class': 'wem__event-detail__headline' },
  'Description'
);

var EventDetail_EventDetail = function EventDetail(props) {
  var base_path = props.base_path,
      browser_url = props.browser_url,
      _props$description = props.description,
      description = _props$description === undefined ? '' : _props$description,
      sponsor = props.sponsor,
      timeslots = props.timeslots,
      title = props.title,
      onClose = props.onClose,
      high_priority = props.high_priority,
      featured_image_url = props.featured_image_url,
      _props$is_virtual = props.is_virtual,
      is_virtual = _props$is_virtual === undefined ? false : _props$is_virtual,
      location = props.location,
      is_wp_item = props.is_wp_item,
      _props$venue = props.venue,
      venue = _props$venue === undefined ? '' : _props$venue,
      _props$link_source = props.link_source,
      link_source = _props$link_source === undefined ? '' : _props$link_source,
      id = props.id;

  var _ref = location || {},
      _ref$full_address = _ref.full_address,
      full_address = _ref$full_address === undefined ? '' : _ref$full_address,
      _ref$address_lines = _ref.address_lines,
      address_lines = _ref$address_lines === undefined ? [] : _ref$address_lines,
      locality = _ref.locality,
      region = _ref.region,
      postal_code = _ref.postal_code,
      _ref$venue = _ref.venue,
      loc_venue = _ref$venue === undefined ? '' : _ref$venue;

  var maybeVenue = (venue || loc_venue).replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g, " ");

  var actions = EventDetail__extends({}, props, {
    isDetailCard: true
  });
  var address = address_lines.filter(function (a) {
    return a.trim() !== '';
  });
  var href = appendParameterString(browser_url, link_source);
  return Object(preact_min["h"])(
    'div',
    { 'class': 'wem__events-right wem__event wem__event-detail', 'data-mid': id },
    Object(preact_min["h"])(
      'button',
      { 'class': 'wem__event-detail__close', onClick: onClose },
      EventDetail__ref2
    ),
    Object(preact_min["h"])(
      'h4',
      { 'class': 'wem__event-detail__date' },
      is_virtual && EventDetail__ref3,
      helpers_timeString(timeslots)
    ),
    high_priority && EventDetail__ref4,
    Object(preact_min["h"])(
      'h2',
      { 'class': 'wem__event-detail__title' },
      cleanEntities(title)
    ),
    Object(preact_min["h"])(
      'strong',
      { 'class': 'wem__event-detail__meta' },
      helpers_eventMeta({ location: location, sponsor: sponsor })
    ),
    Object(preact_min["h"])(components_EventActions_EventActions, actions),
    featured_image_url ? Object(preact_min["h"])(
      'figure',
      { 'class': 'wem__event-detail__image' },
      Object(preact_min["h"])('img', { src: featured_image_url })
    ) : EventDetail__ref5,
    location && (full_address || postal_code) && Object(preact_min["h"])(
      'div',
      { 'class': 'wem__event-detail__content' },
      EventDetail__ref6,
      full_address && full_address !== maybeVenue && Object(preact_min["h"])(
        'div',
        null,
        full_address
      ),
      !full_address && Object(preact_min["h"])(
        'div',
        null,
        !!address.length && address.concat().join(', '),
        !!locality && !!region && !!postal_code && Object(preact_min["h"])(
          'div',
          null,
          locality,
          ', ',
          region,
          ' ',
          postal_code
        ) || postal_code
      )
    ),
    Object(preact_min["h"])(
      'div',
      { 'class': 'wem__event-detail__content' },
      EventDetail__ref7,
      Object(preact_min["h"])(
        'p',
        { 'class': 'wem__event-detail__paragraph' },
        cleanAndSplitString(description)
      ),
      location === null && !is_wp_item && Object(preact_min["h"])(
        'p',
        null,
        'This event\u2019s address is private. ',
        Object(preact_min["h"])(
          'a',
          { href: href, target: !is_wp_item ? "_blank" : null },
          'Sign up for more details.'
        )
      )
    )
  );
};

var _ref8 = Object(preact_min["h"])(Icons_CloseButton, null);

var EventDetail__ref9 = Object(preact_min["h"])('hr', null);

var EventDetail__ref10 = Object(preact_min["h"])(
  'h4',
  { 'class': 'wem__event-detail__headline' },
  'Where'
);

var _ref11 = Object(preact_min["h"])(
  'h4',
  { 'class': 'wem__event-detail__headline' },
  'Details'
);

var EventDetail_POIDetail = function POIDetail(props) {
  var base_path = props.base_path,
      browser_url = props.browser_url,
      description = props.description,
      location = props.location,
      _props$sponsor = props.sponsor,
      sponsor = _props$sponsor === undefined ? '' : _props$sponsor,
      title = props.title,
      onClose = props.onClose,
      office_phone_number = props.office_phone_number,
      excerpt = props.excerpt,
      featured_image_url = props.featured_image_url,
      _props$location = props.location,
      _props$location$full_ = _props$location.full_address,
      full_address = _props$location$full_ === undefined ? '' : _props$location$full_,
      _props$location$addre = _props$location.address_lines,
      address_lines = _props$location$addre === undefined ? [] : _props$location$addre;
  var _props$location2 = props.location,
      locality = _props$location2.locality,
      region = _props$location2.region,
      postal_code = _props$location2.postal_code;

  var actions = EventDetail__extends({}, props, {
    nosocial: true,
    isDetailCard: true
  });
  var address = address_lines.filter(function (a) {
    return a.trim() !== '';
  });

  return Object(preact_min["h"])(
    'div',
    { 'class': 'wem__events-right wem__event wem__event-detail' },
    Object(preact_min["h"])(
      'button',
      { 'class': 'wem__event-detail__close', onClick: onClose },
      _ref8
    ),
    Object(preact_min["h"])(
      'h2',
      { 'class': 'wem__event-detail__title' },
      title
    ),
    excerpt && Object(preact_min["h"])(
      'p',
      null,
      excerpt
    ),
    featured_image_url ? Object(preact_min["h"])(
      'figure',
      { 'class': 'wem__event-detail__image' },
      Object(preact_min["h"])('img', { src: featured_image_url })
    ) : EventDetail__ref9,
    Object(preact_min["h"])(
      'div',
      { 'class': 'wem__event-detail__content' },
      EventDetail__ref10,
      sponsor && sponsor.candidate_name.length > 0 && false && [Object(preact_min["h"])(
        'p',
        { 'class': 'wem__event-detail__paragraph' },
        sponsor.candidate_name
      )],
      full_address || Object(preact_min["h"])(
        'span',
        null,
        address.join(', '),
        locality && region && postal_code && Object(preact_min["h"])(
          'div',
          null,
          location.locality,
          ', ',
          location.region,
          ' ',
          location.postal_code
        )
      ),
      office_phone_number && Object(preact_min["h"])(
        'div',
        { 'class': 'wem__event-detail__phone' },
        office_phone_number
      )
    ),
    Object(preact_min["h"])(
      'div',
      { 'class': 'wem__event-detail__content' },
      _ref11,
      Object(preact_min["h"])('div', { 'class': 'wem__event-detail__paragraph', dangerouslySetInnerHTML: { __html: description } })
    )
  );
};

var _ref12 = Object(preact_min["h"])(
  'div',
  { 'class': 'wem__events-right wem__event-detail' },
  Object(preact_min["h"])(components_Loader, null)
);

var EventDetail_ItemDetail = function (_Component) {
  EventDetail__inherits(ItemDetail, _Component);

  function ItemDetail() {
    var _temp, _this, _ret;

    EventDetail__classCallCheck(this, ItemDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = EventDetail__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { event: null }, _this.onClose = function (e) {
      var _this$props = _this.props,
          base_path = _this$props.base_path,
          setEvent = _this$props.setEvent;

      setEvent();
      route("");
      scrollToWidgetTop();
    }, _temp), EventDetail__possibleConstructorReturn(_this, _ret);
  }

  ItemDetail.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        apiUrl = _props.apiUrl,
        id = _props.id,
        base_path = _props.base_path,
        setEvent = _props.setEvent,
        api_static = _props.api_static,
        events = _props.events,
        extra_map_features = _props.extra_map_features;

    // const endpoint = id.indexOf('event')>-1 ?
    //   `${apiUrl}/we-mobilize/v2/wp-event/?post_id=${String(id).replace('event-','')}` :
    //   `${apiUrl}/we-mobilize/v2/event/?post_id=${id}`;

    var hasEvent = events && events.length && events.find(function (event) {
      return event.id === id && event.location;
    });
    var hasPoi = extra_map_features && extra_map_features.length && extra_map_features.find(function (poi) {
      return String(poi.post_id) === String(id);
    });

    console.log({ extra_map_features: extra_map_features, id: id, hasPoi: hasPoi, hasEvent: hasEvent });

    if (hasEvent || hasPoi) {
      console.log('pre-loaded event');
      this.setState({ event: hasEvent || hasPoi });
      setEvent(hasEvent || hasPoi);
      connectAddThis();
    } else {

      var endpoint = api_static ? api_static + '/events/' + id + '.json' : apiUrl + '/we-mobilize/v2/event/?post_id=' + id;
      //console.log('event detail',{endpoint, id});
      axios_default.a.get(endpoint).then(function (response) {
        _this2.setState({ event: response.data });
        setEvent(response.data);
        connectAddThis();
      }).catch(function (error) {
        console.error(error);
        setEvent();
        route("");
        scrollToWidgetTop();
      });
    }

    scrollToWidgetTop();
  };

  ItemDetail.prototype.render = function render(props, state) {
    var base_path = props.base_path;


    if (state.event) {
      var is_poi = state.event.is_poi;


      var mergeProps = EventDetail__extends({}, state.event, {
        base_path: base_path,
        onClose: this.onClose.bind(this)
      });

      return is_poi ? Object(preact_min["h"])(EventDetail_POIDetail, mergeProps) : Object(preact_min["h"])(EventDetail_EventDetail, mergeProps);
    } else {
      return _ref12;
    }
  };

  return ItemDetail;
}(preact_min["Component"]);

/* harmony default export */ var components_EventDetail = (EventDetail_ItemDetail);
// CONCATENATED MODULE: ./components/SearchBar/index.js



function SearchBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SearchBar_threshold = 5000; //120;

var initialZip = gup('zip').replace(/\D/g, '');

function isValidUSZip(sZip) {
  return (/^\d{5}(-\d{4})?$/.test(sZip)
  );
}

var SearchBar_SearchBar = function (_Component) {
  SearchBar__inherits(SearchBar, _Component);

  function SearchBar() {
    var _temp, _this, _ret;

    SearchBar__classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SearchBar__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      inputValue: '',
      error: '',
      currentSearch: ''
    }, _this.onInput = function (e) {
      var _this$props = _this.props,
          setFilter = _this$props.setFilter,
          isMobileSearch = _this$props.isMobileSearch;
      var _this$state$inputValu = _this.state.inputValue,
          oldInputState = _this$state$inputValu === undefined ? '' : _this$state$inputValu;

      var inputValue = e.target.value;
      _this.setState({
        inputValue: inputValue,
        error: '',
        currentSearch: inputValue ? _this.state.currentSearch : ''
      });
      if (inputValue === "") {
        _this.props.toggleFilter(false);
        setFilter({ fromOrigin: false });
      } else if (inputValue && oldInputState.length != 5 && inputValue.length === 5 && isValidUSZip(inputValue)) {
        setTimeout(function () {
          _this.props.toggleFilter(true);
          _this.onSubmit();
        }, 200);
      }
    }, _this.onSubmit = function (e) {
      var _this$props2 = _this.props,
          toggleFilter = _this$props2.toggleFilter,
          setFilter = _this$props2.setFilter;


      if (e) {
        e.preventDefault();
      }
      //needs to move to the filters
      if (window.google) {
        var geocoder = new google.maps.Geocoder();
        var _this$props3 = _this.props,
            events = _this$props3.events,
            setEvents = _this$props3.setEvents,
            setEvent = _this$props3.setEvent,
            base_path = _this$props3.base_path;
        var inputValue = _this.state.inputValue;


        if (inputValue.length > 0) {
          geocoder.geocode({ address: 'ZipCode ' + inputValue + ', USA', region: 'US' }, function (results, status) {
            console.log('zip search: ', { results: results });
            if (status === 'OK' && results.length > 0) {
              var _results$0$geometry$l = results[0].geometry.location,
                  lat = _results$0$geometry$l.lat,
                  lng = _results$0$geometry$l.lng;

              var origin = { latitude: lat(), longitude: lng() };
              console.log('new origin', { origin: origin });

              var filteredEvents = events.reduce(function (acc, event) {
                var longitude = event.longitude,
                    latitude = event.latitude;

                var location = latitude && longitude && { longitude: longitude, latitude: latitude } || event && event.location && event.location.location;
                if (!location) {
                  return acc;
                }
                var distanceFromSearch = haversine_default()(origin, location, {
                  unit: 'mile'
                });
                event.distanceFromSearch = distanceFromSearch;
                if (distanceFromSearch < SearchBar_threshold) {
                  acc.push(event);
                }
                return acc;
              }, []).sort(function (a, b) {
                return a.distanceFromSearch - b.distanceFromSearch;
              });

              route("");
              setEvent();
              toggleFilter(true);
              setFilter({ fromOrigin: inputValue });
              setEvents(filteredEvents);
              _this.setState({
                currentSearch: inputValue
              });
            } else {
              if (status) {
                _this.setState({ error: 'No results found' });
              }
              console.error('Geocoding failed w/ ' + status);
            }
          });
        } else {
          setEvents(events);
          toggleFilter(false);
        }
      }
    }, _temp), SearchBar__possibleConstructorReturn(_this, _ret);
  }

  // componentDidMount() {
  //   if(gup('zip')){
  //     this.setState({
  //       inputValue: initialZip,
  //       error: ''
  //     });
  //     this.onSubmit();
  //     this.props.toggleFilter(true);
  //   }
  // }

  SearchBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var _this2 = this;

    var _props = this.props,
        started = _props.started,
        toggleFilter = _props.toggleFilter;
    var inputValue = this.state.inputValue;
    //console.log('sb',{started, nextStarted: nextProps.started})

    if (!started && nextProps.started && initialZip) {
      //console.log('initial zip', initialZip);
      this.setState({
        currentSearch: initialZip,
        inputValue: initialZip
      });
      setTimeout(function () {
        _this2.props.toggleFilter(true);
        _this2.onSubmit();
      }, 1600);
    }
    //console.log(nextState.inputValue, {nextState});
  };

  // componentWillReceiveProps(nextProps, {inputValue=""}){
  //   console.log(inputValue, this.state.inputValue);
  //   if(this.state.inputValue!==inputValue && !inputValue){
  //     this.props.toggleFilter(false);
  //   }
  // }

  SearchBar.prototype.render = function render(props, state) {
    var error = state.error,
        inputValue = state.inputValue,
        currentSearch = state.currentSearch;
    var _props2 = this.props,
        style = _props2.style,
        _props2$classNames = _props2.classNames,
        classNames = _props2$classNames === undefined ? '' : _props2$classNames,
        started = _props2.started;


    var searchClass = classnames("wem__search-bar", classNames);
    var buttonClass = classnames("wem__search-bar__icon fa fas fa-search", { '--active': inputValue && inputValue !== currentSearch });

    return Object(preact_min["h"])(
      'form',
      { 'class': searchClass, onSubmit: this.onSubmit, style: style },
      Object(preact_min["h"])('button', { type: 'submit', 'class': buttonClass }),
      Object(preact_min["h"])('input', {
        'class': 'wem__search-bar__input',
        type: 'search',
        placeholder: 'Search by zip code...',
        value: inputValue,
        onInput: this.onInput,
        readonly: !started
      }),
      error && Object(preact_min["h"])(
        'span',
        { 'class': 'wem__search-bar--error' },
        error
      )
    );
  };

  return SearchBar;
}(preact_min["Component"]);

/* harmony default export */ var components_SearchBar = (SearchBar_SearchBar);
// CONCATENATED MODULE: ./components/EventFilters/index.js



function EventFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var EventFilters_threshold = 500;

var EventFilters__ref = Object(preact_min["h"])(
  'label',
  { htmlFor: 'wem-em-category' },
  'Event Type'
);

var EventFilters__ref2 = Object(preact_min["h"])(
  'option',
  { value: '' },
  '(All)'
);

var EventFilters_CategoryFilter = function (_Component) {
  EventFilters__inherits(CategoryFilter, _Component);

  function CategoryFilter() {
    EventFilters__classCallCheck(this, CategoryFilter);

    return EventFilters__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CategoryFilter.prototype.onChange = function onChange(e) {
    e.preventDefault();
    var _props = this.props,
        events = _props.events,
        setEvents = _props.setEvents;
  };

  CategoryFilter.prototype.render = function render(props, state) {
    var categories = props.categories,
        selectedCategory = props.selectedCategory,
        style = props.style,
        setEvents = props.setEvents,
        events = props.events,
        setFilter = props.setFilter;

    if (!categories || !categories.length) {
      return null;
    }
    return Object(preact_min["h"])(
      'div',
      { 'class': 'wem__filter wem__filter--category-section', style: style },
      EventFilters__ref,
      Object(preact_min["h"])(
        'div',
        { 'class': 'wem__filter--category-field' },
        Object(preact_min["h"])(
          'select',
          { id: 'wem-em-category', onChange: function onChange(e) {
              return setFilter({ byCategory: e.target.value || false });
            } },
          EventFilters__ref2,
          categories.map(function (_ref3) {
            var slug = _ref3.slug,
                name = _ref3.name;
            return Object(preact_min["h"])(
              'option',
              { selected: selectedCategory === slug, value: slug },
              name
            );
          })
        )
      )
    );
  };

  return CategoryFilter;
}(preact_min["Component"]);

var today = new Date().toISOString().substring(0, 10);

var EventFilters__ref4 = Object(preact_min["h"])(
  'label',
  { htmlFor: 'wem-em-date' },
  'Date'
);

var EventFilters_DateFilter = function (_Component2) {
  EventFilters__inherits(DateFilter, _Component2);

  function DateFilter() {
    EventFilters__classCallCheck(this, DateFilter);

    return EventFilters__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  DateFilter.prototype.render = function render(props, state) {
    var style = props.style,
        setFilter = props.setFilter,
        selectedDate = props.selectedDate;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'wem__filter wem__filter--date-section', style: style },
      EventFilters__ref4,
      Object(preact_min["h"])(
        'div',
        { 'class': 'wem__filter--date-field' },
        Object(preact_min["h"])('input', { id: 'wem-em-date', type: 'date', onChange: function onChange(e) {
            return setFilter({ fromDay: e.target.value || false });
          }, min: today })
      )
    );
  };

  return DateFilter;
}(preact_min["Component"]);

var vfStyle = {
  width: 'auto',
  marginTop: '10px',
  position: 'relative'
};

var EventFilters__ref5 = Object(preact_min["h"])(
  'span',
  { 'class': 'virtual-label__small' },
  'Virtual?'
);

var EventFilters_IncludeVirtualFilter = function (_Component3) {
  EventFilters__inherits(IncludeVirtualFilter, _Component3);

  function IncludeVirtualFilter() {
    EventFilters__classCallCheck(this, IncludeVirtualFilter);

    return EventFilters__possibleConstructorReturn(this, _Component3.apply(this, arguments));
  }

  IncludeVirtualFilter.prototype.render = function render(props, state) {
    var style = props.style,
        setFilter = props.setFilter,
        _props$virtualOnly = props.virtualOnly,
        virtualOnly = _props$virtualOnly === undefined ? false : _props$virtualOnly;

    return Object(preact_min["h"])(
      'label',
      { htmlFor: 'wem-virtual', 'class': 'virtual-toggle ' + (virtualOnly ? 'checked' : 'unchecked'), style: vfStyle },
      Object(preact_min["h"])(
        'span',
        { 'class': 'virtual-label__large', style: { textTransform: 'none', paddingRight: '10px' } },
        'Include Virtual Events?'
      ),
      EventFilters__ref5,
      Object(preact_min["h"])('input', { title: 'Include Virtual Events?', id: 'wem-virtual', checked: virtualOnly, type: 'checkbox', onChange: function onChange(e) {
          return setFilter({ virtualOnly: !virtualOnly });
        } })
    );
  };

  return IncludeVirtualFilter;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/VirtualList/index.js
var VirtualList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function VirtualList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VirtualList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VirtualList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var STYLE_INNER = 'position:relative; overflow:hidden; width:100%; min-height:100%;';

var STYLE_CONTENT = 'position:absolute; top:0; left:0; height:100%; width:100%; overflow:visible;';

/** Virtual list, renders only visible items.
 *  @param {Array<*>} data         List of data items
 *  @param {Function} renderRow    Renders a single row
 *  @param {Number} rowHeight      Static height of a row
 *  @param {Number} overscanCount  Amount of rows to render above and below visible area of the list
 *  @param {Boolean} [sync=false]  true forces synchronous rendering
 *  @example
 *    <VirtualList
 *      data={['a', 'b', 'c']}
 *      renderRow={ row => <div>{row}</div> }
 *      rowHeight={22}
 *      sync
 *    />
 */

var VirtualList_VirtualList = function (_Component) {
  VirtualList__inherits(VirtualList, _Component);

  function VirtualList() {
    var _temp, _this, _ret;

    VirtualList__classCallCheck(this, VirtualList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = VirtualList__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.resize = function () {
      if (_this.state.height !== _this.base.offsetHeight) {
        _this.setState({ height: _this.base.offsetHeight });
      }
    }, _this.handleScroll = function () {
      _this.setState({ offset: _this.base.scrollTop });
      if (_this.props.sync) _this.forceUpdate();
    }, _temp), VirtualList__possibleConstructorReturn(_this, _ret);
  }

  VirtualList.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props = this.props,
        _props$updatePos = _props.updatePos,
        updatePos = _props$updatePos === undefined ? function () {} : _props$updatePos,
        rowHeight = _props.rowHeight,
        data = _props.data;
    var _state = this.state,
        height = _state.height,
        offset = _state.offset;

    this.resize();
    updatePos({ height: data.length * rowHeight, offset: offset });
    connectAddThis();
  };

  VirtualList.prototype.componentDidMount = function componentDidMount() {
    this.resize();
    addEventListener('resize', this.resize);
    console.log(this.props.data.length + ' rows listed');
    connectAddThis();
  };

  VirtualList.prototype.componentWillUnmount = function componentWillUnmount() {
    removeEventListener('resize', this.resize);
  };

  VirtualList.prototype.render = function render(_ref, _ref2) {
    var _ref2$offset = _ref2.offset,
        offset = _ref2$offset === undefined ? 0 : _ref2$offset,
        _ref2$height = _ref2.height,
        height = _ref2$height === undefined ? 0 : _ref2$height;

    var data = _ref.data,
        rowHeight = _ref.rowHeight,
        renderRow = _ref.renderRow,
        _ref$overscanCount = _ref.overscanCount,
        overscanCount = _ref$overscanCount === undefined ? 10 : _ref$overscanCount,
        sync = _ref.sync,
        updatePos = _ref.updatePos,
        props = _objectWithoutProperties(_ref, ['data', 'rowHeight', 'renderRow', 'overscanCount', 'sync', 'updatePos']);

    // first visible row index
    var start = offset / rowHeight | 0;

    // actual number of visible rows (without overscan)
    var visibleRowCount = height / rowHeight | 0;

    // Overscan: render blocks of rows modulo an overscan row count
    // This dramatically reduces DOM writes during scrolling
    if (overscanCount) {
      start = Math.max(0, start - start % overscanCount);
      visibleRowCount += overscanCount;
    }

    // last visible + overscan row index
    var end = start + 1 + visibleRowCount;

    // data slice currently in viewport plus overscan items
    var selection = data.slice(start, end);

    return Object(preact_min["h"])(
      'div',
      VirtualList__extends({ onScroll: this.handleScroll }, props),
      Object(preact_min["h"])(
        'div',
        { style: STYLE_INNER + ' height:' + data.length * rowHeight + 'px;' },
        Object(preact_min["h"])(
          'div',
          { style: STYLE_CONTENT + ' top:' + start * rowHeight + 'px;' },
          selection.map(renderRow)
        )
      )
    );
  };

  return VirtualList;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/EventsPanel/index.js



function EventsPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventsPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventsPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











//import VirtualList from 'preact-virtual-list';


var tall_card_height = 340;
var short_card_height = 290;

function throttle(fn) {
  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var scope = arguments[2];

  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}
var window_width = window.outerWidth;

var EventsPanel__ref2 = Object(preact_min["h"])(components_Loader, { style: 'margin-top: 150px;' });

var EventsPanel__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'wem__events-panel__scrollmore' },
  Object(preact_min["h"])(Icons_Caret, { strokewidth: '5' })
);

var EventsPanel_EventsPanel = function (_Component) {
  EventsPanel__inherits(EventsPanel, _Component);

  function EventsPanel() {
    EventsPanel__classCallCheck(this, EventsPanel);

    var _this = EventsPanel__possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      nearSticky: false, sticky: false, bottom: false, hasScrolled: false,
      topPos: 0, fullPanel: false, virtualHeight: '60%', itemHeight: window_width < 1300 && window_width > 1000 ? tall_card_height : short_card_height
    };

    _this.runOnScroll = throttle(_this.runOnScroll, 50, _this);
    _this.runOnVirtualScroll = throttle(_this.runOnVirtualScroll, 50, _this);
    _this.virtualResize = throttle(_this.virtualResize, 50, _this);
    _this.virtualResizeSlow = throttle(_this.virtualResize, 300, _this);
    return _this;
  }

  EventsPanel.prototype.runOnScroll = function runOnScroll(e) {
    var _state = this.state,
        sticky = _state.sticky,
        nearSticky = _state.nearSticky,
        bottom = _state.bottom,
        hasScrolled = _state.hasScrolled;
    var spacerTop = this._spacer.offsetTop;
    var _scroller = this._scroller,
        scrollTop = _scroller.scrollTop,
        scrollHeight = _scroller.scrollHeight;
    //console.log({hasScrolled, spacerTop, home: this._spacerHome, scrollTop, scrollHeight, offsetHeight: this._offsetHeight})

    if (!hasScrolled) {
      this.setState({ hasScrolled: true });
    }
    if (!sticky && this._spacerHome < spacerTop) {
      this.setState({ sticky: true });
    } else if (sticky && (this._spacerHome === spacerTop || scrollTop < this._spacerHome)) {
      this.setState({ sticky: false });
    }

    if (!nearSticky && this._spacerHome < scrollTop + 105) {
      this.setState({ nearSticky: true });
    } else if (nearSticky && this._spacerHome > scrollTop + 105) {
      this.setState({ nearSticky: false });
    }

    if (!bottom && scrollTop / scrollHeight > 0.9) {
      //scrollHeight < scrollTop + this._offsetHeight + 20){
      this.setState({ bottom: true });
    } else if (bottom && scrollTop / scrollHeight < 0.9) {
      //(scrollHeight > scrollTop + this._offsetHeight)){
      this.setState({ bottom: false });
    }
  };

  EventsPanel.prototype.runOnVirtualScroll = function runOnVirtualScroll(_ref) {
    var height = _ref.height,
        offset = _ref.offset;

    if (!this._scroller) {
      return false;
    }
    var _state2 = this.state,
        sticky = _state2.sticky,
        nearSticky = _state2.nearSticky,
        bottom = _state2.bottom,
        hasScrolled = _state2.hasScrolled;
    //const { offsetTop: spacerTop } = this._spacer;

    var _scroller2 = this._scroller,
        scrollTop = _scroller2.scrollTop,
        scrollHeight = _scroller2.scrollHeight;

    if (!hasScrolled && offset > 0) {
      this.setState({ hasScrolled: true });
    }
    if (!sticky && offset > scrollHeight) {
      this.setState({
        sticky: true,
        fullPanel: true
      });
    } else if (sticky && offset < scrollHeight) {
      this.setState({
        sticky: false,
        fullPanel: false
      });
    }

    if (!bottom && offset / height > 0.9) {
      //scrollHeight < scrollTop + this._offsetHeight + 20){
      this.setState({ bottom: true });
    } else if (bottom && offset / height < 0.9) {
      //(scrollHeight > scrollTop + this._offsetHeight)){
      this.setState({ bottom: false });
    }
    //connectAddThis();
    //this.virtualResizeSlow();
  };

  EventsPanel.prototype.virtualResize = function virtualResize() {
    var _this2 = this;

    var _state3 = this.state,
        sticky = _state3.sticky,
        nearSticky = _state3.nearSticky,
        bottom = _state3.bottom,
        hasScrolled = _state3.hasScrolled;
    var _window = window,
        outerWidth = _window.outerWidth;

    this.setState({
      virtualHeight: this._outerPanel.offsetHeight - this._scroller.offsetHeight,
      itemHeight: outerWidth < 1300 && outerWidth > 1000 ? tall_card_height : short_card_height
    });
    setTimeout(function () {
      _this2.setState({
        virtualHeight: _this2._outerPanel.offsetHeight - _this2._scroller.offsetHeight,
        itemHeight: outerWidth < 1300 && outerWidth > 1000 ? tall_card_height : short_card_height
      });
    }, 10);
    //console.log({oh: this._outerPanel.offsetHeight, sch: this._scroller.offsetHeight})
  };

  EventsPanel.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        isVirtual = _props.isVirtual,
        events = _props.events;
    var offsetTop = this._spacer.offsetTop;
    var _scroller3 = this._scroller,
        scrollHeight = _scroller3.scrollHeight,
        offsetHeight = _scroller3.offsetHeight;

    this._spacerHome = offsetTop;
    this._scrollHeight = scrollHeight;
    this._offsetHeight = offsetHeight;
    if (!isVirtual) {
      this._scroller.addEventListener("scroll", this.runOnScroll);
      connectAddThis();
    } else {
      this.timeout = setTimeout(this.virtualResize, 100);
      window.addEventListener("resize", this.virtualResize);
    }
    //console.log(`${events.length} events listed`,{isVirtual, spacerTop: offsetTop, home: this._spacerHome, div: this._scroller.offsetTop})
  };

  EventsPanel.prototype.componentWillUnmount = function componentWillUnmount() {
    var isVirtual = this.props.isVirtual;

    clearTimeout(this.timeout);
    if (!isVirtual) {
      this._scroller.removeEventListener("scroll", this.runOnScroll);
    } else {
      window.removeEventListener("resize", this.virtualResize);
    }
  };

  EventsPanel.prototype.render = function render(props, state) {
    var _this3 = this;

    var base_path = props.base_path,
        title = props.title,
        description = props.description,
        events = props.events,
        setEvent = props.setEvent,
        setEvents = props.setEvents,
        _props$categories = props.categories,
        categories = _props$categories === undefined ? [] : _props$categories,
        isVirtual = props.isVirtual,
        toggleFilter = props.toggleFilter,
        _props$virtualOnly = props.virtualOnly,
        virtualOnly = _props$virtualOnly === undefined ? false : _props$virtualOnly,
        setFilter = props.setFilter,
        isFiltered = props.isFiltered,
        isLoading = props.isLoading,
        no_events_message = props.no_events_message,
        _props$show_images = props.show_images,
        show_images = _props$show_images === undefined ? true : _props$show_images,
        link_source = props.link_source;
    var sticky = state.sticky,
        nearSticky = state.nearSticky,
        bottom = state.bottom,
        hasScrolled = state.hasScrolled,
        topPos = state.topPos,
        fullPanel = state.fullPanel,
        virtualHeight = state.virtualHeight,
        itemHeight = state.itemHeight;


    var panelClass = classnames("wem__events-right wem__events-panel", { '--at-bottom': bottom, 'wem__events-panel-virtual': isVirtual });
    var scrollableClass = classnames("wem__events-panel__scrollable", {
      '--sticky is-sticky': sticky,
      '--near-sticky': nearSticky,
      '--no-events': !isLoading && events.length === 0,
      '--no-description': !Boolean(description)
    });

    console.log(events.length, events.filter(function (x) {
      return x.is_virtual;
    }).length, events.filter(function (x) {
      return !x.is_virtual;
    }).length);

    var with_images = window.outerWidth > 767 && window.outerWidth < 1000 ? false : show_images;

    var virtualClass = classnames("wem__events-virtual-scroller", { "--is-full": fullPanel });

    return Object(preact_min["h"])(
      'div',
      { 'class': panelClass, 'data-events': events.length, ref: function ref(outerPanel) {
          return _this3._outerPanel = outerPanel;
        } },
      Object(preact_min["h"])(
        'div',
        { 'class': scrollableClass, ref: function ref(scroller) {
            return _this3._scroller = scroller;
          }, style: { top: topPos } },
        Object(preact_min["h"])(
          'div',
          { 'class': 'wem__events-panel__content' },
          Object(preact_min["h"])(
            'h1',
            { 'class': 'wem__events-panel__headline h3' },
            title
          ),
          description && Object(preact_min["h"])(
            'div',
            { 'class': 'wem__events-panel__description' },
            cleanEntities(description)
          ),
          Object(preact_min["h"])(components_SearchBar, { classNames: 'only-mobile', started: !isLoading, isMobileSearch: true, setFilter: setFilter, base_path: base_path, events: events, setEvents: setEvents, setEvent: setEvent, toggleFilter: toggleFilter })
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'wem_events-filters' },
          Object(preact_min["h"])(EventFilters_CategoryFilter, { categories: categories, setFilter: setFilter }),
          Object(preact_min["h"])(EventFilters_DateFilter, { setFilter: setFilter }),
          Object(preact_min["h"])(EventFilters_IncludeVirtualFilter, { virtualOnly: virtualOnly, setFilter: setFilter })
        ),
        Object(preact_min["h"])('div', { 'class': 'wem__events-panel__scroll-spacer', ref: function ref(spacer) {
            return _this3._spacer = spacer;
          } }),
        !isLoading && events.length > 0 && !isVirtual && events.map(function (event, i) {
          return Object(preact_min["h"])(components_EventCard, { link_source: link_source, show_images: show_images && (hasScrolled || i < 4), base_path: base_path, event: event, setEvent: setEvent });
        })
      ),
      isLoading && EventsPanel__ref2,
      !isLoading && isVirtual && events.length > 0 && Object(preact_min["h"])(VirtualList_VirtualList, { 'class': virtualClass, data: events, style: { height: virtualHeight }, updatePos: this.runOnVirtualScroll, rowHeight: itemHeight, renderRow: function renderRow(event) {
          return Object(preact_min["h"])(components_EventCard, { link_source: link_source, isVirtual: isVirtual, itemHeight: itemHeight, show_images: with_images, base_path: base_path, event: event, setEvent: setEvent });
        } }),
      !isLoading && events.length === 0 && (isFiltered ? Object(preact_min["h"])(
        'div',
        { 'class': 'wem__events-panel__noevents --isFiltered' },
        no_events_message,
        ' ',
        Object(preact_min["h"])(
          'button',
          { onClick: function onClick() {
              return setFilter({ clear: true });
            } },
          'Clear filters?'
        )
      ) : Object(preact_min["h"])(
        'div',
        { 'class': 'wem__events-panel__noevents' },
        no_events_message
      )),
      !isLoading && events.length > 0 && EventsPanel__ref3
    );
  };

  return EventsPanel;
}(preact_min["Component"]);

/* harmony default export */ var components_EventsPanel = (EventsPanel_EventsPanel);
// CONCATENATED MODULE: ./components/MapMarker/index.js



function MapMarker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MapMarker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MapMarker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MapMarker_MapMarker = function (_Component) {
  MapMarker__inherits(MapMarker, _Component);

  function MapMarker() {
    var _temp, _this, _ret;

    MapMarker__classCallCheck(this, MapMarker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MapMarker__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function () {
      var _this$props = _this.props,
          base_path = _this$props.base_path,
          id = _this$props.id,
          post_id = _this$props.post_id,
          is_wp_item = _this$props.is_wp_item,
          setThisEvent = _this$props.setThisEvent,
          title = _this$props.title,
          _this$props$type = _this$props.type,
          type = _this$props$type === undefined ? 'event' : _this$props$type;

      // Couldn't get routing to play nice with just the second route call. This
      // needs to be figured out down the road.

      var ev_id = post_id || id;

      var newroute = cleanUrl('/' + ev_id + '/' + slugify(title));
      route('/');
      setThisEvent();
      route(newroute);
      //console.log(newroute);
      scrollToWidgetTop();
    }, _temp), MapMarker__possibleConstructorReturn(_this, _ret);
  }

  MapMarker.prototype.render = function render(props) {
    var id = props.id,
        post_id = props.post_id,
        selectedEventId = props.selectedEventId,
        title = props.title,
        Icon = props.Icon,
        noshadow = props.noshadow;


    var ev_id = post_id || id;

    var className = classnames(Icon ? 'wem__events-map__icon' : 'wem__events-map__marker', {
      'is-active': selectedEventId === Number(ev_id),
      noshadow: noshadow
    });

    return Object(preact_min["h"])(
      'div',
      { id: 'marker-' + ev_id, title: title, 'class': className, onClick: this.onClick },
      Icon && Object(preact_min["h"])(Icon, null)
    );
  };

  return MapMarker;
}(preact_min["Component"]);

/* harmony default export */ var components_MapMarker = (MapMarker_MapMarker);
// EXTERNAL MODULE: ../node_modules/google-map-react/lib/index.js
var lib = __webpack_require__("7oLP");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../node_modules/google-map-react/utils/index.js
var utils = __webpack_require__("+olq");
var utils_default = /*#__PURE__*/__webpack_require__.n(utils);

// EXTERNAL MODULE: ../node_modules/points-cluster/lib/index.js
var points_cluster_lib = __webpack_require__("feDp");
var points_cluster_lib_default = /*#__PURE__*/__webpack_require__.n(points_cluster_lib);

// CONCATENATED MODULE: ./components/EventsMap/index.js
var _class, _temp2;

var EventsMap__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function EventsMap__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EventsMap__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EventsMap__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var maxZoom = 15;
var clusterRadius = 60;

// this function merges external props in with those
// that might need access to the maps prop Maps passes in
var createMapOptions = function createMapOptions(extraProps) {
  return function (maps) {
    return EventsMap__extends({
      fullscreenControl: false
      // panControl: false,
      // mapTypeControl: false,
      // scrollwheel: false,
      // styles: [{ stylers: [{ 'saturation': -100 }, { 'gamma': 0.8 }, { 'lightness': 4 }, { 'visibility': 'on' }] }]
    }, extraProps);
  };
};

var EventsMap__ref2 = Object(preact_min["h"])(components_Loader, null);

var EventsMap_EventsMap = (_temp2 = _class = function (_Component) {
  EventsMap__inherits(EventsMap, _Component);

  function EventsMap() {
    var _temp, _this, _ret;

    EventsMap__classCallCheck(this, EventsMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = EventsMap__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.el = null, _this.state = { apiReady: false }, _this.mapLoaded = function () {
      _this.setState({ apiReady: true });
    }, _this.getNewBounds = function (events) {

      var nw = { lat: null, lng: null };
      var se = { lat: null, lng: null };

      var _this$props = _this.props,
          isFiltered = _this$props.isFiltered,
          selectedEvent = _this$props.selectedEvent,
          _this$props$filters = _this$props.filters,
          filters = _this$props$filters === undefined ? {} : _this$props$filters;


      var slicedEvents = (isFiltered || selectedEvent) && !filters.fromOrigin ? events.slice(0, filters.byCategory ? 100 : 12) : filters.fromOrigin ? events.sort(function (a, b) {
        return a.distanceFromSearch - b.distanceFromSearch;
      }).slice(0, 9) : events;
      //const slicedEvents = (filters.fromOrigin || selectedEvent) ? events.slice(0, 12) : events;

      console.log('getting new bounds on ' + slicedEvents.length + ' events', EventsMap__extends({}, filters, { selectedEvent: selectedEvent }));

      slicedEvents.filter(function (x) {
        return x.latitude && x.longitude;
      }).forEach(function (event) {
        var rawlat = event.latitude,
            rawlng = event.longitude;


        var latitude = parseFloat(rawlat);
        var longitude = parseFloat(rawlng);

        nw.lat = null === nw.lat || latitude > nw.lat ? latitude : parseFloat(nw.lat);
        nw.lng = null === nw.lng || longitude < nw.lng ? longitude : parseFloat(nw.lng);
        se.lat = null === se.lat || latitude < se.lat ? latitude : parseFloat(se.lat);
        se.lng = null === se.lng || longitude > se.lng ? longitude : parseFloat(se.lng);
      });

      if (nw.lat !== null && nw.lat === se.lat) {
        //console.log('single event', { latitude: nw.lat, longitude: se.lng })
        return { center: { lat: nw.lat, lng: se.lng }, zoom: 11 };
      }

      if (events.length > 1 && null !== nw.lat && null !== _this.el) {
        var width = _this.el.clientWidth - 15;
        var height = _this.el.clientHeight - 15;
        //console.log('real bounds', { nw, se }, { width, height })
        return Object(utils["fitBounds"])({ nw: nw, se: se }, { width: width, height: height });
      } else {
        //console.log('default', { center: { lat: 40, lng: -80 }, zoom: 5 })
        return { center: { lat: 40, lng: -80 }, zoom: 5 };
      }
    }, _this.renderMarkers = function (events) {
      var _this$props2 = _this.props,
          base_path = _this$props2.base_path,
          selectedEvent = _this$props2.selectedEvent,
          setEvent = _this$props2.setEvent,
          filters = _this$props2.filters;

      var selectedEventId = selectedEvent ? selectedEvent.post_id || selectedEvent.id : null;
      var latlngmap = {};

      //console.log(`rendering ${events.filter(x=>x.latitude && x.longitude).length} map markers from ${events.length} events`)
      // console.log('sc',
      //   supercluster(events, {
      //       minZoom: min_zoom, // min zoom to generate clusters on
      //       maxZoom, // max zoom level to cluster the points on
      //       radius: clusterRadius, // cluster radius in pixels
      //   })
      // );

      return events.map(function (event) {
        var id = event.id,
            post_id = event.post_id,
            _event$is_wp_item = event.is_wp_item,
            is_wp_item = _event$is_wp_item === undefined ? false : _event$is_wp_item,
            title = event.title,
            is_poi = event.is_poi,
            latitude = event.latitude,
            longitude = event.longitude;

        var ll_key = 'll' + latitude + longitude;
        var noshadow = Boolean(latlngmap[ll_key]);
        latlngmap[ll_key] = true;
        var markerProps = {
          base_path: base_path,
          is_wp_item: is_wp_item,
          id: post_id || id,
          post_id: post_id,
          is_poi: is_poi,
          selectedEventId: selectedEventId,
          title: title,
          latitude: latitude,
          longitude: longitude,
          noshadow: noshadow,
          lat: latitude,
          lng: longitude,
          Icon: is_poi ? Icons_Star : undefined
        };
        return Object(preact_min["h"])(components_MapMarker, EventsMap__extends({
          setThisEvent: function setThisEvent() {
            return setEvent(event);
          }
        }, markerProps));
      });
    }, _temp), EventsMap__possibleConstructorReturn(_this, _ret);
  }
  /**
   * Given a list of events, calculate the northwest and southeast points of a
   * containing box.
   *
   * @param {Array<Object>} - events
   * @return {Object}
   */


  /**
   * Given a list of events, returns marker components for each event at their
   * specified coordinates.
   *
   * @param {Array<Object>} - events
   * @return {Array<MapMarker>}
   */


  EventsMap.prototype.render = function render(props) {
    var _this2 = this;

    var apiKey = props.apiKey,
        events = props.events,
        event = props.event,
        defcenter = props.defcenter,
        defzoom = props.defzoom,
        setEvent = props.setEvent,
        selectedEvent = props.selectedEvent,
        mapStyles = props.mapStyles,
        isLoading = props.isLoading,
        _props$extra_map_feat = props.extra_map_features,
        extra_map_features = _props$extra_map_feat === undefined ? [] : _props$extra_map_feat,
        default_bounds = props.default_bounds,
        isFiltered = props.isFiltered,
        filters = props.filters,
        default_zoom = props.default_zoom,
        min_zoom = props.min_zoom;


    var isDefault = !isFiltered && !selectedEvent;
    var isVirtualEvent = selectedEvent && !selectedEvent.latitude;

    var legitEvents = events.filter(function (event) {
      return event.latitude && event.longitude && (!filters.fromOrigin || !event.distanceFromSearch || event.distanceFromSearch < 320);
    });

    var boundsEvents = selectedEvent ? [selectedEvent] : extra_map_features && extra_map_features.length ? legitEvents.concat(extra_map_features) : legitEvents;

    var mapEvents = extra_map_features && extra_map_features.length ? legitEvents.concat(extra_map_features) : legitEvents;

    var width = this.el && this.el.clientWidth - 15 || 705;
    var height = this.el && this.el.clientHeight - 15 || 584;

    var _ref = (isDefault || isVirtualEvent) && default_bounds ? Object(utils["fitBounds"])(default_bounds, { width: width, height: height }) : boundsEvents.length ? this.getNewBounds(boundsEvents) : {},
        _ref$center = _ref.center,
        center = _ref$center === undefined ? { lat: 41.52269490543275, lng: -81.51461555554198 } : _ref$center,
        _ref$zoom = _ref.zoom,
        zoom = _ref$zoom === undefined ? 8 : _ref$zoom;

    var _mapOptions = {
      styles: mapStyles,
      minZoom: min_zoom
    };

    var mapOptions = createMapOptions(_mapOptions);

    // console.log({mapOptions: _mapOptions, center, zoom, min_zoom, fitBounds: fitBounds(default_bounds, { width, height })});

    return Object(preact_min["h"])(
      'div',
      { 'class': 'wem__events-map', ref: function ref(el) {
          return _this2.el = el;
        }, 'data-events': legitEvents.length, 'data-poi': extra_map_features.length },
      isLoading ? EventsMap__ref2 : Object(preact_min["h"])(
        lib_default.a,
        {
          bootstrapURLKeys: { key: apiKey },
          center: center,
          zoom: zoom || default_zoom,
          defaultCenter: defcenter,
          defaultZoom: defzoom,
          minZoom: min_zoom,
          onGoogleApiLoaded: this.mapLoaded,
          onChange: function onChange(e) {
            return console.log(e);
          },
          resetBoundsOnResize: true
          //layerTypes={['TransitLayer']}
          , yesIWantToUseGoogleMapApiInternals: true,
          options: mapOptions
        },
        !isVirtualEvent && this.renderMarkers(mapEvents)
      )
    );
  };

  return EventsMap;
}(preact_min["Component"]), _class.defaultProps = {
  defcenter: {
    lat: 40,
    lng: -80
  },
  defzoom: 11
}, _temp2);


/* harmony default export */ var components_EventsMap = (EventsMap_EventsMap);
// CONCATENATED MODULE: ./components/index.js









// EXTERNAL MODULE: ./style.scss
var style_0 = __webpack_require__("3mJm");
var style_default = /*#__PURE__*/__webpack_require__.n(style_0);

// CONCATENATED MODULE: ./App.js
var App__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function App__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function App__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function App__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var addDocumentClass = function addDocumentClass(className) {
  return document.documentElement.className = document.documentElement.className + (' ' + className);
};

if (navigator.userAgent.toLowerCase().indexOf('safari') !== -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1 && typeof window.ontouchstart === 'undefined') {
  addDocumentClass('is-safari');
}

var App__ref3 = Object(preact_min["h"])(components_Loader, { highZIndex: true });

var App_App = function (_Component) {
  App__inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    App__classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = App__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      events: [],
      filteredEvents: [],
      isLoading: false,
      isFiltered: false,
      selectedEvent: false,
      failed: false,
      filters: defaultFilters,
      started: false,
      static_mode: false,
      mapIsLoading: false,
      isAltTitle: false
    }, _this.setEvents = function (filteredEvents) {
      _this.setState({ filteredEvents: filteredEvents });
    }, _this.toggleFilter = function () {
      var isFiltered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({ isFiltered: isFiltered });
    }, _this.setEvent = function () {
      var selectedEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({ selectedEvent: selectedEvent });
    }, _this.setFilter = function () {
      var newFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state = _this.state,
          filters = _this$state.filters,
          events = _this$state.events;


      if (newFilter.clear) {
        _this.setState({
          filters: defaultFilters,
          filteredEvents: events,
          isFiltered: false
        });
        document.getElementById('wem-em-category').value = '';
        document.getElementById('wem-em-date').value = '';
      } else {

        var newFilters = App__extends({}, filters, newFilter);

        var filteredEvents = refilterEvents(events, newFilters);

        var isFiltered = Boolean(Object.keys(defaultFilters).find(function (key) {
          return newFilters[key];
        }));

        console.log('setting filters', { filters: filters, newFilters: newFilters }, filteredEvents.length + ' of ' + events.length);

        _this.setState({
          filters: newFilters,
          filteredEvents: filteredEvents,
          isFiltered: isFiltered
        });
      }
      setTimeout(function () {
        return document.querySelectorAll('.wem__events-panel__scrollable')[0].scrollTop = 0;
      }, 200);
    }, _temp), App__possibleConstructorReturn(_this, _ret);
  }

  App.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        api_url = _props.api_url,
        api_static = _props.api_static,
        endpoint = _props.endpoint,
        _props$alt_title = _props.alt_title,
        alt_title = _props$alt_title === undefined ? '' : _props$alt_title;


    var isStatic = Boolean(api_static);

    console.log('loading app ', { isStatic: isStatic, endpoint: endpoint });

    var api_source = isStatic ? api_static + '/map.json' : cleanUrl(api_url + '/' + endpoint + '/v2/long/');

    this.setState({
      isLoading: true,
      static_mode: Boolean(api_static),
      isAltTitle: alt_title && gup('alt_title')
    });
    axios_default.a.get(api_source).then(function (_ref) {
      var data = _ref.data;
      return data ? data : Promise.reject('No Data');
    }).then(function (data) {
      return data && data.length ? data : Promise.reject('No Events');
    }).then(function (data) {
      return data.sort(function (a, b) {
        return a.high_priority === b.high_priority ? a.first_day - b.first_day : a.high_priority ? -1 : 1;
      });
    }).then(function (data) {
      _this2.setState({
        events: data,
        filteredEvents: data,
        mapIsLoading: false,
        isLoading: isStatic
      });
      addDocumentClass('wem-is-active');
      if (isStatic) {
        var dynamicCategories = {};
        // axios
        //   .get(`${api_static}/some.json`)
        axios_default.a.get(api_static + '/all.json').then(function (_ref2) {
          var data = _ref2.data;
          return data ? data : Promise.reject('No Data');
        }).then(function (data) {
          return data && data.length ? data : Promise.reject('No Events');
        }).then(function (data) {
          return data.sort(function (a, b) {
            return a.first_day - b.first_day;
          });
        }).then(function (data) {
          var events = data.map(function (event) {
            if (!event.latitude && event.location && event.location.location) {
              event.latitude = event.location.location.latitude;
              event.longitude = event.location.location.longitude;
            }
            if (event.event_type && !dynamicCategories[event.event_type]) {
              dynamicCategories[event.event_type] = event.event_type;
            }
            return event;
          });
          _this2.setState({
            started: true,
            events: events,
            filteredEvents: events,
            dynamicCategories: Object.keys(dynamicCategories)
          });
          setTimeout(function () {
            return _this2.setState({ isLoading: false });
          }, 100);
        });
      }
      setTimeout(function () {
        return _this2.setState({ started: true });
      }, 100);
    }).catch(function (error) {
      addDocumentClass('wem-has-failed');
      _this2.setState({
        started: true,
        failed: error,
        isLoading: false,
        mapIsLoading: false
      });
    });
  };

  App.prototype.render = function render(props) {
    var _props2 = this.props,
        api_key = _props2.api_key,
        api_url = _props2.api_url,
        base_path = _props2.base_path,
        title = _props2.title,
        _props2$alt_title = _props2.alt_title,
        alt_title = _props2$alt_title === undefined ? '' : _props2$alt_title,
        description = _props2.description,
        _props2$categories = _props2.categories,
        categories = _props2$categories === undefined ? [] : _props2$categories,
        _props2$mapStyles = _props2.mapStyles,
        mapStyles = _props2$mapStyles === undefined ? [] : _props2$mapStyles,
        default_bounds = _props2.default_bounds,
        _props2$show_images = _props2.show_images,
        show_images = _props2$show_images === undefined ? true : _props2$show_images,
        _props2$link_source = _props2.link_source,
        link_source = _props2$link_source === undefined ? '' : _props2$link_source,
        virtual_scroll = _props2.virtual_scroll,
        _props2$default_zoom = _props2.default_zoom,
        default_zoom = _props2$default_zoom === undefined ? 8 : _props2$default_zoom,
        _props2$min_zoom = _props2.min_zoom,
        min_zoom = _props2$min_zoom === undefined ? 4 : _props2$min_zoom,
        _props2$no_events_mes = _props2.no_events_message,
        no_events_message = _props2$no_events_mes === undefined ? "Sorry, no upcoming events at this time." : _props2$no_events_mes,
        extra_map_features = _props2.extra_map_features,
        api_static = _props2.api_static;
    var _state = this.state,
        events = _state.events,
        filteredEvents = _state.filteredEvents,
        isFiltered = _state.isFiltered,
        isLoading = _state.isLoading,
        mapIsLoading = _state.mapIsLoading,
        selectedEvent = _state.selectedEvent,
        isAltTitle = _state.isAltTitle,
        filters = _state.filters,
        started = _state.started,
        failed = _state.failed,
        static_mode = _state.static_mode,
        _state$dynamicCategor = _state.dynamicCategories,
        dynamicCategories = _state$dynamicCategor === undefined ? [] : _state$dynamicCategor;


    var categoryOptions = (dynamicCategories.length ? dynamicCategories : categories).map(function (cat) {
      return { slug: cat.toUpperCase(), name: sanitizeCategory(cat) };
    });

    var isVirtual = Boolean(api_static) || Boolean(virtual_scroll);

    var className = classnames('wem', {
      '--init': started,
      '--ready': started && !isLoading,
      '--no-events': started && !events.length,
      '--failed': Boolean(failed)
    });

    console.log({ isLoading: isLoading, started: started, events: events.length, filters: filters, default_bounds: default_bounds });

    return Object(preact_min["h"])(
      'div',
      { 'class': className },
      !started && App__ref3,
      Object(preact_min["h"])(
        'div',
        { 'class': 'wem__map-container' },
        Object(preact_min["h"])(components_SearchBar, { classNames: 'only-desktop', started: started, base_path: base_path, setFilter: this.setFilter, events: events, setEvents: this.setEvents, setEvent: this.setEvent, toggleFilter: this.toggleFilter }),
        Object(preact_min["h"])(components_EventsMap, {
          base_path: base_path,
          apiKey: api_key,
          events: filteredEvents,
          isFiltered: isFiltered,
          selectedEvent: selectedEvent,
          setEvent: this.setEvent,
          mapStyles: mapStyles,
          setFilter: this.setFilter,
          filters: filters,
          extra_map_features: extra_map_features,
          isLoading: mapIsLoading,
          default_bounds: default_bounds,
          default_zoom: default_zoom,
          min_zoom: min_zoom
        })
      ),
      Object(preact_min["h"])(
        preact_router_es,
        { history: createHashHistory_default()() },
        Object(preact_min["h"])(components_EventsPanel, {
          path: '/',
          title: isAltTitle ? alt_title : title,
          description: description,
          events: filteredEvents,
          setEvent: this.setEvent,
          categories: categoryOptions,
          setEvents: this.setEvents,
          toggleFilter: this.toggleFilter,
          setFilter: this.setFilter,
          isFiltered: isFiltered,
          isLoading: isLoading,
          virtualOnly: filters.virtualOnly,
          no_events_message: no_events_message,
          show_images: show_images,
          isVirtual: isVirtual,
          link_source: sanitizeParameterString(link_source)
        }),
        Object(preact_min["h"])(components_EventDetail, {
          path: '/:id/:slug',
          apiUrl: api_url,
          events: events,
          api_static: api_static,
          setEvent: this.setEvent,
          show_images: show_images,
          link_source: sanitizeParameterString(link_source),
          extra_map_features: extra_map_features
        })
      )
    );
  };

  return App;
}(preact_min["Component"]);

/* harmony default export */ var App_0 = (App_App);
// CONCATENATED MODULE: ./index.js
var poly = __webpack_require__("m+Gh");





var _habitat = preact_habitat_es(App_0);

_habitat.render({
  selector: '[data-widget-host="we-mobilize"]',
  clean: true
});

/***/ }),

/***/ "K2XS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _wrap2 = __webpack_require__("uWKE");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var LatLng = function () {
  function LatLng(lat, lng) {
    _classCallCheck(this, LatLng);

    if (isNaN(lat) || isNaN(lng)) {
      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
    }
    this.lat = +lat;
    this.lng = +lng;
  }

  LatLng.prototype.wrap = function wrap() {
    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
  };

  return LatLng;
}();

LatLng.convert = function (a) {
  if (a instanceof LatLng) {
    return a;
  }

  if (Array.isArray(a)) {
    return new LatLng(a[0], a[1]);
  }

  if ('lng' in a && 'lat' in a) {
    return new LatLng(a.lat, a.lng);
  }

  return a;
};

exports.default = LatLng;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KRuG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var settle = __webpack_require__("aS8y");
var buildURL = __webpack_require__("H6Qo");
var parseHeaders = __webpack_require__("ZeD7");
var isURLSameOrigin = __webpack_require__("/w7L");
var createError = __webpack_require__("3bIi");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("dn2M");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "LCnx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__("YJJm");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

/***/ }),

/***/ "LcGr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = isNumber;
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

var objectToString = Object.prototype.toString;

function isNumber(value) {
  var numberTag = '[object Number]';
  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
}

/***/ }),

/***/ "LeeW":
/***/ (function(module, exports) {

function buildDistanceInWordsLocale() {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  function localize(token, count, options) {
    options = options || {};

    var result;
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }

    return result;
  }

  return {
    localize: localize
  };
}

module.exports = buildDistanceInWordsLocale;

/***/ }),

/***/ "M8l6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "MoY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}

/***/ }),

/***/ "N6L2":
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__("LeeW");
var buildFormatLocale = __webpack_require__("b/WI");

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
};

/***/ }),

/***/ "Os0n":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else this[name] = definition();
})('$script', function () {
  var doc = document,
      head = doc.getElementsByTagName('head')[0],
      s = 'string',
      f = false,
      push = 'push',
      readyState = 'readyState',
      onreadystatechange = 'onreadystatechange',
      list = {},
      ids = {},
      delay = {},
      scripts = {},
      scriptpath,
      urlArgs;

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) {
      if (!fn(ar[i])) return f;
    }return 1;
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el);
      return 1;
    });
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths];
    var idOrDoneIsDone = idOrDone && idOrDone.call,
        done = idOrDoneIsDone ? idOrDone : optDone,
        id = idOrDoneIsDone ? paths.join('') : idOrDone,
        queue = paths.length;
    function loopFn(item) {
      return item.call ? item() : list[item];
    }
    function callback() {
      if (! --queue) {
        list[id] = 1;
        done && done();
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback();

        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = path.indexOf('.js') === -1 ? scriptpath + path + '.js' : scriptpath + path;
        }

        if (scripts[path]) {
          if (id) ids[id] = 1;
          return scripts[path] == 2 ? callback() : setTimeout(function () {
            loading(path, true);
          }, 0);
        }

        scripts[path] = 1;
        if (id) ids[id] = 1;
        create(path, callback);
      });
    }, 0);
    return $script;
  }

  function create(path, fn) {
    var el = doc.createElement('script'),
        loaded;
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if (el[readyState] && !/^c|loade/.test(el[readyState]) || loaded) return;
      el.onload = el[onreadystatechange] = null;
      loaded = 1;
      scripts[path] = 2;
      fn();
    };
    el.async = 1;
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild);
  }

  $script.get = create;

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift();
      !scripts.length ? $script(s, id, done) : $script(s, callback);
    })();
  };

  $script.path = function (p) {
    scriptpath = p;
  };
  $script.urlArgs = function (str) {
    urlArgs = str;
  };
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps];
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {
      return list[dep];
    }) ? ready() : !function (key) {
      delay[key] = delay[key] || [];
      delay[key][push](ready);
      req && req(missing);
    }(deps.join('|'));
    return $script;
  };

  $script.done = function (idOrDone) {
    $script([null], idOrDone);
  };

  return $script;
});

/***/ }),

/***/ "OvAf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("BXyq");
var utils = __webpack_require__("S1cf");
var InterceptorManager = __webpack_require__("rj2i");
var dispatchRequest = __webpack_require__("uz6X");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, { method: 'get' }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "Rrov":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("bGge");

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  return startOfWeek(dirtyDate, { weekStartsOn: 1 });
}

module.exports = startOfISOWeek;

/***/ }),

/***/ "RzPU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function printWarning() {};

if (false) {
  printWarning = function printWarning(format, subs) {
    var index = 0;
    var message = 'Warning: ' + (subs.length > 0 ? format.replace(/%s/g, function () {
      return subs[index++];
    }) : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function (member) {
  printWarning('Please use `require("history").%s` instead of `require("history/%s")`. ' + 'Support for the latter will be removed in the next major release.', [member, member]);
};

/***/ }),

/***/ "S1cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("ED/T");
var isBuffer = __webpack_require__("p/oJ");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "SInJ":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  var cleanDate = parse(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = startOfYear;

/***/ }),

/***/ "TKCF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var BASE_URL = 'https://maps';
var DEFAULT_URL = BASE_URL + '.googleapis.com';
var API_PATH = '/maps/api/js?callback=_$_google_map_initialize_$_';

var $script_ = null;

var loadPromise_ = void 0;

var resolveCustomPromise_ = void 0;

var _customPromise = new Promise(function (resolve) {
  resolveCustomPromise_ = resolve;
});

// TODO add libraries language and other map options

exports.default = function (bootstrapURLKeys, heatmapLibrary) {
  if (!$script_) {
    $script_ = __webpack_require__("Os0n"); // eslint-disable-line
  }

  // call from outside google-map-react
  // will be as soon as loadPromise_ resolved
  if (!bootstrapURLKeys) {
    return _customPromise;
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = function () {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };

    if (false) {
      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
        var message = '"callback" key in bootstrapURLKeys is not allowed,\n                          use onGoogleApiLoaded property instead';
        // eslint-disable-next-line no-console
        console.error(message);
        throw new Error(message);
      }
    }

    var params = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
      return r + '&' + key + '=' + bootstrapURLKeys[key];
    }, '');

    var libraries = heatmapLibrary ? '&libraries=visualization' : '';

    $script_('' + DEFAULT_URL + API_PATH + params + libraries, function () {
      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
    });
  });

  resolveCustomPromise_(loadPromise_);

  return loadPromise_;
};

/***/ }),

/***/ "UAZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),

/***/ "UJ0C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("sdYq");
} else {
  module.exports = require('./cjs/history.js');
}

/***/ }),

/***/ "UJg9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}

/***/ }),

/***/ "UV3R":
/***/ (function(module, exports) {

var commonFormatterKeys = ['M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd', 'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG', 'H', 'HH', 'h', 'hh', 'm', 'mm', 's', 'ss', 'S', 'SS', 'SSS', 'Z', 'ZZ', 'X', 'x'];

function buildFormattingTokensRegExp(formatters) {
  var formatterKeys = [];
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key);
    }
  }

  var formattingTokens = commonFormatterKeys.concat(formatterKeys).sort().reverse();
  var formattingTokensRegExp = new RegExp('(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g');

  return formattingTokensRegExp;
}

module.exports = buildFormattingTokensRegExp;

/***/ }),

/***/ "V3+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "VS7n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = window.fetch || (window.fetch = __webpack_require__("QAmr").default || __webpack_require__("QAmr"));

/***/ }),

/***/ "Vvjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(_extends({}, a, b)).every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),

/***/ "Vy4H":
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__("5S8c");
var getISOWeek = __webpack_require__("eL1o");
var getISOYear = __webpack_require__("7L22");
var parse = __webpack_require__("ajCz");
var isValid = __webpack_require__("x3VB");
var enLocale = __webpack_require__("N6L2");

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var options = dirtyOptions || {};

  var locale = options.locale;
  var localeFormatters = enLocale.format.formatters;
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp;
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters;

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp;
    }
  }

  var date = parse(dirtyDate);

  if (!isValid(date)) {
    return 'Invalid Date';
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

  return formatFn(date);
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function M(date) {
    return date.getMonth() + 1;
  },

  // Month: 01, 02, ..., 12
  'MM': function MM(date) {
    return addLeadingZeros(date.getMonth() + 1, 2);
  },

  // Quarter: 1, 2, 3, 4
  'Q': function Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },

  // Day of month: 1, 2, ..., 31
  'D': function D(date) {
    return date.getDate();
  },

  // Day of month: 01, 02, ..., 31
  'DD': function DD(date) {
    return addLeadingZeros(date.getDate(), 2);
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function DDD(date) {
    return getDayOfYear(date);
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function DDDD(date) {
    return addLeadingZeros(getDayOfYear(date), 3);
  },

  // Day of week: 0, 1, ..., 6
  'd': function d(date) {
    return date.getDay();
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function E(date) {
    return date.getDay() || 7;
  },

  // ISO week: 1, 2, ..., 53
  'W': function W(date) {
    return getISOWeek(date);
  },

  // ISO week: 01, 02, ..., 53
  'WW': function WW(date) {
    return addLeadingZeros(getISOWeek(date), 2);
  },

  // Year: 00, 01, ..., 99
  'YY': function YY(date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2);
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function YYYY(date) {
    return addLeadingZeros(date.getFullYear(), 4);
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function GG(date) {
    return String(getISOYear(date)).substr(2);
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function GGGG(date) {
    return getISOYear(date);
  },

  // Hour: 0, 1, ... 23
  'H': function H(date) {
    return date.getHours();
  },

  // Hour: 00, 01, ..., 23
  'HH': function HH(date) {
    return addLeadingZeros(date.getHours(), 2);
  },

  // Hour: 1, 2, ..., 12
  'h': function h(date) {
    var hours = date.getHours();
    if (hours === 0) {
      return 12;
    } else if (hours > 12) {
      return hours % 12;
    } else {
      return hours;
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function hh(date) {
    return addLeadingZeros(formatters['h'](date), 2);
  },

  // Minute: 0, 1, ..., 59
  'm': function m(date) {
    return date.getMinutes();
  },

  // Minute: 00, 01, ..., 59
  'mm': function mm(date) {
    return addLeadingZeros(date.getMinutes(), 2);
  },

  // Second: 0, 1, ..., 59
  's': function s(date) {
    return date.getSeconds();
  },

  // Second: 00, 01, ..., 59
  'ss': function ss(date) {
    return addLeadingZeros(date.getSeconds(), 2);
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function SS(date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2);
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function SSS(date) {
    return addLeadingZeros(date.getMilliseconds(), 3);
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function Z(date) {
    return formatTimezone(date.getTimezoneOffset(), ':');
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function ZZ(date) {
    return formatTimezone(date.getTimezoneOffset());
  },

  // Seconds timestamp: 512969520
  'X': function X(date) {
    return Math.floor(date.getTime() / 1000);
  },

  // Milliseconds timestamp: 512969520900
  'x': function x(date) {
    return date.getTime();
  }
};

function buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp);
  var length = array.length;

  var i;
  var formatter;
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]];
    if (formatter) {
      array[i] = formatter;
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }

  return function (date) {
    var output = '';
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters);
      } else {
        output += array[i];
      }
    }
    return output;
  };
}

function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '');
  }
  return input.replace(/\\/g, '');
}

function formatTimezone(offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
}

function addLeadingZeros(number, targetLength) {
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output;
}

module.exports = format;

/***/ }),

/***/ "X3LN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}(); /* eslint-disable class-methods-use-this */

var _pointGeometry = __webpack_require__("ckno");

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__("K2XS");

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _wrap = __webpack_require__("uWKE");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
var Transform = function () {
  function Transform(tileSize, minZoom, maxZoom) {
    _classCallCheck(this, Transform);

    this.tileSize = tileSize || 512; // constant

    this._minZoom = minZoom || 0;
    this._maxZoom = maxZoom || 52;

    this.latRange = [-85.05113, 85.05113];

    this.width = 0;
    this.height = 0;
    this.zoom = 0;
    this.center = new _lat_lng2.default(0, 0);
    this.angle = 0;
  }

  Transform.prototype.zoomScale = function zoomScale(zoom) {
    return Math.pow(2, zoom);
  };

  Transform.prototype.scaleZoom = function scaleZoom(scale) {
    return Math.log(scale) / Math.LN2;
  };

  Transform.prototype.project = function project(latlng, worldSize) {
    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
  };

  Transform.prototype.unproject = function unproject(point, worldSize) {
    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
  };

  // lat/lon <-> absolute pixel coords convertion
  Transform.prototype.lngX = function lngX(lon, worldSize) {
    return (180 + lon) * (worldSize || this.worldSize) / 360;
  };

  // latitude to absolute y coord


  Transform.prototype.latY = function latY(lat, worldSize) {
    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
    return (180 - y) * (worldSize || this.worldSize) / 360;
  };

  Transform.prototype.xLng = function xLng(x, worldSize) {
    return x * 360 / (worldSize || this.worldSize) - 180;
  };

  Transform.prototype.yLat = function yLat(y, worldSize) {
    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  };

  Transform.prototype.locationPoint = function locationPoint(latlng) {
    var p = this.project(latlng);
    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
  };

  Transform.prototype.pointLocation = function pointLocation(p) {
    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
    return this.unproject(this.point.sub(p2));
  };

  _createClass(Transform, [{
    key: 'minZoom',
    get: function get() {
      return this._minZoom;
    },
    set: function set(zoom) {
      this._minZoom = zoom;
      this.zoom = Math.max(this.zoom, zoom);
    }
  }, {
    key: 'maxZoom',
    get: function get() {
      return this._maxZoom;
    },
    set: function set(zoom) {
      this._maxZoom = zoom;
      this.zoom = Math.min(this.zoom, zoom);
    }
  }, {
    key: 'worldSize',
    get: function get() {
      return this.tileSize * this.scale;
    }
  }, {
    key: 'centerPoint',
    get: function get() {
      return new _pointGeometry2.default(0, 0); // this.size._div(2);
    }
  }, {
    key: 'size',
    get: function get() {
      return new _pointGeometry2.default(this.width, this.height);
    }
  }, {
    key: 'bearing',
    get: function get() {
      return -this.angle / Math.PI * 180;
    },
    set: function set(bearing) {
      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
    }
  }, {
    key: 'zoom',
    get: function get() {
      return this._zoom;
    },
    set: function set(zoom) {
      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
      this._zoom = zoomV;
      this.scale = this.zoomScale(zoomV);
      this.tileZoom = Math.floor(zoomV);
      this.zoomFraction = zoomV - this.tileZoom;
    }
  }, {
    key: 'x',
    get: function get() {
      return this.lngX(this.center.lng);
    }
  }, {
    key: 'y',
    get: function get() {
      return this.latY(this.center.lat);
    }
  }, {
    key: 'point',
    get: function get() {
      return new _pointGeometry2.default(this.x, this.y);
    }
  }]);

  return Transform;
}();

exports.default = Transform;

/***/ }),

/***/ "X8jb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "YJJm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.convertNeSwToNwSe = convertNeSwToNwSe;
exports.convertNwSeToNeSw = convertNwSeToNeSw;
exports.fitBounds = fitBounds;
exports.meters2ScreenPixels = meters2ScreenPixels;
exports.tile2LatLng = tile2LatLng;
exports.latLng2Tile = latLng2Tile;
exports.getTilesIds = getTilesIds;

var _log = __webpack_require__("2aWH");

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var GOOGLE_TILE_SIZE = 256;

function latLng2World(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng;

  var sin = Math.sin(lat * Math.PI / 180);
  var x = lng / 360 + 0.5;
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;

  y = y < 0 // eslint-disable-line
  ? 0 : y > 1 ? 1 : y;
  return { x: x, y: y };
}

function world2LatLng(_ref2) {
  var x = _ref2.x,
      y = _ref2.y;

  var n = Math.PI - 2 * Math.PI * y;

  // TODO test that this is faster
  // 360 * Math.atan(Math.exp((180 - y * 360) * Math.PI / 180)) / Math.PI - 90;
  return {
    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
    lng: x * 360 - 180
  };
}

// Thank you wiki https://en.wikipedia.org/wiki/Geographic_coordinate_system
function latLng2MetersPerDegree(_ref3) {
  var lat = _ref3.lat;

  var phi = lat * Math.PI / 180;
  var metersPerLatDegree = 111132.92 - 559.82 * Math.cos(2 * phi) + 1.175 * Math.cos(4 * phi) - 0.0023 * Math.cos(6 * phi);
  var metersPerLngDegree = 111412.84 * Math.cos(phi) - 93.5 * Math.cos(3 * phi) + 0.118 * Math.cos(5 * phi);
  return { metersPerLatDegree: metersPerLatDegree, metersPerLngDegree: metersPerLngDegree };
}

function meters2LatLngBounds(meters, _ref4) {
  var lat = _ref4.lat,
      lng = _ref4.lng;

  var _latLng2MetersPerDegr = latLng2MetersPerDegree({
    lat: lat
  }),
      metersPerLatDegree = _latLng2MetersPerDegr.metersPerLatDegree,
      metersPerLngDegree = _latLng2MetersPerDegr.metersPerLngDegree;

  var latDelta = 0.5 * meters / metersPerLatDegree;
  var lngDelta = 0.5 * meters / metersPerLngDegree;

  return {
    nw: {
      lat: lat - latDelta,
      lng: lng - lngDelta
    },
    se: {
      lat: lat + latDelta,
      lng: lng + lngDelta
    }
  };
}

function meters2WorldSize(meters, _ref5) {
  var lat = _ref5.lat,
      lng = _ref5.lng;

  var _meters2LatLngBounds = meters2LatLngBounds(meters, { lat: lat, lng: lng }),
      nw = _meters2LatLngBounds.nw,
      se = _meters2LatLngBounds.se;

  var nwWorld = latLng2World(nw);
  var seWorld = latLng2World(se);
  var w = Math.abs(seWorld.x - nwWorld.x);
  var h = Math.abs(seWorld.y - nwWorld.y);

  return { w: w, h: h };
}

function fitNwSe(nw, se, width, height) {
  var EPS = 0.000000001;
  var nwWorld = latLng2World(nw);
  var seWorld = latLng2World(se);
  var dx = nwWorld.x < seWorld.x ? seWorld.x - nwWorld.x : 1 - nwWorld.x + seWorld.x;
  var dy = seWorld.y - nwWorld.y;

  if (dx <= 0 && dy <= 0) {
    return null;
  }

  var zoomX = (0, _log2.default)(width / GOOGLE_TILE_SIZE / Math.abs(dx));
  var zoomY = (0, _log2.default)(height / GOOGLE_TILE_SIZE / Math.abs(dy));
  var zoom = Math.floor(EPS + Math.min(zoomX, zoomY));

  // TODO find center just unproject middle world point
  var middle = {
    x: nwWorld.x < seWorld.x // eslint-disable-line
    ? 0.5 * (nwWorld.x + seWorld.x) : nwWorld.x + seWorld.x - 1 > 0 ? 0.5 * (nwWorld.x + seWorld.x - 1) : 0.5 * (1 + nwWorld.x + seWorld.x),
    y: 0.5 * (nwWorld.y + seWorld.y)
  };

  var scale = Math.pow(2, zoom);
  var halfW = width / scale / GOOGLE_TILE_SIZE / 2;
  var halfH = height / scale / GOOGLE_TILE_SIZE / 2;

  var newNW = world2LatLng({
    x: middle.x - halfW,
    y: middle.y - halfH
  });

  var newSE = world2LatLng({
    x: middle.x + halfW,
    y: middle.y + halfH
  });

  return {
    center: world2LatLng(middle),
    zoom: zoom,
    newBounds: {
      nw: newNW,
      se: newSE
    }
  };
}

function convertNeSwToNwSe(_ref6) {
  var ne = _ref6.ne,
      sw = _ref6.sw;

  return {
    nw: {
      lat: ne.lat,
      lng: sw.lng
    },
    se: {
      lat: sw.lat,
      lng: ne.lng
    }
  };
}

function convertNwSeToNeSw(_ref7) {
  var nw = _ref7.nw,
      se = _ref7.se;

  return {
    ne: {
      lat: nw.lat,
      lng: se.lng
    },
    sw: {
      lat: se.lat,
      lng: nw.lng
    }
  };
}

function fitBounds(_ref8, _ref9) {
  var nw = _ref8.nw,
      se = _ref8.se,
      ne = _ref8.ne,
      sw = _ref8.sw;
  var width = _ref9.width,
      height = _ref9.height;

  var fittedData = void 0;

  if (nw && se) {
    fittedData = fitNwSe(nw, se, width, height);
  } else {
    var calculatedNwSe = convertNeSwToNwSe({ ne: ne, sw: sw });
    fittedData = fitNwSe(calculatedNwSe.nw, calculatedNwSe.se, width, height);
  }

  return _extends({}, fittedData, {
    newBounds: _extends({}, fittedData.newBounds, convertNwSeToNeSw(fittedData.newBounds))
  });
}

// -------------------------------------------------------------------
// Helpers to calc some markers size

function meters2ScreenPixels(meters, _ref10, zoom) {
  var lat = _ref10.lat,
      lng = _ref10.lng;

  var _meters2WorldSize = meters2WorldSize(meters, { lat: lat, lng: lng }),
      w = _meters2WorldSize.w,
      h = _meters2WorldSize.h;

  var scale = Math.pow(2, zoom);
  var wScreen = w * scale * GOOGLE_TILE_SIZE;
  var hScreen = h * scale * GOOGLE_TILE_SIZE;
  return {
    w: wScreen,
    h: hScreen
  };
}

// --------------------------------------------------
// Helper functions for working with svg tiles, (examples coming soon)

function tile2LatLng(_ref11, zoom) {
  var x = _ref11.x,
      y = _ref11.y;

  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, zoom);

  return {
    lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
    lng: x / Math.pow(2, zoom) * 360 - 180
  };
}

function latLng2Tile(_ref12, zoom) {
  var lat = _ref12.lat,
      lng = _ref12.lng;

  var worldCoords = latLng2World({ lat: lat, lng: lng });
  var scale = Math.pow(2, zoom);

  return {
    x: Math.floor(worldCoords.x * scale),
    y: Math.floor(worldCoords.y * scale)
  };
}

function getTilesIds(_ref13, zoom) {
  var from = _ref13.from,
      to = _ref13.to;

  var scale = Math.pow(2, zoom);

  var ids = [];
  for (var x = from.x; x !== (to.x + 1) % scale; x = (x + 1) % scale) {
    for (var y = from.y; y !== (to.y + 1) % scale; y = (y + 1) % scale) {
      ids.push([zoom, x, y]);
    }
  }

  return ids;
}

/***/ }),

/***/ "YdsM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),

/***/ "ZShz":
/***/ (function(module, exports, __webpack_require__) {

!function (n, t) {
   true ? t(exports, __webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";
  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };function r(n, t) {
    function r() {
      this.constructor = n;
    }_i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }var e = { register: function register(n) {
      console.warn("Consumer used without a Provider");
    }, unregister: function unregister(n) {}, val: function val(n) {} };function u(n) {
    var t = n.children;return { child: 1 === t.length ? t[0] : null, children: t };
  }function o(n) {
    return u(n).child || "render" in n && n.render;
  }var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;function a(n, i) {
    var a = "_preactContextProvider-" + s++;return { Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };return { register: function register(n) {
                i.push(n), n(r, e(r));
              }, unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              }, val: function val(n) {
                if (void 0 === n || n == r) return r;var t = e(n);return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              } };
          }(t.value, i || f), r;
        }return r(e, n), e.prototype.getChildContext = function () {
          var n;return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;return i || t.h("span", null, r);
        }, e;
      }(t.Component), Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;0 != ((r |= 0) & t) && e.setState({ value: n });
          }, e.state = { value: e.u().val() || n }, e;
        }return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component) };
  }var h = a;n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", { value: !0 });
});

/***/ }),

/***/ "ZeD7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "ZzxP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".wem__search-bar{background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;z-index:2;-webkit-box-shadow:0 0 7px 0 rgba(0,0,0,.3);box-shadow:0 0 7px 0 rgba(0,0,0,.3);min-height:55px;max-height:55px}.is-safari .wem__search-bar{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.wem__search-bar.only-desktop{display:none}@media (min-width:768px){.wem__search-bar.only-desktop{display:-webkit-box;display:-ms-flexbox;display:flex}}.wem__search-bar.only-mobile{display:none}@media (max-width:767px){.wem__search-bar.only-mobile{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-shadow:none;box-shadow:none;border:1px solid #ccc;border-radius:3px;overflow:hidden;margin-top:20px}}.wem__search-bar__icon{color:#333;margin-left:20px;-webkit-transform:translateY(-.5px);-ms-transform:translateY(-.5px);transform:translateY(-.5px);opacity:.8;-webkit-transition:.4s;transition:.4s}.wem__search-bar__icon.\\--active{cursor:pointer;opacity:1}.wem__search-bar__input{font-family:inherit;font-size:16px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:block;padding:20px 13px;outline:none;border:none;min-height:55px;max-height:55px}.wem__search-bar__input:focus{background-color:transparent}.wem__search-bar--error{font-size:10px;line-height:13px;position:absolute;padding:2px 8px;background:#fff;color:#f60;top:100%;-webkit-animation:revealRight .4s 1 forwards;animation:revealRight .4s 1 forwards;-webkit-transition:.4s;transition:.4s;z-index:0}input[type=search].wem__search-bar__input{-webkit-appearance:searchfield;border:none}.is-safari input[type=search].wem__search-bar__input{-webkit-appearance:textfield}.wem input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:searchfield-cancel-button;background:rgba(0,0,0,.7);cursor:pointer}@-webkit-keyframes revealRight{0%{left:-100%}to{left:0}}@keyframes revealRight{0%{left:-100%}to{left:0}}.wem__events-map{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:none;width:100%;height:100%;position:relative}@media (min-width:768px){.wem__events-map{display:block}}.wem__events-map__icon,.wem__events-map__marker{display:block;width:20px;height:20px;cursor:pointer;position:relative;-webkit-transform:translate(-10px,-10px);-ms-transform:translate(-10px,-10px);transform:translate(-10px,-10px);-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;-webkit-transition:color .3s ease-in-out;transition:color .3s ease-in-out}.wem__events-map__icon.noshadow,.wem__events-map__marker.noshadow{-webkit-box-shadow:none;box-shadow:none}.wem__events-map__icon.is-active,.wem__events-map__marker.is-active{-webkit-transform:translate(-10px,-10px) scale(1.2);-ms-transform:translate(-10px,-10px) scale(1.2);transform:translate(-10px,-10px) scale(1.2);-webkit-transform-origin:center center;-ms-transform-origin:center center;transform-origin:center center}.wem__events-map__marker{background-color:#009cde;border-radius:100%;border:3px solid #fff;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.1);box-shadow:0 0 5px 0 rgba(0,0,0,.1);-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}.wem__events-map__marker.is-active,.wem__events-map__marker:hover{position:relative;z-index:9999}.wem__events-map__marker:hover{background-color:#f60}.wem__events-map__marker.is-active{background-color:#f60;z-index:99999;position:relative}.wem__events-map__marker.is-active:hover{z-index:999999;position:relative}.wem__events-map__icon{width:19px;height:19px;color:#009cde;-webkit-box-shadow:none;box-shadow:none}.wem__events-map__icon.is-active,.wem__events-map__icon:hover{position:relative;z-index:9999}.wem__events-map__icon:hover{color:#f60}.wem__events-map__icon.is-active{color:#f60;z-index:99999;position:relative}.wem__events-map__icon.is-active:hover{z-index:999999;position:relative}.wem__events-panel{background-color:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;z-index:2;-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);box-shadow:0 0 20px rgba(0,0,0,.3);pointer-events:all!important}@media (min-width:768px){.wem__events-panel{max-width:50%;min-height:600px}}.wem__events-panel__content{margin-top:-15px;padding:35px}@media (min-width:768px){.wem__events-panel__content{margin-top:0;padding:85px 75px 12px}}.wem__events-panel__scrollable{overflow-y:scroll;position:relative}.wem__events-panel__scrollable.\\--no-events{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.wem__events-panel__scrollmore{-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;bottom:0;width:100%;opacity:.8;-webkit-transition:all .4s;transition:all .4s;font-family:inherit;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff;padding:10px;pointer-events:none;-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);box-shadow:0 0 20px rgba(0,0,0,.3);text-align:center;display:none}.wem__events-panel__scrollmore:before{content:\"Scroll for more events\";display:inline-block;font-size:14px;text-align:center;pointer-events:none;font-family:inherit;font-weight:400}.wem__events-panel__scrollmore svg{height:12px;width:12px;opacity:.8;text-align:center;pointer-events:none;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);margin-left:10px;position:relative;top:2px}.wem__events-panel:hover .wem__events-panel__scrollmore{pointer-events:none;opacity:0}@media (min-width:768px){.wem__events-panel__scrollmore{display:-webkit-box;display:-ms-flexbox;display:flex}}.wem__events-panel.\\--at-bottom .wem__events-panel__scrollmore{display:none!important}.wem__events-panel__headline{color:#002740;margin:0 0 20px;font-weight:bolder}.wem__events-panel__description{color:#333;margin:0 0 10px}.wem_events-filters{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-top:10px;font-size:14px;background:#fff;z-index:999;padding:12px 35px;height:55px;position:-webkit-sticky;position:sticky;top:0}@media (min-width:768px){.wem_events-filters{padding:11px 75px}}.\\--sticky .wem_events-filters{padding-left:35px;-webkit-transition:padding-left .2s;transition:padding-left .2s}.\\--sticky .wem_events-filters label{opacity:0;-webkit-transition:none;transition:none}.\\--near-sticky .wem_events-filters label{opacity:0;-webkit-transition:opacity .1s;transition:opacity .1s}.wem__events-panel__scroll-spacer{height:30px;background:#fff;border-bottom:1px solid #ccc;z-index:99}@media (min-width:768px){.wem__events-panel__scroll-spacer{height:43px;position:-webkit-sticky;position:sticky;top:13px}}.wem__events-panel__noevents{padding:60px;text-align:center;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:Campton-Bold,sans-serif;font-size:20px;-webkit-transform:translateY(-27%);-ms-transform:translateY(-27%);transform:translateY(-27%)}.wem__events-panel__noevents button{cursor:pointer;display:block;margin:20px auto;font-size:14px}.wem__events-panel-virtual .\\--sticky .wem__events-panel__content{display:none}.wem__events-panel-virtual .\\--sticky .wem__events-panel__scroll-spacer{height:1px}.wem__events-panel-virtual .\\--sticky .wem_events-filters{margin-top:0}.wem__events-panel-virtual .wem__filter label{-webkit-transition:none!important;transition:none!important}.wem__events-virtual-scroller{position:absolute;bottom:0;width:100%;height:60%;overflow-y:scroll}.wem__events-virtual-scroller .wem__event-card{overflow:hidden;min-height:290px}.wem__events-virtual-scroller .wem__event-card__details{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.wem__events-virtual-scroller .wem__event-card__description{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}@media (min-width:768px) and (max-width:1000px){.wem__events-virtual-scroller .\\--has-image .wem__event-card__description{display:none}.wem__events-virtual-scroller .wem__event-actions{position:relative;min-width:50vw}.wem__events-virtual-scroller .\\--has-image .wem__event-card__meta{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}}.wem__events-virtual-scroller.\\--is-full{height:calc(100% - 55px)!important}.wem__event__virtual{font-size:16px;line-height:16px;font-family:Campton-Bold,sans-serif;font-weight:400}.wem__event-card{background-color:#fff;text-decoration:none;color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;padding:35px 30px;border-left:0 solid #009cde;border-right:10px solid transparent;border-bottom:1px solid #ccc;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out;cursor:pointer;position:relative;will-change:border-width}.wem__event-card:hover{background-color:#f7f7f7;border-left-width:10px;border-right-width:0}@media (min-width:768px){.wem__event-card{padding:35px 35px 35px 75px}}.wem__event-card:last-child{border-bottom:0}.wem__event-card__details{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;max-width:100%}@media (min-width:768px){.\\--has-image .wem__event-card__details{max-width:70%;width:40%}}.wem__event-card__image{display:none;-webkit-box-flex:1;-ms-flex:1 0 30%;flex:1 0 30%;max-height:calc(100% - 20px);min-width:30%;width:30%;position:relative;margin:0 -20px 0 30px;overflow:hidden}@media (min-width:768px){.wem__event-card__image{display:block}}.wem__event-card__image img{width:100%;max-width:100%;height:auto;display:none;position:absolute}@media (min-width:768px){.wem__event-card__image img{display:block}}.wem__event-card__date{text-transform:uppercase;margin:0 0 8px}.wem__event-card__title{color:#009cde;margin:0 0 10px}.wem__event-card__meta{font-weight:700;font-size:.9rem;line-height:1rem;display:block;font-family:Campton-Bold,sans-serif}.wem__event-card__summary{font-size:.9rem;margin:0}.wem__event-card__description{font-size:16px;line-height:1.3;margin:0}.wem__event-card__description.description-short{display:none}@media (max-width:768px){.wem__event-card__description.description-short{display:none}.wem__event-card__description.description-long{display:block}}@media (min-width:768px) and (max-width:1100px){.wem__event-card__description.description-short{display:block}.wem__event-card__description.description-long{display:none}}.wem__event-detail{background-color:#fff;color:#333;width:100%;min-height:500px;padding:65px 30px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;position:relative;z-index:2;-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);box-shadow:0 0 20px rgba(0,0,0,.3);overflow-y:scroll}@media (min-width:768px){.wem__event-detail{max-width:50%;padding:65px 75px}}.wem__event-detail__close{background-color:#eee;text-decoration:none;font-size:24px;color:#333;width:38px;height:38px;position:absolute;top:20px;right:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;outline:none;border:none;border-radius:100%;-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out;cursor:pointer;padding:7px}.wem__event-detail__close:hover{background-color:#fe0000;color:#fff}.wem__event-detail__close svg{width:100%;height:100%;-webkit-transform:scale(.7);-ms-transform:scale(.7);transform:scale(.7);-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;max-height:20px}.wem__event-detail__image{padding:0;margin:0}.wem__event-detail__image img{max-width:100%;display:block}.wem__event-detail__date{text-transform:uppercase;margin:0 0 20px}.wem__event-detail__title{margin:0 0 10px}.wem__event-detail__meta{display:block}.wem__event-detail__actions{font-size:.9rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin:10px 0 30px}.wem__event-detail__action{text-decoration:none;font-weight:700;color:#fe0000;-webkit-transition:color .3s ease-in-out;transition:color .3s ease-in-out}.wem__event-detail__action+.wem__event-detail__action{margin-left:10px}.wem__event-detail__action:hover{color:#cb0000}.wem__event-detail__action-details{color:#0166ff}.wem__event-detail__content{margin:30px 0 0}.wem__event-detail__content p:last-child{margin-bottom:0;margin-bottom:-.1em}.wem__event-detail__headline{margin:0 0 5px}.wem__event-detail__headline+.wem__event-detail__paragraph{margin-top:5px}.wem__event-detail__phone{margin-top:15px}.wem_event-card__priority-icon{color:#009cde;margin-left:-24px;margin-top:-3px;position:absolute}.wem__event-actions{font-size:.9rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-family:Campton-Bold,sans-serif;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:10px 0 0;-ms-flex-wrap:wrap;flex-wrap:wrap}@media (min-width:375px){.wem__event-actions{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}}.wem__event-detail .wem__event-actions{margin:10px 0 20px}@media (min-width:960px){.wem__event-card .wem__event-actions{min-width:100vw}}.wem__event-actions__url{text-decoration:none;font-weight:700;font-size:16px;line-height:16px;color:#f60;-webkit-transition:color .3s ease-in-out;transition:color .3s ease-in-out;margin-top:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap}.wem__event-actions__url svg{height:11px;line-height:16px;font-weight:700;display:inline-block;vertical-align:middle;padding-left:10px;-webkit-box-flex:1;-ms-flex:1 0 6px;flex:1 0 6px;position:relative;top:.5px}@media (min-width:375px){.wem__event-actions__url+.wem__event-actions__url{margin-left:20px}}.wem__event-actions__url:hover{color:#cc5200}.wem__event-actions__url-details{color:#009cde}.wem__event-actions__url-details:hover{color:#0078ab}.wem__event-actions__social{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition:.5s;transition:.5s;text-align:left;margin-top:10px;min-width:57px;display:none;margin-left:auto;text-align:right;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;max-width:90px}@media (min-width:375px){.wem__event-actions__social{display:-webkit-box;display:-ms-flexbox;display:flex}}@media (min-width:768px){.wem__event-actions__social{opacity:0}}.wem__event:hover .wem__event-actions__social{opacity:1}@media (min-width:768px){.wem__event-card .wem__event-actions__social{max-width:80px;margin-left:30px;-ms-flex-pack:distribute;justify-content:space-around}}.\\--no-url .wem__event-actions__social{margin-left:0}.wem__event-detail .wem__event-actions__social{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;min-width:10px}@media (min-width:375px){.wem__event-detail .wem__event-actions__social a{min-width:10px;text-align:right}}@media (min-width:390px){.wem__event-detail .wem__event-actions__social{max-width:120px}.wem__event-detail .wem__event-actions__social a{min-width:25px}}@media (min-width:768px){.wem__event-detail .wem__event-actions__social{max-width:100px}}.wem__event-actions__social-link{color:rgba(0,0,0,.5);margin-left:10px;position:relative;-webkit-transition:color .3s ease-in-out;transition:color .3s ease-in-out;top:1px}.wem__event-actions__social-link:first-of-type{margin-left:0}.wem__event-actions__social-link:hover{color:#000}.wem_events-filters{-ms-flex-wrap:wrap;flex-wrap:wrap}.wem__filter{position:relative;-webkit-box-flex:1;-ms-flex:1 0 49%;flex:1 0 49%}.wem__filter input,.wem__filter select{padding:4px 10px 4px 8px}.wem__filter label{font-family:Campton-Bold,sans-serif;font-weight:700;color:#919191;margin-bottom:-4px;position:absolute;top:-27px;-webkit-transition:opacity .3s .8s;transition:opacity .3s .8s}@media (min-width:768px){.wem__filter{min-width:40%;-webkit-box-flex:1;-ms-flex:1 0 40%;flex:1 0 40%;max-width:50%}}@media (max-width:767px){.wem__filter{max-width:calc(50% - 5px)}}.wem__filter--category-section{margin-right:10px}.wem__filter--category-section select{-webkit-appearance:menulist!important;-moz-appearance:menulist!important;appearance:menulist!important}.wem__filter--category-section select:focus{outline:none}.wem__filter--date-section{border-radius:3px}.wem__filter--category-field,.wem__filter--date-field{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:34px;border:1px solid #666;border-radius:3px;top:-1px}.wem__filter--category-field input,.wem__filter--category-field select,.wem__filter--date-field input,.wem__filter--date-field select{height:34px;width:100%}.is-safari .wem__filter--category-field{border:none}@keyframes lds-dual-ring{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes lds-dual-ring{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.lds-dual-ring,.wem__loader__icon{position:relative}.lds-dual-ring div,.wem__loader__icon div{position:absolute;width:32px;height:32px;border-radius:50%;border:4px solid #000;border-color:#ccc transparent;-webkit-animation:lds-dual-ring .7s linear infinite;animation:lds-dual-ring .7s linear infinite}.lds-dual-ring,.wem__loader__icon{width:100px!important;height:100px!important;-webkit-transform:translate(-50px,-50px) scale(1) translate(50px,50px);-ms-transform:translate(-50px,-50px) scale(1) translate(50px,50px);transform:translate(-50px,-50px) scale(1) translate(50px,50px)}.wem__loader{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;top:0;left:0}.wem__loader.high{z-index:99999}.wem{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;border-bottom:1px solid #ccc;position:relative}.wem .wem__events-right,.wem .wem__map-container{visibility:hidden;opacity:0!important;-webkit-transition:opacity .5s;transition:opacity .5s}.wem .wem__map-container{max-height:0}@media (min-width:768px){.wem .wem__map-container{max-height:none}}.wem.\\--failed,.wem.\\--init{visibility:visible;opacity:1}.wem.\\--failed .wem__events-right,.wem.\\--init .wem__events-right{visibility:visible;opacity:1!important}@media (min-width:768px){.wem.\\--failed .wem__map-container,.wem.\\--init .wem__map-container{visibility:visible;opacity:1!important}}.wem,.wem *,.wem:after,.wem :after,.wem:before,.wem :before{-webkit-box-sizing:border-box;box-sizing:border-box}@media (min-width:768px){.wem{min-height:600px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;max-height:calc(100vh - 76px)}}.wem__map-container{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.wem_long_title{font-size:20px!important}.virtual-toggle{padding-left:25px;position:relative}.virtual-toggle input{opacity:0;position:absolute}.virtual-toggle:after{content:\"\";height:16px;width:16px;border:1px solid #666;position:absolute;left:0}.virtual-toggle:before{content:none;margin-top:-3px;position:absolute;left:2px;border-left:2px solid #002740;border-bottom:2px solid #002740;left:4px;top:8px;-ms-transform:rotate(-45deg);-webkit-transform:rotate(-45deg);transform:rotate(-45deg);height:5px;width:9px}.virtual-toggle.checked:before{content:\"\"}.virtual-label__small{display:none}.is-sticky .virtual-label__small{display:block}.is-sticky .virtual-toggle{position:absolute;right:-20px;opacity:1!important}.is-sticky .virtual-toggle:after{top:0}.is-sticky .virtual-label__large{display:none}", "", {"version":3,"sources":["/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/SearchBar/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventsMap/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/MapMarker/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/_variables.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventsPanel/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventCard/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventDetail/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventActions/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/EventFilters/style.scss","/Users/dtipson/Sites/txdems-clean/wp-content/plugins/we-mobilize/frontend/src/components/Loader/style.scss"],"names":[],"mappings":"AAAA,iBACE,gBACA,oBAAA,oBAAA,aACA,8BAAA,6BAAA,uBAAA,mBACA,yBAAA,sBAAA,8BAEA,yBAAA,sBAAA,mBACA,kBACA,UACA,4CAAA,oCACA,gBACA,eCcuB,CDXvB,4BACE,uBAAA,oBAAA,0BAA2B,CAf/B,8BAmBI,YAAY,CACZ,yBApBJ,8BAqBM,oBAAA,oBAAA,YAAY,CAEf,CAvBH,6BAyBI,YAAY,CACZ,yBA1BJ,6BA2BM,oBAAA,oBAAA,aAIA,wBAAA,gBACA,sBACA,kBACA,gBACA,eAAe,CAElB,CAIH,uBACE,WACA,iBACA,oCAAA,gCAAA,4BACA,WACA,uBAAA,cAAgB,CALlB,iCAQI,eACA,SAAU,CACX,wBAID,oBACA,eACA,mBAAA,oBAAA,YACA,cACA,kBACA,aACA,YACA,gBACA,eCtCuB,CD6BzB,8BAYI,4BAA6B,CAC9B,wBAMD,eACA,iBACA,kBACA,gBACA,gBACA,WACA,SACA,6CAAA,qCACA,uBAAA,eACA,SAAS,CACV,0CAGC,+BACA,WAAY,CAEZ,qDACE,4BAA6B,CAC9B,oGAMD,6CACA,0BACA,cAAe,CAChB,+BAIG,GAAM,UAAW,CACjB,GAAI,MAAM,CAAA,CALb,uBAIG,GAAM,UAAW,CACjB,GAAI,MAAM,CAAA,CEzGd,iBACE,mBAAA,oBAAA,YACA,aACA,WACA,YACA,iBAAkB,CAElB,yBAPF,iBAQI,aAAc,CAEjB,CCVD,gDACE,cACA,WACA,YACA,eACA,kBACA,yCAAA,qCAAA,iCACA,oDAAA,4CACA,yCAAA,gCAAkC,CARpC,kEAUI,wBAAA,eAAe,CAVnB,oEAaI,oDAAA,gDAAA,4CACA,uCAAA,mCAAA,8BAA+B,CAChC,yBAID,yBACA,mBACA,sBACA,4CAAA,oCACA,oDAAA,2CAA6C,CAL/C,kEAQI,kBACA,YAAa,CATjB,+BAYI,qBC3BkB,CDetB,mCAeI,sBACA,cACA,iBAAkB,CAjBtB,yCAoBI,eACA,iBAAkB,CACnB,uBAMD,WACA,YACA,cACA,wBAAA,eAAe,CAJjB,8DAOI,kBACA,YAAa,CARjB,6BAWI,UCrDkB,CD0CtB,iCAcI,WACA,cACA,iBAAkB,CAhBtB,uCAmBI,eACA,iBAAkB,CACnB,mBEjED,sBACA,mBAAA,oBAAA,YACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,kBACA,UACA,2CAAA,mCACA,4BAA8B,CAE9B,yBAVF,mBAWI,cACA,gBAAiB,CAGpB,CAED,4BACE,iBACA,YJKiB,CIHjB,yBAJF,4BAKI,aACA,sBAAuB,CAE1B,CAED,+BACE,kBACA,iBAAkB,CAFpB,4CAII,mBAAA,kBAAA,aAAc,CACf,+BAID,yBAAA,sBAAA,mBACA,kBACA,SACA,WACA,WACA,2BAAA,mBACA,oBACA,wBAAA,qBAAA,uBACA,gBACA,aACA,oBACA,2CAAA,mCACA,kBA8CA,YAAY,CA3Dd,sCAgBI,iCACA,qBACA,eACA,kBACA,oBAEA,oBACA,eAAmB,CAvBvB,mCA0BI,YACA,WACA,WACA,kBACA,oBACA,gCAAA,4BAAA,wBACA,iBACA,kBACA,OAAO,CACR,wDAoBC,oBACA,SAAU,CACX,yBAzDH,+BA6DI,oBAAA,oBAAA,YAAY,CAMf,CAHC,+DACE,sBAAwB,CACzB,6BAID,cACA,gBACA,kBAAmB,CACpB,gCAGC,WACA,eAAgB,CACjB,oBAGC,oBAAA,oBAAA,aACA,uBAAA,oBAAA,2BACA,gBACA,eACA,gBACA,YACA,kBACA,YAMA,wBAAA,gBACA,KAAK,CALL,yBAVF,oBAWI,iBAAkB,CAqBrB,CAdC,+BACE,kBACA,oCAAA,2BAA6B,CAF/B,qCAII,UACA,wBAAA,eAAgB,CACjB,0CAIC,UACA,+BAAA,sBAAwB,CACzB,kCAOH,YACA,gBACA,6BACA,UAAU,CAEV,yBANF,kCAOI,YACA,wBAAA,gBACA,QAAe,CAElB,CAED,6BACE,aACA,kBACA,mBAAA,kBAAA,cACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,wBAAA,qBAAA,uBACA,oCACA,eACA,mCAAA,+BAAA,0BAA6B,CAT/B,oCAYI,eACA,cACA,iBACA,cAAe,CAChB,kEAOG,YAAa,CAHnB,wEAMM,UAAU,CANhB,0DASM,YAAY,CATlB,8CAaI,kCAAA,yBAA2B,CAC5B,8BAGD,kBACA,SACA,WACA,WACA,iBAAkB,CALpB,+CAQI,gBACA,gBAAiB,CATrB,wDAYI,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,qBAAsB,CAb1B,4DAgBI,mBAAA,kBAAA,aAAc,CACf,gDAjBH,0EAoBM,YAAY,CApBlB,kDAuBM,kBACA,cAAe,CAxBrB,mEA2BM,mBAAA,kBAAA,aAAc,CACf,CA5BL,yCA+BI,kCAAoC,CACrC,qBAGG,eACF,iBACA,oCACA,eAAgB,CACnB,iBC9OC,sBACA,qBACA,WACA,oBAAA,oBAAA,aACA,kBACA,4BACA,oCACA,6BACA,uCAAA,+BACA,eACA,kBACA,wBAAyB,CAZ3B,uBAeI,yBACA,uBAGA,oBAAqB,CACtB,yBApBH,iBAuBI,2BAA4B,CAK/B,CA5BD,4BA0BI,eAAgB,CACjB,0BAOD,mBAAA,kBAAA,cACA,cAAe,CLhBb,yBKkBA,wCACE,cACA,SAAwB,CACzB,CAIL,wBAEE,aAKA,mBAAA,iBAAA,aACA,6BACA,cACA,UACA,kBACA,sBACA,eAAgB,CLtCd,yBKyBJ,wBAII,aAAc,CAqBjB,CAzBD,4BAeI,WACA,eACA,YACA,aACA,iBAAkB,CL5ClB,yBKyBJ,4BAsBM,aAAc,CAEjB,CAGH,uBACE,yBACA,cAAe,CAChB,wBAGC,cACA,eAAkB,CACnB,uBAGC,gBACA,gBACA,iBACA,cACA,mCFrByC,CEsB1C,0BAGC,gBACA,QAAS,CACV,8BAGC,eACA,gBACA,QAAS,CAHX,gDAMI,YAAa,CACd,yBAPH,gDAWM,YAAa,CAXnB,+CAcM,aAAc,CACf,CAEH,gDAjBF,gDAmBM,aAAc,CAnBpB,+CAsBM,YAAa,CACd,CCrHL,mBACE,sBACA,WACA,WACA,iBACA,kBACA,mBAAA,oBAAA,YACA,kBACA,UACA,2CAAA,mCACA,iBAAkB,CNShB,yBMnBJ,mBAaI,cACA,iBAAkB,CAErB,CAED,0BACE,sBACA,qBACA,eACA,WACA,WACA,YACA,kBACA,SACA,WACA,oBAAA,oBAAA,aACA,wBAAA,qBAAA,uBACA,yBAAA,sBAAA,mBACA,aACA,YACA,mBACA,uCAAA,+BACA,eACA,WAAY,CAlBd,gCAqBI,yBACA,UAAW,CAtBf,8BAyBI,WACA,YACA,4BAAA,wBAAA,oBACA,gCAAA,4BAAA,wBACA,eAAgB,CACjB,0BAID,UACA,QAAS,CAFX,8BAII,eACA,aAAc,CACf,yBAID,yBACA,eAAkB,CACnB,0BAGC,eAAkB,CACnB,yBAGC,aAAc,CACf,4BAIC,gBACA,oBAAA,oBAAA,aACA,8BAAA,6BAAA,uBAAA,mBACA,uBAAA,oBAAA,2BACA,wBAAA,qBAAA,uBACA,kBAAmB,CACpB,2BAGC,qBACA,gBACA,cACA,yCAAA,gCAAkC,CAJpC,sDAOI,gBAAiB,CAPrB,iCAWI,aAA2B,CAC5B,mCAKD,aAAc,CACf,4BAMC,eAAgB,CADlB,yCAGI,gBACA,mBAAqB,CACtB,6BAID,cAAiB,CAClB,2DAGC,cAAe,CAChB,0BAIC,eAAgB,CACjB,+BAGC,cACA,kBACA,gBACA,iBAAkB,CACnB,oBChIC,gBACA,oBAAA,oBAAA,aACA,8BAAA,6BAAA,uBAAA,mBACA,yBAAA,sBAAA,8BACA,oCAIA,yBAAA,sBAAA,mBACA,gBACA,mBAAA,cAAe,CPKb,yBOhBJ,oBAOI,uBAAA,oBAAA,0BAA2B,CAa9B,CARC,uCACE,kBAAmB,CPGnB,yBODF,qCAEI,eAAgB,CAEnB,CAGH,yBACE,qBACA,gBACA,eACA,iBACA,WACA,yCAAA,iCACA,AACA,gBACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,kBAAmB,CAXrB,6BAcI,YACA,iBACA,gBACA,qBACA,sBACA,kBAGA,mBAAA,iBAAA,aACA,kBACA,QAAU,CP9BV,yBOMJ,kDA6BM,gBAAiB,CAClB,CA9BL,+BAmCI,aAA8B,CAC/B,iCAKD,aJjEkB,CIgEpB,uCAII,aAA4B,CAC7B,4BAKD,oBAAA,oBAAA,aACA,8BAAA,6BAAA,uBAAA,mBACA,mBAAA,eACA,yBAAA,sBAAA,8BACA,yBAAA,sBAAA,mBACA,uBAAA,eACA,gBACA,gBACA,eACA,aACA,iBACA,iBACA,mBAAA,kBAAA,cACA,cAAe,CPrEb,yBOsDJ,4BAmBI,oBAAA,oBAAA,YAAa,CA2ChB,CPpHG,yBOsDJ,4BAuBI,SAAU,CAuCb,CApCC,8CACE,SAAU,CPjFV,yBOoFF,6CAEI,eACA,iBACA,yBAAA,4BAA6B,CAEhC,CAED,uCACE,aAAgB,CACjB,+CAEC,mBAAA,kBAAA,cACA,cAAe,CPjGf,yBO+FF,iDAMM,eACA,gBAAiB,CAClB,CPvGH,yBO+FF,+CAWI,eAAgB,CAXpB,iDAaM,cAAe,CAChB,CP7GH,yBO+FF,+CAiBI,eAAgB,CAGnB,CAGH,iCACE,qBACA,iBACA,kBACA,yCAAA,iCACA,OAAO,CALT,+CAQI,aAAc,CARlB,uCAYI,UAAW,CHlCf,oBIlHE,mBAAA,cAAe,CAChB,aAGC,kBAeA,mBAAA,iBAAA,YAAa,CAhBf,uCAII,wBAAyB,CAJ7B,mBAOI,oCACA,gBACA,cACA,mBACA,kBACA,UACA,mCAAA,0BAA2B,CAC5B,yBAdH,aAkBI,cACA,mBAAA,iBAAA,aACA,aAAc,CAKjB,CAHC,yBAtBF,aAuBI,yBAA0B,CAE7B,CAGD,+BACE,iBAAkB,CADpB,sCAGI,sCAAA,mCAAA,6BAA+B,CAHnC,4CAKM,YAAa,CACd,2BAKH,iBAAkB,CAEnB,sDAGC,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,YACA,sBACA,kBACA,QAAS,CANX,sIAQI,YACA,UAAU,CACX,wCAKC,WAAY,CACb,yBC3DD,GACE,4BACA,mBAAoB,CAEtB,GACE,gCACA,uBAAyB,CAAA,CAG7B,iCACE,GACE,4BACA,mBAAoB,CAEtB,GACE,gCACA,uBAAyB,CAAA,CAG7B,kCACE,iBAAkB,CACnB,0CAEC,kBACA,WACA,YACA,kBACA,sBACA,8BACA,oDACA,2CAA6C,CAX/C,kCAkBE,sBACA,uBACA,uEACA,mEAAA,8DAAyF,CAC1F,aAwBC,WACA,YACA,oBAAA,oBAAA,aACA,wBAAA,qBAAA,uBACA,yBAAA,sBAAA,mBACA,kBACA,MACA,MAAM,CARR,kBAUI,aAAa,CTfjB,KACE,WACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBACA,gBACA,6BACA,iBAAkB,CANpB,iDASI,kBACA,oBACA,+BAAA,sBAAwB,CAX5B,yBAcI,YAAY,CACb,yBAfH,yBAkBM,eAAe,CAChB,CAnBL,4BAgCI,mBACA,SAAU,CAjCd,kEAuBQ,mBACA,mBAAqB,CACtB,yBAzBP,oEA4BU,mBACA,mBAAqB,CACtB,CA9BT,4DAqCI,8BAAA,qBAAsB,CACvB,yBAtCH,KAyCI,iBACA,8BAAA,6BAAA,uBAAA,mBACA,6BAA8B,CAEjC,CAED,oBACE,mBAAA,oBAAA,YACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,qBAAsB,CACvB,gBAGC,wBAAyB,CAC1B,gBAGC,kBACA,iBAAkB,CAFpB,sBAII,UACA,iBAAiB,CALrB,sBAQI,WACA,YACA,WACA,sBACA,kBACA,MAAM,CAbV,uBAgBI,aACA,gBACA,kBACA,SACA,8BACA,gCACA,SACA,QACA,6BACA,iCAAA,yBACA,WACA,SAAU,CA3Bd,+BAgCM,UAAU,CACX,sBAKH,YAAa,CACd,iCAIG,aAAc,CAFlB,2BAKI,kBACA,YACA,mBAAoB,CAPxB,iCASM,KAAK,CATX,iCAaI,YAAa,CACd","file":"style.scss","sourcesContent":[".wem__search-bar {\n  background: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  \n  align-items: center;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 0 7px 0 rgba(#000, 0.3);\n  min-height: $searchFilterHeight;\n  max-height: $searchFilterHeight;\n  //overflow: hidden;\n\n  .is-safari &{\n    justify-content: flex-start;\n  }\n\n  &.only-desktop{\n    display:none;\n    @media (min-width: 768px) {\n      display:flex;\n    }\n  }\n  &.only-mobile{\n    display:none;\n    @media (max-width: 767px) {\n      display:flex;\n      // margin: 20px 0 -20px;\n      // margin-left: calc(50% - 50vw);\n      // margin-right: calc(50% - 50vw);\n      box-shadow: none;\n      border: 1px solid #ccc;\n      border-radius: 3px;\n      overflow: hidden;\n      margin-top:20px;\n    }\n  }\n\n}\n\n.wem__search-bar__icon {\n  color: #333;\n  margin-left: 20px;\n  transform: translateY(-0.5px);\n  opacity: 0.8;\n  transition: 0.4s;\n\n  &.--active{\n    cursor: pointer;\n    opacity: 1;\n  }\n}\n\n.wem__search-bar__input {\n  font-family: inherit;\n  font-size: 16px;\n  flex-grow: 1;\n  display: block;\n  padding: 20px 13px;\n  outline: none;\n  border: none;\n  min-height: $searchFilterHeight;\n  max-height: $searchFilterHeight;\n\n  &:focus{\n    background-color: transparent;\n  }\n\n}\n\n\n.wem__search-bar--error{\n  font-size: 10px;\n  line-height: 13px;\n  position: absolute;\n  padding: 2px 8px;\n  background: #fff;\n  color: $secondary;\n  top:100%;\n  animation: revealRight 0.4s 1 forwards;\n  transition: 0.4s;\n  z-index:0;\n}\n\ninput[type=search].wem__search-bar__input{\n  -webkit-appearance: searchfield;\n  border: none;\n\n  .is-safari &{\n    -webkit-appearance: textfield;\n  }\n}\n\n\n\n.wem input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration{\n  -webkit-appearance:searchfield-cancel-button;\n  background: rgba(0,0,0,0.7);\n  cursor: pointer;\n}\n\n\n@keyframes revealRight {\n    from {left: -100%;}\n    to {left:0;}\n}","// Must import each component stylesheet separately to prevent the Preact\n// Widget template from generating unique class names per component. This is to\n// allow themes to further style components.\n\n// @import '../../../../themes/purple/assets/scss/utilities/_variables.scss';\n// @import '../../../../themes/purple/assets/scss/utilities/_mixins.scss';\n@import '_variables.scss';\n@import '_mixins.scss';\n//@import '../../../../themes/wideeyecreative/assets/scss/global/_typography.scss';\n\n// //@import '../../../../themes/wideeyecreative/assets/scss/base/sanitize.scss';\n// //@import '../../../../themes/wideeyecreative/assets/scss/base/base.scss';\n\n@mixin breakpoint($breakpoint, $width: min) {\n  @if $width == \"max\" {\n    @media (#{$width}-width: $breakpoint - 1px) {\n      @content;\n    }\n  } @else {\n    @media (#{$width}-width: $breakpoint) {\n      @content;\n    }\n  }\n}\n$panelPadding: 35px !default;\n$searchFilterHeight: 55px !default;\n$white: #fff !default;\n$primary    : #0066ff!default;\n$secondary    : #ff0000!default;\n$body     : #222222!default;\n$tertiary   : #d7dee5!default;\n$details    : #919191!default;\n$bg-dark      : #0066FF!default;\n$bg-light   : #eeeeee!default;\n\n// Headlines\n$headlineColor  : #222222!default;\n$hrColor    : #cccccc!default;\n// breakpoints\n$bp-alpha   : 320px!default;\n$bp-adams   : 375px!default;\n$bp-adams-wide : 390px!default;\n$bp-bravo   : 480px!default;\n$bp-charlie : 768px!default;\n$bp-delta   : 960px!default;\n$bp-bobby   : 992px!default;\n$bp-echo    : 1250px!default;\n// fonts\n$primary-font : 'freight-text-pro'!default;\n$headline-font  : 'sofia-pro'!default;\n\n\n@import 'components/SearchBar/style.scss';\n@import 'components/EventsMap/style.scss';\n@import 'components/MapMarker/style.scss';\n@import 'components/EventsPanel/style.scss';\n@import 'components/EventCard/style.scss';\n@import 'components/EventDetail/style.scss';\n@import 'components/EventActions/style.scss';\n@import 'components/EventFilters/style.scss';\n@import 'components/Loader/style.scss';\n\n\n.wem {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-bottom: 1px solid #ccc;\n  position: relative;\n\n  .wem__map-container, .wem__events-right{\n    visibility: hidden;\n    opacity: 0  !important;\n    transition: opacity 0.5s;\n  }\n  .wem__map-container{\n    max-height:0;\n  }\n  @media (min-width: 768px) {\n    .wem__map-container{\n      max-height:none;\n    }\n  }\n  &.--init, &.--failed{\n      .wem__events-right{\n        visibility: visible;\n        opacity: 1 !important;\n      }\n      @media (min-width: 768px) {\n        .wem__map-container{\n          visibility: visible;\n          opacity: 1 !important;\n        }\n      }\n    visibility: visible;\n    opacity: 1;\n  }\n\n  &, &:before, &:after, *, *:before, *:after {\n    box-sizing: border-box;\n  }\n\n  @media (min-width: 768px) {\n    min-height: 600px;\n    flex-direction: row;\n    max-height: calc(100vh - 76px);\n  }\n}\n\n.wem__map-container {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.wem_long_title{\n  font-size:20px !important;\n}\n\n.virtual-toggle {\n  padding-left:25px;\n  position: relative;\n  input {\n    opacity:0;\n    position:absolute;\n  }\n  &:after {\n    content:'';\n    height:16px;\n    width:16px;\n    border:1px solid #666;\n    position: absolute;\n    left:0;\n  }\n  &:before {\n    content:none;\n    margin-top: -3px;\n    position: absolute;\n    left:2px;\n    border-left: 2px solid #002740;\n    border-bottom: 2px solid #002740;\n    left: 4px;\n    top: 8px;\n    -ms-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    height: 5px;\n    width: 9px;\n\n  }\n  &.checked {\n    &:before {\n      content:'';\n    }\n  }\n}\n\n.virtual-label__small {\n  display: none;\n}\n\n.is-sticky {\n  .virtual-label__small {\n    display: block;\n  }\n  .virtual-toggle {\n    position: absolute;\n    right:-20px;\n    opacity:1 !important;\n    &:after {\n      top:0;\n    }\n  }\n  .virtual-label__large {\n    display: none;\n  }\n}\n",".wem__events-map {\n  flex-grow: 1;\n  display: none;\n  width: 100%;\n  height: 100%;\n  position: relative;\n\n  @media (min-width: 768px) {\n    display: block;\n  }\n}\n",".wem__events-map__marker, .wem__events-map__icon{\n  display: block;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  position: relative;\n  transform: translate(-10px, -10px);\n  transition: background-color 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out;\n  &.noshadow{\n    box-shadow:none;\n  }\n  &.is-active{\n    transform: translate(-10px,-10px) scale(1.2);\n    transform-origin: center center;\n  }\n}\n\n.wem__events-map__marker {\n  background-color: $primary;\n  border-radius: 100%;\n  border: 3px solid #fff;\n  box-shadow: 0 0 5px 0 rgba(#000, 0.1);\n  transition: background-color 0.3s ease-in-out;\n  &:hover,\n  &.is-active {\n    position: relative;\n    z-index: 9999;\n  }\n  &:hover{\n    background-color: $secondary;\n  }\n  &.is-active{\n    background-color: $secondary;\n    z-index: 99999;\n    position: relative;\n  }\n  &.is-active:hover{\n    z-index: 999999;\n    position: relative;\n  }\n}\n\n\n\n.wem__events-map__icon{\n  width: 19px;\n  height: 19px;\n  color: $primary;\n  box-shadow:none;\n  &:hover,\n  &.is-active {\n    position: relative;\n    z-index: 9999;\n  }\n  &:hover{\n    color: $secondary;\n  }\n  &.is-active{\n    color: $secondary;\n    z-index: 99999;\n    position: relative;\n  }\n  &.is-active:hover{\n    z-index: 999999;\n    position: relative;\n  }\n}","// colors\n$primary\t\t\t: #009cde;\n$primarylight\t\t: lighten($primary, 10%);\n$secondary\t\t\t: #ff6600;\n$secondarylight\t\t: lighten($secondary, 10%);\n$tertiary\t\t\t: #133346;\n$tertiarylight\t\t: lighten($tertiary, 10%);\n$quaternary\t\t\t: #1682b5;\n$quaternarylight\t: lighten($quaternary, 10%);\n$bodydark\t\t\t: #002740;\n$body\t\t\t\t: #333333;\n$bodysemi\t\t\t: #999999;\n$bodylight\t\t\t: #cccccc;\n$bodylightest\t\t: #fcfbfa;\n\n$hover\t\t\t: $quaternary;\n$hoverlight\t\t: $primary;\n\n// Header\n$header-height\t\t :  61px;\n$header-mobile-height:\t55px;\n\n// Navigation \n$navBackground\t: #fff;\n$navColor\t\t: $bodydark;\n$navColorHover\t: $primary;\n$dropDownBg\t\t: $bodydark;\n$dropDownColor\t: #fff;\n$dropDownHover\t: $primary;\n$socialColor\t: #999999;\n$socialHover\t: $secondary;\n\n// Splash Popup\n$splashBackground : #0f2142;\n\n// Default Box shadow. Set to zero if you want to remove shadow from buttons and boxes\n$boxShadowTop\t\t\t: 4px;\n$boxShadowLeft\t\t\t: 2px;\n$boxShadowBlur\t\t\t: 8px;\n$boxShadowColor\t\t\t: rgba(0,0,0,0.05);\n$boxShadowTopHover\t\t: 8px;\n$boxShadowLeftHover\t\t: 4px;\n$boxShadowBlurHover\t\t: 15px;\n$boxShadowColorHover\t: rgba(0,0,0,0.15);\n\n// Headlines\n$headlineColor  : $bodydark;\n$hrColor\t\t: $primary;\n \n// Social Media\n$facebook\t\t: #1682b5;\n$twitter\t\t: #00aced;\n$email\t\t\t: #cccccc;\n\n// breakpoints\n$bp-alpha\t\t: 320px;\n$bp-bravo\t\t: 480px;\n$bp-charlie\t\t: 768px;\n$bp-delta\t\t: 960px;\n$bp-bobby\t\t: 1100px;\n$bp-echo\t\t: 1250px;\n$bp-fin\t\t\t: 1350px;\n\n// fonts\n$primary-font\t: \"Sentinel SSm A\", \"Sentinel SSm B\", serif;\n$headline-font\t: 'Campton-Bold', sans-serif;\n\n// Fonts available: \n// font-family: \"Chivo\";\n// book = 400\n// bold = 700\n\n// font-family: \"Campton-Bold\";\n// bold = normal/400",".wem__events-panel {\n  background-color: #fff;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 0 20px rgba(#000, 0.3);\n  pointer-events: all !important;\n\n  @media (min-width: 768px) {\n    max-width: 50%;\n    min-height: 600px;\n  }\n\n}\n\n.wem__events-panel__content {\n  margin-top:-15px;\n  padding: 35px $panelPadding;\n\n  @media (min-width: 768px) {\n    margin-top:0;\n    padding: 85px 75px 12px;\n  }\n}\n\n.wem__events-panel__scrollable {\n  overflow-y: scroll;\n  position: relative;\n  &.--no-events{\n    flex: 1 0 auto;\n  }\n}\n\n.wem__events-panel__scrollmore{\n  align-items: center;\n  position: absolute;\n  bottom:0;\n  width: 100%;\n  opacity: 0.8;\n  transition: all 0.4s;\n  font-family: inherit;\n  justify-content: center;\n  background: $white;\n  padding: 10px;\n  pointer-events: none;\n  box-shadow: 0 0 20px rgba(#000, 0.3);\n  text-align: center;\n\n  &:before{\n    content: 'Scroll for more events';\n    display: inline-block;\n    font-size: 14px;\n    text-align: center;\n    pointer-events: none;\n\n    font-family: inherit;\n    font-weight: normal;\n  }\n  svg{\n    height: 12px;\n    width:12px;\n    opacity: 0.8;\n    text-align: center;\n    pointer-events: none;\n    transform: rotate(90deg);\n    margin-left:10px;\n    position: relative;\n    top:2px;\n  }\n  // &:after{\n  //   content:'';\n  //   background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 79 43.1' style='enable-background:new 0 0 79 43.1;' xml:space='preserve' role='img' aria-labelledby='down-arrow-title down-arrow-desc'%3E%3Cpolygon fill='%23000' stroke='%23000' stroke-width='3' class='st0' points='75.4,0 39.5,35.9 3.6,0 3.6,0 0,3.6 39.5,43.1 79,3.6 75.4,0 '%3E%3C/polygon%3E%3C/svg%3E\");\n  //   transform: rotate(90deg);\n  //   display: inline-block;\n  //   background-repeat: no-repeat;\n  //   background-position: center;\n  //   font-size: 14px;\n  //   height: 10px;\n  //   width:10px;\n  //   text-align: center;\n  //   pointer-events: none;\n  //   font-family: inherit;\n  //   font-weight: bold;\n  //   margin-left:10px;\n  //   position: relative;\n  //   top:-1px;\n  // }\n  .wem__events-panel:hover & {\n    pointer-events: none;\n    opacity: 0;\n  }\n\n  display:none;\n  @media (min-width: 768px) {\n    display:flex;\n  }\n\n  .wem__events-panel.--at-bottom &{\n    display: none !important;\n  }\n}\n\n.wem__events-panel__headline {\n  color: $headlineColor;\n  margin: 0 0 20px 0;\n  font-weight: bolder;\n}\n\n.wem__events-panel__description {\n  color: $body;\n  margin: 0 0 10px;\n}\n\n.wem_events-filters{\n  display: flex;\n  justify-content: flex-start;\n  margin-top:10px;\n  font-size: 14px;\n  background: #fff;\n  z-index: 999;\n  padding: 12px $panelPadding;\n  height: $searchFilterHeight;\n\n  @media (min-width: 768px) {\n    padding: 11px 75px;\n  }\n\n  position: sticky;\n  top:0;\n\n\n  .--sticky &{\n    padding-left: $panelPadding;\n    transition: padding-left 0.2s;\n    label{\n      opacity: 0;\n      transition: none;\n    }\n  }\n  .--near-sticky &{\n    label{\n      opacity: 0;\n      transition: opacity 0.1s;\n    }\n  }\n}\n\n$scrollSpacerHeight: $searchFilterHeight - 12px;\n\n.wem__events-panel__scroll-spacer{\n  height: 30px;\n  background: #fff;\n  border-bottom: 1px solid #ccc;\n  z-index:99;\n\n  @media (min-width: 768px) {\n    height: $scrollSpacerHeight;\n    position: sticky;\n    top: 12px + 1px;\n  }\n}\n\n.wem__events-panel__noevents{\n  padding: 60px;\n  text-align:center;\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-family: $headline-font;\n  font-size: 20px;\n  transform: translate(0, -27%);\n\n  button{\n    cursor: pointer;\n    display: block;\n    margin:20px auto 20px;\n    font-size: 14px;\n  }\n}\n\n\n.wem__events-panel-virtual{\n  .--sticky{\n    .wem__events-panel__content{\n      display: none;\n    }\n    .wem__events-panel__scroll-spacer{\n      height:1px;\n    }\n    .wem_events-filters{\n      margin-top:0;\n    }\n  }\n  .wem__filter label{\n    transition: none !important;\n  }\n}\n.wem__events-virtual-scroller{\n  position: absolute;\n  bottom: 0;\n  width:100%;\n  height:60%;\n  overflow-y: scroll;\n\n  .wem__event-card{\n    overflow: hidden;\n    min-height: 290px;\n  }\n  .wem__event-card__details{\n    display: flex;\n    flex-direction: column;\n  }\n  .wem__event-card__description{\n    flex: 1 0 auto;\n  }\n  @media (min-width: 768px) and (max-width: 1000px){\n    .--has-image .wem__event-card__description{\n      display:none;\n    }\n    .wem__event-actions{\n      position: relative;\n      min-width: 50vw;\n    }\n    .--has-image .wem__event-card__meta{\n      flex: 1 0 auto;\n    }\n  }\n  &.--is-full{\n    height: calc(100% - 55px) !important;\n  }\n}\n.wem__event__virtual{\n      font-size: 16px;\n    line-height: 16px;\n    font-family: Campton-Bold,sans-serif;\n    font-weight: 400;\n}",".wem__event-card {\n  background-color: #fff;\n  text-decoration: none;\n  color: #333;\n  display: flex;\n  padding: 35px 30px;\n  border-left: 0 solid $primary;\n  border-right: 10px solid transparent;\n  border-bottom: 1px solid #ccc;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  position: relative;\n  will-change: border-width;\n\n  &:hover {\n    background-color: #f7f7f7;\n    border-left-width: 10px;\n\n    // Need this to offset inner padding so text doesn't shift.\n    border-right-width: 0;\n  }\n\n  @media (min-width: 768px) {\n    padding: 35px 35px 35px 75px;\n  }\n  &:last-child{\n    border-bottom: 0;\n  }\n}\n\n\n$image-size: 30%;\n\n.wem__event-card__details{\n  flex: 1 1 auto;\n  max-width: 100%;\n  @include breakpoint($bp-charlie){\n    .--has-image & {\n      max-width: 100% - $image-size;\n      width: 70% - $image-size;\n    }\n  }\n}\n\n.wem__event-card__image{\n\n  display: none;\n  @include breakpoint($bp-charlie){\n    display: block;\n  }\n\n  flex: 1 0 $image-size;\n  max-height: calc(100% - 20px);\n  min-width:$image-size;\n  width: $image-size;\n  position: relative;\n  margin: 0 -20px 0 30px;\n  overflow: hidden;\n  img{\n    width:100%;\n    max-width:100%;\n    height: auto;\n    display: none;\n    position: absolute;\n\n    @include breakpoint($bp-charlie){\n      display: block;\n    }\n  }\n}\n\n.wem__event-card__date {\n  text-transform: uppercase;\n  margin: 0 0 8px;\n}\n\n.wem__event-card__title {\n  color: $primary;\n  margin: 0 0 10px 0;\n}\n\n.wem__event-card__meta {\n  font-weight: bold;\n  font-size: 0.9rem;\n  line-height: 1rem;\n  display: block;\n  font-family: $headline-font;\n}\n\n.wem__event-card__summary {\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.wem__event-card__description {\n  font-size: 16px;\n  line-height: 1.3;\n  margin: 0;\n\n  &.description-short{\n    display: none;\n  }\n\n  @media (max-width: 768px){\n    &.description-short{\n      display: none;\n    }\n    &.description-long{\n      display: block;\n    }\n  }\n  @media (min-width: 768px) and (max-width: 1100px){\n    &.description-short{\n      display: block;\n    }\n    &.description-long{\n      display: none;\n    }\n  }\n}\n",".wem__event-detail {\n  background-color: #fff;\n  color: #333;\n  width: 100%;\n  min-height: 500px;\n  padding: 65px 30px;\n  flex-grow: 1;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 0 20px rgba(#000, 0.3);\n  overflow-y: scroll;\n\n  @include breakpoint($bp-charlie){\n    max-width: 50%;\n    padding: 65px 75px;\n  }\n}\n\n.wem__event-detail__close {\n  background-color: #eee;\n  text-decoration: none;\n  font-size: 24px;\n  color: #333;\n  width: 38px;\n  height: 38px;\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  border: none;\n  border-radius: 100%;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  padding: 7px;\n\n  &:hover {\n    background-color: #fe0000;\n    color: #fff;\n  }\n  svg{\n    width:100%;\n    height:100%;\n    transform: scale(0.7);\n    transform-origin: center;\n    max-height: 20px;\n  }\n}\n\n.wem__event-detail__image{\n  padding: 0;\n  margin: 0;\n  img{\n    max-width: 100%;\n    display: block;\n  }\n}\n\n.wem__event-detail__date {\n  text-transform: uppercase;\n  margin: 0 0 20px 0;\n}\n\n.wem__event-detail__title {\n  margin: 0 0 10px 0;\n}\n\n.wem__event-detail__meta {\n  display: block;\n}\n\n\n.wem__event-detail__actions {\n  font-size: 0.9rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 10px 0 30px;\n}\n\n.wem__event-detail__action {\n  text-decoration: none;\n  font-weight: bold;\n  color: #fe0000;\n  transition: color 0.3s ease-in-out;\n\n  & + & {\n    margin-left: 10px;\n  }\n\n  &:hover {\n    color: darken(#fe0000, 10%);\n  }\n}\n\n\n.wem__event-detail__action-details{\n  color: #0166ff;\n}\n\n\n\n\n.wem__event-detail__content {\n  margin: 30px 0 0;\n  p:last-child{\n    margin-bottom:0;\n    margin-bottom: -0.1em;\n  }\n}\n\n.wem__event-detail__headline {\n  margin: 0 0 5px 0;\n}\n\n.wem__event-detail__headline + .wem__event-detail__paragraph {\n  margin-top: 5px;\n}\n\n\n.wem__event-detail__phone{\n  margin-top: 15px;\n}\n\n.wem_event-card__priority-icon{\n  color: $primary;\n  margin-left:-24px;\n  margin-top:-3px;\n  position: absolute;\n}","$thin-mobile-width: $bp-adams;\n\n\n.wem__event-actions {\n  font-size: 0.9rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-family: $headline-font;\n  @include breakpoint($thin-mobile-width){\n    justify-content: flex-start;\n  }\n  align-items: center;\n  margin: 10px 0 0;\n  flex-wrap: wrap;\n  .wem__event-detail &{\n    margin: 10px 0 20px;\n  }\n  .wem__event-card & {\n    @include breakpoint($bp-delta){\n      min-width: 100vw;\n    }\n  }\n}\n\n.wem__event-actions__url {\n  text-decoration: none;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 16px;\n  color: $secondary;\n  transition: color 0.3s ease-in-out;\n  white-space: nowrap;\n  margin-top:10px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n\n  svg{\n    height:11px;\n    line-height: 16px;\n    font-weight: bold;\n    display: inline-block;\n    vertical-align:middle;\n    padding-left: 10px;\n    // position: relative;\n    // top:-1.5px;\n    flex: 1 0 6px;\n    position: relative;\n    top: 0.5px;\n  }\n\n  @include breakpoint($thin-mobile-width){\n    & + & {\n      margin-left: 20px;\n    }\n  }\n\n\n  &:hover {\n    color: darken($secondary, 10%);\n  }\n}\n\n\n.wem__event-actions__url-details{\n  color: $primary;\n\n  &:hover {\n    color: darken($primary, 10%);\n  }\n}\n\n.wem__event-actions__social {\n  //flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  transition: .5s;\n  text-align:left;\n  margin-top:10px;\n  min-width: 57px;\n  display:none;\n  margin-left: auto;\n  text-align: right;\n  flex: 1 0 auto;\n  max-width: 90px;\n\n\n  @include breakpoint($thin-mobile-width){\n    display: flex;\n  }\n\n  @include breakpoint($bp-charlie){\n    opacity: 0;\n  }\n\n  .wem__event:hover & {\n    opacity: 1;\n  }\n\n  .wem__event-card & {\n    @include breakpoint($bp-charlie){\n      max-width: 80px;\n      margin-left: 30px;\n      justify-content: space-around;\n    }\n  }\n\n  .--no-url & {\n    margin-left: 0px;\n  }\n  .wem__event-detail & {\n    flex: 1 0 auto;\n    min-width: 10px;\n\n    @include breakpoint($thin-mobile-width){\n      a {\n        min-width: 10px;\n        text-align: right;\n      }\n    }\n    @include breakpoint($bp-adams-wide){\n      max-width: 120px;\n      a{\n        min-width: 25px;\n      }\n    }\n    @include breakpoint($bp-charlie){\n      max-width: 100px;\n    }\n\n  }\n}\n\n.wem__event-actions__social-link {\n  color: rgba(#000, 0.5);\n  margin-left: 10px;\n  position: relative;\n  transition: color 0.3s ease-in-out;\n  top:1px;\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n\n  &:hover {\n    color: #000;\n  }\n}\n",".wem_events-filters{\n  flex-wrap: wrap;\n}\n\n.wem__filter{\n  position: relative;\n\n  select,input{\n    padding: 4px 10px 4px 8px;\n  }\n  label{\n    font-family: $headline-font;\n    font-weight: bold;\n    color: $details;\n    margin-bottom: -4px;\n    position: absolute;\n    top: -27px;\n    transition: opacity .3s .8s;\n  }\n\n  flex: 1 0 49%;\n  @media (min-width: 768px) {\n    min-width: 40%;\n    flex: 1 0 40%;\n    max-width: 50%;\n  }\n  @media (max-width: 767px) {\n    max-width: calc(50% - 5px);\n  }\n}\n\n\n.wem__filter--category-section{\n  margin-right: 10px;\n  select{\n    appearance: menulist !important;\n    &:focus{\n      outline: none;\n    }\n  }\n}\n\n.wem__filter--date-section{\n  border-radius: 3px;\n  input {  }\n}\n\n.wem__filter--category-field, .wem__filter--date-field{\n  display:flex;\n  align-items: center;\n  height: 34px;\n  border: 1px solid #666;\n  border-radius: 3px;\n  top: -1px;\n  select, input{\n    height: 34px;\n    width:100%;\n  }\n\n}\n\n  .is-safari .wem__filter--category-field{\n    border: none;\n  }","\n\n\n@keyframes lds-dual-ring {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes lds-dual-ring {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.lds-dual-ring {\n  position: relative;\n}\n.lds-dual-ring div {\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 4px solid #000;\n  border-color: #cccccc transparent #cccccc transparent;\n  -webkit-animation: lds-dual-ring 0.7s linear infinite;\n  animation: lds-dual-ring 0.7s linear infinite;\n}\n\n$size: 100px;\n$half-size : $size/2;\n\n.lds-dual-ring {\n  width: $size !important;\n  height: $size !important;\n  -webkit-transform: translate(-$half-size, -$half-size) scale(1) translate($half-size, $half-size);\n  transform: translate(-$half-size, -$half-size) scale(1) translate($half-size, $half-size);\n}\n\n// @keyframes wem-spinning {\n//   from { transform: rotate(0deg); }\n//   to { transform: rotate(360deg); }\n// }\n\n// .wem__loader {\n//   width: 100%;\n//   height: 100%;\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n// }\n\n// .wem__loader__icon {\n//   font-size: 40px;\n//   color: #333;\n//   animation: wem-spinning 1s infinite linear;\n// }\n\n\n\n.wem__loader {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top:0;\n  left:0;\n  &.high{\n    z-index:99999;\n  }\n}\n\n.wem__loader__icon {\n  @extend .lds-dual-ring;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "a2Uu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "aS8y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("3bIi");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "ajCz":
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__("bjhr");
var isDate = __webpack_require__("CFBi");

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var parseTokenDateTimeDelimeter = /[T ]/;
var parseTokenPlainTime = /:/;

// year tokens
var parseTokenYY = /^(\d{2})$/;
var parseTokensYYY = [/^([+-]\d{2})$/, // 0 additional digits
/^([+-]\d{3})$/, // 1 additional digit
/^([+-]\d{4})$/ // 2 additional digits
];

var parseTokenYYYY = /^(\d{4})/;
var parseTokensYYYYY = [/^([+-]\d{4})/, // 0 additional digits
/^([+-]\d{5})/, // 1 additional digit
/^([+-]\d{6})/ // 2 additional digits
];

// date tokens
var parseTokenMM = /^-(\d{2})$/;
var parseTokenDDD = /^-?(\d{3})$/;
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
var parseTokenWww = /^-?W(\d{2})$/;
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/;
var parseTokenTimezoneZ = /^(Z)$/;
var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse(argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument !== 'string') {
    return new Date(argument);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits;
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
  } else {
    additionalDigits = Number(additionalDigits);
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE;
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime);
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
      var offsetDiff = getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) - getTimezoneOffsetInMilliseconds(fullTimeDate);
      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(argument);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(parseTokenDateTimeDelimeter);
  var timeString;

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits];
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  }

  // Invalid ISO-formatted year
  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date;
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date;
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week);
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek);
  }

  // Invalid ISO-formatted date
  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = parseTokenHH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR;
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  }

  // Invalid ISO-formatted time
  return null;
}

function parseTimezone(timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString);
  if (token) {
    return 0;
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  }

  return 0;
}

function dayOfISOYear(isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

module.exports = parse;

/***/ }),

/***/ "aos0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addPassiveEventListener;
// feature detection for passive support
// see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
function hasPassiveSupport() {
  var passiveSupported = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
}

function addPassiveEventListener(element, eventName, func, capture) {
  element.addEventListener(eventName, func, hasPassiveSupport() ? {
    capture: capture,
    passive: true
  } : capture);
}

/***/ }),

/***/ "b+X3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = function (props) {
  return _react2.default.createElement('div', { style: style }, _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true })));
};

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _google_map_markers = __webpack_require__("tGIC");

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var style = {
  width: '50%',
  height: '50%',
  left: '50%',
  top: '50%',
  // backgroundColor: 'red',
  margin: 0,
  padding: 0,
  position: 'absolute'
  // opacity: 0.3
};

/***/ }),

/***/ "b/WI":
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__("UV3R");

function buildFormatLocale() {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function MMM(date) {
      return months3char[date.getMonth()];
    },

    // Month: January, February, ..., December
    'MMMM': function MMMM(date) {
      return monthsFull[date.getMonth()];
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function dd(date) {
      return weekdays2char[date.getDay()];
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function ddd(date) {
      return weekdays3char[date.getDay()];
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function dddd(date) {
      return weekdaysFull[date.getDay()];
    },

    // AM, PM
    'A': function A(date) {
      return date.getHours() / 12 >= 1 ? meridiemUppercase[1] : meridiemUppercase[0];
    },

    // am, pm
    'a': function a(date) {
      return date.getHours() / 12 >= 1 ? meridiemLowercase[1] : meridiemLowercase[0];
    },

    // a.m., p.m.
    'aa': function aa(date) {
      return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0];
    }

    // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  };var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date));
    };
  });

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  };
}

function ordinal(number) {
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
}

module.exports = buildFormatLocale;

/***/ }),

/***/ "bGge":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? Number(dirtyOptions.weekStartsOn) || 0 : 0;

  var date = parse(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = startOfWeek;

/***/ }),

/***/ "bjhr":
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
};

/***/ }),

/***/ "ckno":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function clone() {
        return new Point(this.x, this.y);
    },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add: function add(p) {
        return this.clone()._add(p);
    },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub: function sub(p) {
        return this.clone()._sub(p);
    },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint: function multByPoint(p) {
        return this.clone()._multByPoint(p);
    },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint: function divByPoint(p) {
        return this.clone()._divByPoint(p);
    },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult: function mult(k) {
        return this.clone()._mult(k);
    },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div: function div(k) {
        return this.clone()._div(k);
    },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate: function rotate(a) {
        return this.clone()._rotate(a);
    },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround: function rotateAround(a, p) {
        return this.clone()._rotateAround(a, p);
    },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function matMult(m) {
        return this.clone()._matMult(m);
    },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit: function unit() {
        return this.clone()._unit();
    },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp: function perp() {
        return this.clone()._perp();
    },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round: function round() {
        return this.clone()._round();
    },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function mag() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function equals(other) {
        return this.x === other.x && this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function dist(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function distSqr(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function angle() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function angleTo(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function angleWith(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function angleWithSep(x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    },

    _matMult: function _matMult(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function _add(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function _sub(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function _mult(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function _div(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function _multByPoint(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function _divByPoint(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function _unit() {
        this._div(this.mag());
        return this;
    },

    _perp: function _perp() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function _rotate(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function _rotateAround(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function _round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};

/***/ }),

/***/ "dIHR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = isPlainObject;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

/***/ }),

/***/ "dLWn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = detectBrowser;
// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
var detectBrowserResult_ = null;

function detectBrowser() {
  if (detectBrowserResult_) {
    return detectBrowserResult_;
  }

  if (typeof navigator !== 'undefined') {
    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    var isSafari = navigator.userAgent.indexOf('Safari') > -1;

    if (isChrome && isSafari) {
      isSafari = false;
    }

    if (isChrome && isOpera) {
      isChrome = false;
    }

    detectBrowserResult_ = {
      isExplorer: isExplorer,
      isFirefox: isFirefox,
      isOpera: isOpera,
      isChrome: isChrome,
      isSafari: isSafari
    };
    return detectBrowserResult_;
  }

  detectBrowserResult_ = {
    isChrome: true,
    isExplorer: false,
    isFirefox: false,
    isOpera: false,
    isSafari: false
  };

  return detectBrowserResult_;
}

/***/ }),

/***/ "dZBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("nUiQ");

/***/ }),

/***/ "ddNZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}

/***/ }),

/***/ "dn2M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "eL1o":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("ajCz");
var startOfISOWeek = __webpack_require__("Rrov");
var startOfISOYear = __webpack_require__("z+C4");

var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  var date = parse(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = getISOWeek;

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_preact__, "createRef")) __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "feDp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__("2gTp");

var _invariant2 = _interopRequireDefault(_invariant);

var _latLng = __webpack_require__("v9xj");

var _createTree = __webpack_require__("GZEH");

var _createTree2 = _interopRequireDefault(_createTree);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var createCluster = function createCluster(x, y, points) {
  return {
    x: x, // cluster center
    y: y,
    wx: x, // weighted cluster center
    wy: y,
    zoom: Infinity, // the last zoom the cluster was processed at
    points: points,
    numPoints: points.length
  };
};

// squared distance between two points
function distSq(a, b) {
  var dx = a.wx - b.wx;
  var dy = a.wy - b.wy;
  return dx * dx + dy * dy;
}

function SuperCluster(options) {
  this.options = _extends({}, this.options, options);

  this._initTrees();
}

SuperCluster.prototype = {
  options: {
    minZoom: 0, // min zoom to generate clusters on
    maxZoom: 16, // max zoom level to cluster the points on
    radius: 40, // cluster radius in pixels
    extent: 512, // tile extent (radius is calculated relative to it)
    nodeSize: 16 },

  // size of the R-tree leaf node, affects performance
  load: function load(points) {
    // generate a cluster object for each point
    var clusters = points.map(function (_ref) {
      var pt = _objectWithoutProperties(_ref, []);

      var lat = _ref.lat;
      var lng = _ref.lng;
      return createCluster(lng, lat, [pt]);
    });

    // cluster points on max zoom, then cluster the results on previous zoom, etc.;
    // results in a cluster hierarchy across zoom levels
    for (var z = this.options.maxZoom; z >= this.options.minZoom; z--) {
      this.trees[z + 1].load(clusters); // index input points into an R-tree
      clusters = this._cluster(clusters, z); // create a new set of clusters for the zoom
    }
    this.trees[this.options.minZoom].load(clusters); // index top-level clusters

    return this;
  },
  getClusters: function getClusters(bbox, zoom) {
    var _this = this;

    var _bbox = _slicedToArray(bbox, 4);

    var nwLng = _bbox[0];
    var seLat = _bbox[1];
    var seLng = _bbox[2];
    var nwLat = _bbox[3];

    var z = Math.max(this.options.minZoom, Math.min(zoom, this.options.maxZoom + 1));
    var bBoxes = nwLng < seLng ? [bbox] : [[nwLng, seLat, 180, nwLat], [-180, seLat, seLng, nwLat]];

    var clusters = bBoxes.map(function (bBox) {
      return _this.trees[z].search(bBox);
    }).reduce(function (r, lst) {
      return [].concat(_toConsumableArray(r), _toConsumableArray(lst));
    }, []);

    return clusters;
  },
  _initTrees: function _initTrees() {
    this.trees = [];
    // make an R-Tree index for each zoom level
    for (var z = 0; z <= this.options.maxZoom + 1; z++) {
      this.trees[z] = (0, _createTree2.default)(this.options.nodeSize);
    }
  },
  _cluster: function _cluster(points, zoom) {
    var clusters = [];
    var r = (0, _latLng.screenDist2LatLngDist)(this.options.radius, zoom);
    var bbox = [0, 0, 0, 0];

    // loop through each point
    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      var clusterPoints = p.points;
      // if we've already visited the point at this zoom level, skip it
      if (p.zoom <= zoom) continue;
      p.zoom = zoom;

      // find all nearby points with a bbox search
      bbox[0] = p.wx - r;
      bbox[1] = p.wy - r;
      bbox[2] = p.wx + r;
      bbox[3] = p.wy + r;
      var bboxNeighbors = this.trees[zoom + 1].search(bbox);

      var foundNeighbors = false;
      var numPoints = p.numPoints;
      var wx = p.wx * numPoints;
      var wy = p.wy * numPoints;

      for (var j = 0; j < bboxNeighbors.length; j++) {
        var b = bboxNeighbors[j];
        // filter out neighbors that are too far or already processed
        if (zoom < b.zoom && distSq(p, b) <= r * r) {
          foundNeighbors = true;
          b.zoom = zoom; // save the zoom (so it doesn't get processed twice)
          wx += b.wx * b.numPoints; // accumulate coordinates for calculating weighted center
          wy += b.wy * b.numPoints;
          numPoints += b.numPoints;
          clusterPoints = [].concat(_toConsumableArray(clusterPoints), _toConsumableArray(b.points));
        }
      }

      if (!foundNeighbors) {
        clusters.push(p); // no neighbors, add a single point as cluster
        continue;
      }

      // form a cluster with neighbors
      var cluster = createCluster(p.x, p.y, clusterPoints);
      (0, _invariant2.default)(clusterPoints.length === numPoints, 'clusterPoints.length === numPoints');

      // save weighted cluster center for display
      cluster.wx = wx / numPoints;
      cluster.wy = wy / numPoints;

      clusters.push(cluster);
    }

    return clusters;
  }
};

var supercluster = function supercluster(points, options) {
  var cl = new SuperCluster(options);
  cl.load(points);

  return function (_ref2) {
    var _ref2$bounds = _ref2.bounds;
    var nw = _ref2$bounds.nw;
    var se = _ref2$bounds.se;
    var zoom = _ref2.zoom;
    return cl.getClusters([nw.lng, se.lat, se.lng, nw.lat], zoom);
  };
};

exports.default = supercluster;

/*
const cl = supercluster([
  { lat: 10, lng: 10 },
  { lat: 10.1, lng: 10.1 },
  { lat: 12, lng: 12 },
  { lat: 84, lng: 179 },
]);

const r = cl({ bounds: { nw: { lat: 85, lng: -180 }, se: { lat: -85, lng: 180 } }, zoom: 2 });

console.log(JSON.stringify(r));
*/

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "lJnv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _passiveEvents = __webpack_require__("aos0");

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Reliable `window` and `document` detection
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Check `document` and `window` in case of server-side rendering
/* eslint-disable */
/**
* Detect Element Resize.
* Forked in order to guard against unsafe 'window' and 'document' references.
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

var _window;
if (canUseDOM) {
  _window = window;
} else if (typeof self !== 'undefined') {
  _window = self;
} else {
  _window = undefined;
}

var attachEvent = typeof document !== 'undefined' && document.attachEvent;
var stylesCreated = false;

if (canUseDOM && !attachEvent) {
  var requestFrame = function () {
    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
      return _window.setTimeout(fn, 20);
    };
    return function (fn) {
      return raf(fn);
    };
  }();

  var cancelFrame = function () {
    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
    return function (id) {
      return cancel(id);
    };
  }();

  var resetTriggers = function resetTriggers(element) {
    var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
    contract.scrollLeft = contract.scrollWidth;
    contract.scrollTop = contract.scrollHeight;
    expandChild.style.width = expand.offsetWidth + 1 + 'px';
    expandChild.style.height = expand.offsetHeight + 1 + 'px';
    expand.scrollLeft = expand.scrollWidth;
    expand.scrollTop = expand.scrollHeight;
  };

  var checkTriggers = function checkTriggers(element) {
    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
  };

  var scrollListener = function scrollListener(e) {
    var element = this;
    resetTriggers(this);
    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
    this.__resizeRAF__ = requestFrame(function () {
      if (checkTriggers(element)) {
        element.__resizeLast__.width = element.offsetWidth;
        element.__resizeLast__.height = element.offsetHeight;
        element.__resizeListeners__.forEach(function (fn) {
          fn.call(element, e);
        });
      }
    });
  };

  /* Detect CSS Animations support to detect element display/re-attach */
  var animation = false,
      animationstring = 'animation',
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';

  if (canUseDOM) {
    var elm = document.createElement('fakeelement');
    if (elm.style.animationName !== undefined) {
      animation = true;
    }

    if (animation === false) {
      for (var i = 0; i < domPrefixes.length; i++) {
        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
          pfx = domPrefixes[i];
          animationstring = pfx + 'Animation';
          keyframeprefix = '-' + pfx.toLowerCase() + '-';
          animationstartevent = startEvents[i];
          animation = true;
          break;
        }
      }
    }
  }

  var animationName = 'resizeanim';
  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
}

var createStyles = function createStyles() {
  if (!stylesCreated) {
    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    stylesCreated = true;
  }
};

var addResizeListener = function addResizeListener(element, fn) {
  if (element.parentNode === undefined) {
    var tempParentDiv = document.createElement('div');
    element.parentNode = tempParentDiv;
  }
  element = element.parentNode;
  if (attachEvent) element.attachEvent('onresize', fn);else {
    if (!element.__resizeTriggers__) {
      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
      createStyles();
      element.__resizeLast__ = {};
      element.__resizeListeners__ = [];
      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
      element.appendChild(element.__resizeTriggers__);
      resetTriggers(element);

      (0, _passiveEvents2.default)(element, 'scroll', scrollListener, true);

      /* Listen for a css animation to detect element display/re-attach */
      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
        if (e.animationName == animationName) resetTriggers(element);
      });
    }
    element.__resizeListeners__.push(fn);
  }
};

var removeResizeListener = function removeResizeListener(element, fn) {
  element = element.parentNode;
  if (attachEvent) element.detachEvent('onresize', fn);else {
    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
    if (!element.__resizeListeners__.length) {
      element.removeEventListener('scroll', scrollListener);
      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
    }
  }
};

module.exports = {
  addResizeListener: addResizeListener,
  removeResizeListener: removeResizeListener
};

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "m+Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

if (!global.Promise) global.Promise = __webpack_require__("BtxX");
if (!global.fetch) global.fetch = __webpack_require__("VS7n");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "mI+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "mKb8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _pointGeometry = __webpack_require__("ckno");

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__("K2XS");

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _transform = __webpack_require__("X3LN");

var _transform2 = _interopRequireDefault(_transform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Geo = function () {
  function Geo(tileSize) {
    _classCallCheck(this, Geo);

    // left_top view пользует гугл
    // super();
    this.hasSize_ = false;
    this.hasView_ = false;
    this.transform_ = new _transform2.default(tileSize || 512);
  }

  Geo.prototype.setView = function setView(center, zoom, bearing) {
    this.transform_.center = _lat_lng2.default.convert(center);
    this.transform_.zoom = +zoom;
    this.transform_.bearing = +bearing;
    this.hasView_ = true;
  };

  Geo.prototype.setViewSize = function setViewSize(width, height) {
    this.transform_.width = width;
    this.transform_.height = height;
    this.hasSize_ = true;
  };

  Geo.prototype.setMapCanvasProjection = function setMapCanvasProjection(maps, mapCanvasProjection) {
    this.maps_ = maps;
    this.mapCanvasProjection_ = mapCanvasProjection;
  };

  Geo.prototype.canProject = function canProject() {
    return this.hasSize_ && this.hasView_;
  };

  Geo.prototype.hasSize = function hasSize() {
    return this.hasSize_;
  };

  /** Returns the pixel position relative to the map center. */

  Geo.prototype.fromLatLngToCenterPixel = function fromLatLngToCenterPixel(ptLatLng) {
    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
  };

  /**
   * Returns the pixel position relative to the map panes,
   * or relative to the map center if there are no panes.
   */

  Geo.prototype.fromLatLngToDivPixel = function fromLatLngToDivPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToDivPixel(latLng);
    }
    return this.fromLatLngToCenterPixel(ptLatLng);
  };

  /** Returns the pixel position relative to the map top-left. */

  Geo.prototype.fromLatLngToContainerPixel = function fromLatLngToContainerPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToContainerPixel(latLng);
    }

    var pt = this.fromLatLngToCenterPixel(ptLatLng);
    pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);

    pt.x += this.transform_.width / 2;
    pt.y += this.transform_.height / 2;

    return pt;
  };

  /** Returns the LatLng for the given offset from the map top-left. */

  Geo.prototype.fromContainerPixelToLatLng = function fromContainerPixelToLatLng(ptXY) {
    if (this.mapCanvasProjection_) {
      var latLng = this.mapCanvasProjection_.fromContainerPixelToLatLng(ptXY);
      return { lat: latLng.lat(), lng: latLng.lng() };
    }

    var ptxy = _extends({}, ptXY);
    ptxy.x -= this.transform_.width / 2;
    ptxy.y -= this.transform_.height / 2;
    var ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));

    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
    return ptRes;
  };

  Geo.prototype.getWidth = function getWidth() {
    return this.transform_.width;
  };

  Geo.prototype.getHeight = function getHeight() {
    return this.transform_.height;
  };

  Geo.prototype.getZoom = function getZoom() {
    return this.transform_.zoom;
  };

  Geo.prototype.getCenter = function getCenter() {
    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });

    return ptRes;
  };

  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
    var bndT = margins && margins[0] || 0;
    var bndR = margins && margins[1] || 0;
    var bndB = margins && margins[2] || 0;
    var bndL = margins && margins[3] || 0;

    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
      var topLeftCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: bndL - this.getWidth() / 2,
        y: bndT - this.getHeight() / 2
      }));
      var bottomRightCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: this.getWidth() / 2 - bndR,
        y: this.getHeight() / 2 - bndB
      }));

      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
      bottomRightCorner.lat, bottomRightCorner.lng, // SE
      bottomRightCorner.lat, topLeftCorner.lng, // SW
      topLeftCorner.lat, bottomRightCorner.lng];

      if (roundFactor) {
        res = res.map(function (r) {
          return Math.round(r * roundFactor) / roundFactor;
        });
      }
      return res;
    }

    return [0, 0, 0, 0];
  };

  return Geo;
}();

exports.default = Geo;

/***/ }),

/***/ "nUiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var bind = __webpack_require__("ED/T");
var Axios = __webpack_require__("OvAf");
var defaults = __webpack_require__("BXyq");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("mI+K");
axios.CancelToken = __webpack_require__("tsWd");
axios.isCancel = __webpack_require__("V3+0");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("X8jb");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "nqnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("RzPU")('createHashHistory');
module.exports = __webpack_require__("UJ0C").createHashHistory;

/***/ }),

/***/ "p/oJ":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "rj2i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "sGQd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var isEmpty = function isEmpty(val) {
  // check for empty object {}, array []
  if (val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    if (Object.keys(val).length === 0) {
      return true;
    }
  } else if (val === null || val === undefined || val === '') {
    // check for undefined, null and ""
    return true;
  }
  return false;
};

exports.default = isEmpty;

/***/ }),

/***/ "sIbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);

/***/ }),

/***/ "sdYq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _interopDefault(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}Object.defineProperty(exports, "__esModule", { value: !0 });var resolvePathname = _interopDefault(__webpack_require__("UAZL")),
    valueEqual = _interopDefault(__webpack_require__("Vvjq"));__webpack_require__("sIbj");var invariant = _interopDefault(__webpack_require__("1bfQ"));function _extends() {
  return (_extends = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];for (var a in e) {
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      }
    }return t;
  }).apply(this, arguments);
}function addLeadingSlash(t) {
  return "/" === t.charAt(0) ? t : "/" + t;
}function stripLeadingSlash(t) {
  return "/" === t.charAt(0) ? t.substr(1) : t;
}function hasBasename(t, n) {
  return 0 === t.toLowerCase().indexOf(n.toLowerCase()) && -1 !== "/?#".indexOf(t.charAt(n.length));
}function stripBasename(t, n) {
  return hasBasename(t, n) ? t.substr(n.length) : t;
}function stripTrailingSlash(t) {
  return "/" === t.charAt(t.length - 1) ? t.slice(0, -1) : t;
}function parsePath(t) {
  var n = t || "/",
      e = "",
      a = "",
      r = n.indexOf("#");-1 !== r && (a = n.substr(r), n = n.substr(0, r));var o = n.indexOf("?");return -1 !== o && (e = n.substr(o), n = n.substr(0, o)), { pathname: n, search: "?" === e ? "" : e, hash: "#" === a ? "" : a };
}function createPath(t) {
  var n = t.pathname,
      e = t.search,
      a = t.hash,
      r = n || "/";return e && "?" !== e && (r += "?" === e.charAt(0) ? e : "?" + e), a && "#" !== a && (r += "#" === a.charAt(0) ? a : "#" + a), r;
}function createLocation(t, n, e, a) {
  var r;"string" == typeof t ? (r = parsePath(t)).state = n : (void 0 === (r = _extends({}, t)).pathname && (r.pathname = ""), r.search ? "?" !== r.search.charAt(0) && (r.search = "?" + r.search) : r.search = "", r.hash ? "#" !== r.hash.charAt(0) && (r.hash = "#" + r.hash) : r.hash = "", void 0 !== n && void 0 === r.state && (r.state = n));try {
    r.pathname = decodeURI(r.pathname);
  } catch (t) {
    throw t instanceof URIError ? new URIError('Pathname "' + r.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : t;
  }return e && (r.key = e), a ? r.pathname ? "/" !== r.pathname.charAt(0) && (r.pathname = resolvePathname(r.pathname, a.pathname)) : r.pathname = a.pathname : r.pathname || (r.pathname = "/"), r;
}function locationsAreEqual(t, n) {
  return t.pathname === n.pathname && t.search === n.search && t.hash === n.hash && t.key === n.key && valueEqual(t.state, n.state);
}function createTransitionManager() {
  var o = null;var a = [];return { setPrompt: function setPrompt(t) {
      return o = t, function () {
        o === t && (o = null);
      };
    }, confirmTransitionTo: function confirmTransitionTo(t, n, e, a) {
      if (null != o) {
        var r = "function" == typeof o ? o(t, n) : o;"string" == typeof r ? "function" == typeof e ? e(r, a) : a(!0) : a(!1 !== r);
      } else a(!0);
    }, appendListener: function appendListener(t) {
      var n = !0;function e() {
        n && t.apply(void 0, arguments);
      }return a.push(e), function () {
        n = !1, a = a.filter(function (t) {
          return t !== e;
        });
      };
    }, notifyListeners: function notifyListeners() {
      for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
        n[e] = arguments[e];
      }a.forEach(function (t) {
        return t.apply(void 0, n);
      });
    } };
}var canUseDOM = !("undefined" == typeof window || !window.document || !window.document.createElement);function getConfirmation(t, n) {
  n(window.confirm(t));
}function supportsHistory() {
  var t = window.navigator.userAgent;return (-1 === t.indexOf("Android 2.") && -1 === t.indexOf("Android 4.0") || -1 === t.indexOf("Mobile Safari") || -1 !== t.indexOf("Chrome") || -1 !== t.indexOf("Windows Phone")) && window.history && "pushState" in window.history;
}function supportsPopStateOnHashChange() {
  return -1 === window.navigator.userAgent.indexOf("Trident");
}function supportsGoWithoutReloadUsingHash() {
  return -1 === window.navigator.userAgent.indexOf("Firefox");
}function isExtraneousPopstateEvent(t) {
  return void 0 === t.state && -1 === navigator.userAgent.indexOf("CriOS");
}var PopStateEvent = "popstate",
    HashChangeEvent = "hashchange";function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (t) {
    return {};
  }
}function createBrowserHistory(t) {
  void 0 === t && (t = {}), canUseDOM || invariant(!1);var s = window.history,
      c = supportsHistory(),
      n = !supportsPopStateOnHashChange(),
      e = t,
      a = e.forceRefresh,
      h = void 0 !== a && a,
      r = e.getUserConfirmation,
      u = void 0 === r ? getConfirmation : r,
      o = e.keyLength,
      i = void 0 === o ? 6 : o,
      f = t.basename ? stripTrailingSlash(addLeadingSlash(t.basename)) : "";function l(t) {
    var n = t || {},
        e = n.key,
        a = n.state,
        r = window.location,
        o = r.pathname + r.search + r.hash;return f && (o = stripBasename(o, f)), createLocation(o, a, e);
  }function d() {
    return Math.random().toString(36).substr(2, i);
  }var v = createTransitionManager();function p(t) {
    _extends(T, t), T.length = s.length, v.notifyListeners(T.location, T.action);
  }function g(t) {
    isExtraneousPopstateEvent(t) || w(l(t.state));
  }function P() {
    w(l(getHistoryState()));
  }var m = !1;function w(n) {
    if (m) m = !1, p();else {
      v.confirmTransitionTo(n, "POP", u, function (t) {
        t ? p({ action: "POP", location: n }) : function (t) {
          var n = T.location,
              e = H.indexOf(n.key);-1 === e && (e = 0);var a = H.indexOf(t.key);-1 === a && (a = 0);var r = e - a;r && (m = !0, L(r));
        }(n);
      });
    }
  }var y = l(getHistoryState()),
      H = [y.key];function x(t) {
    return f + createPath(t);
  }function L(t) {
    s.go(t);
  }var O = 0;function E(t) {
    1 === (O += t) && 1 === t ? (window.addEventListener(PopStateEvent, g), n && window.addEventListener(HashChangeEvent, P)) : 0 === O && (window.removeEventListener(PopStateEvent, g), n && window.removeEventListener(HashChangeEvent, P));
  }var S = !1;var T = { length: s.length, action: "POP", location: y, createHref: x, push: function push(t, n) {
      var i = createLocation(t, n, d(), T.location);v.confirmTransitionTo(i, "PUSH", u, function (t) {
        if (t) {
          var n = x(i),
              e = i.key,
              a = i.state;if (c) {
            if (s.pushState({ key: e, state: a }, null, n), h) window.location.href = n;else {
              var r = H.indexOf(T.location.key),
                  o = H.slice(0, r + 1);o.push(i.key), H = o, p({ action: "PUSH", location: i });
            }
          } else window.location.href = n;
        }
      });
    }, replace: function replace(t, n) {
      var o = "REPLACE",
          i = createLocation(t, n, d(), T.location);v.confirmTransitionTo(i, o, u, function (t) {
        if (t) {
          var n = x(i),
              e = i.key,
              a = i.state;if (c) {
            if (s.replaceState({ key: e, state: a }, null, n), h) window.location.replace(n);else {
              var r = H.indexOf(T.location.key);-1 !== r && (H[r] = i.key), p({ action: o, location: i });
            }
          } else window.location.replace(n);
        }
      });
    }, go: L, goBack: function goBack() {
      L(-1);
    }, goForward: function goForward() {
      L(1);
    }, block: function block(t) {
      void 0 === t && (t = !1);var n = v.setPrompt(t);return S || (E(1), S = !0), function () {
        return S && (S = !1, E(-1)), n();
      };
    }, listen: function listen(t) {
      var n = v.appendListener(t);return E(1), function () {
        E(-1), n();
      };
    } };return T;
}var HashChangeEvent$1 = "hashchange",
    HashPathCoders = { hashbang: { encodePath: function encodePath(t) {
      return "!" === t.charAt(0) ? t : "!/" + stripLeadingSlash(t);
    }, decodePath: function decodePath(t) {
      return "!" === t.charAt(0) ? t.substr(1) : t;
    } }, noslash: { encodePath: stripLeadingSlash, decodePath: addLeadingSlash }, slash: { encodePath: addLeadingSlash, decodePath: addLeadingSlash } };function stripHash(t) {
  var n = t.indexOf("#");return -1 === n ? t : t.slice(0, n);
}function getHashPath() {
  var t = window.location.href,
      n = t.indexOf("#");return -1 === n ? "" : t.substring(n + 1);
}function pushHashPath(t) {
  window.location.hash = t;
}function replaceHashPath(t) {
  window.location.replace(stripHash(window.location.href) + "#" + t);
}function createHashHistory(t) {
  void 0 === t && (t = {}), canUseDOM || invariant(!1);var n = window.history,
      e = (supportsGoWithoutReloadUsingHash(), t),
      a = e.getUserConfirmation,
      i = void 0 === a ? getConfirmation : a,
      r = e.hashType,
      o = void 0 === r ? "slash" : r,
      s = t.basename ? stripTrailingSlash(addLeadingSlash(t.basename)) : "",
      c = HashPathCoders[o],
      h = c.encodePath,
      u = c.decodePath;function f() {
    var t = u(getHashPath());return s && (t = stripBasename(t, s)), createLocation(t);
  }var l = createTransitionManager();function d(t) {
    _extends(E, t), E.length = n.length, l.notifyListeners(E.location, E.action);
  }var v = !1,
      p = null;function g() {
    var t = getHashPath(),
        n = h(t);if (t !== n) replaceHashPath(n);else {
      var e = f(),
          a = E.location;if (!v && function (t, n) {
        return t.pathname === n.pathname && t.search === n.search && t.hash === n.hash;
      }(a, e)) return;if (p === createPath(e)) return;p = null, function (n) {
        if (v) v = !1, d();else {
          l.confirmTransitionTo(n, "POP", i, function (t) {
            t ? d({ action: "POP", location: n }) : function (t) {
              var n = E.location,
                  e = y.lastIndexOf(createPath(n));-1 === e && (e = 0);var a = y.lastIndexOf(createPath(t));-1 === a && (a = 0);var r = e - a;r && (v = !0, H(r));
            }(n);
          });
        }
      }(e);
    }
  }var P = getHashPath(),
      m = h(P);P !== m && replaceHashPath(m);var w = f(),
      y = [createPath(w)];function H(t) {
    n.go(t);
  }var x = 0;function L(t) {
    1 === (x += t) && 1 === t ? window.addEventListener(HashChangeEvent$1, g) : 0 === x && window.removeEventListener(HashChangeEvent$1, g);
  }var O = !1;var E = { length: n.length, action: "POP", location: w, createHref: function createHref(t) {
      var n = document.querySelector("base"),
          e = "";return n && n.getAttribute("href") && (e = stripHash(window.location.href)), e + "#" + h(s + createPath(t));
    }, push: function push(t, n) {
      var o = createLocation(t, void 0, void 0, E.location);l.confirmTransitionTo(o, "PUSH", i, function (t) {
        if (t) {
          var n = createPath(o),
              e = h(s + n);if (getHashPath() !== e) {
            p = n, pushHashPath(e);var a = y.lastIndexOf(createPath(E.location)),
                r = y.slice(0, a + 1);r.push(n), y = r, d({ action: "PUSH", location: o });
          } else d();
        }
      });
    }, replace: function replace(t, n) {
      var r = "REPLACE",
          o = createLocation(t, void 0, void 0, E.location);l.confirmTransitionTo(o, r, i, function (t) {
        if (t) {
          var n = createPath(o),
              e = h(s + n);getHashPath() !== e && (p = n, replaceHashPath(e));var a = y.indexOf(createPath(E.location));-1 !== a && (y[a] = n), d({ action: r, location: o });
        }
      });
    }, go: H, goBack: function goBack() {
      H(-1);
    }, goForward: function goForward() {
      H(1);
    }, block: function block(t) {
      void 0 === t && (t = !1);var n = l.setPrompt(t);return O || (L(1), O = !0), function () {
        return O && (O = !1, L(-1)), n();
      };
    }, listen: function listen(t) {
      var n = l.appendListener(t);return L(1), function () {
        L(-1), n();
      };
    } };return E;
}function clamp(t, n, e) {
  return Math.min(Math.max(t, n), e);
}function createMemoryHistory(t) {
  void 0 === t && (t = {});var n = t,
      r = n.getUserConfirmation,
      e = n.initialEntries,
      a = void 0 === e ? ["/"] : e,
      o = n.initialIndex,
      i = void 0 === o ? 0 : o,
      s = n.keyLength,
      c = void 0 === s ? 6 : s,
      h = createTransitionManager();function u(t) {
    _extends(g, t), g.length = g.entries.length, h.notifyListeners(g.location, g.action);
  }function f() {
    return Math.random().toString(36).substr(2, c);
  }var l = clamp(i, 0, a.length - 1),
      d = a.map(function (t) {
    return createLocation(t, void 0, "string" == typeof t ? f() : t.key || f());
  }),
      v = createPath;function p(t) {
    var n = clamp(g.index + t, 0, g.entries.length - 1),
        e = g.entries[n];h.confirmTransitionTo(e, "POP", r, function (t) {
      t ? u({ action: "POP", location: e, index: n }) : u();
    });
  }var g = { length: d.length, action: "POP", location: d[l], index: l, entries: d, createHref: v, push: function push(t, n) {
      var a = createLocation(t, n, f(), g.location);h.confirmTransitionTo(a, "PUSH", r, function (t) {
        if (t) {
          var n = g.index + 1,
              e = g.entries.slice(0);e.length > n ? e.splice(n, e.length - n, a) : e.push(a), u({ action: "PUSH", location: a, index: n, entries: e });
        }
      });
    }, replace: function replace(t, n) {
      var e = "REPLACE",
          a = createLocation(t, n, f(), g.location);h.confirmTransitionTo(a, e, r, function (t) {
        t && (g.entries[g.index] = a, u({ action: e, location: a }));
      });
    }, go: p, goBack: function goBack() {
      p(-1);
    }, goForward: function goForward() {
      p(1);
    }, canGo: function canGo(t) {
      var n = g.index + t;return 0 <= n && n < g.entries.length;
    }, block: function block(t) {
      return void 0 === t && (t = !1), h.setPrompt(t);
    }, listen: function listen(t) {
      return h.appendListener(t);
    } };return g;
}exports.createBrowserHistory = createBrowserHistory, exports.createHashHistory = createHashHistory, exports.createMemoryHistory = createMemoryHistory, exports.createLocation = createLocation, exports.locationsAreEqual = locationsAreEqual, exports.parsePath = parsePath, exports.createPath = createPath;

/***/ }),

/***/ "tGIC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__("1Jly");

var _omit2 = _interopRequireDefault(_omit);

var _shallowEqual = __webpack_require__("CnKR");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// utils


var mainStyle = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var style = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  backgroundColor: 'transparent',
  position: 'absolute'
};

var GoogleMapMarkers = function (_Component) {
  _inherits(GoogleMapMarkers, _Component);

  /* eslint-disable react/forbid-prop-types */
  function GoogleMapMarkers(props) {
    _classCallCheck(this, GoogleMapMarkers);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getState = function () {
      return {
        children: _this.props.dispatcher.getChildren(),
        updateCounter: _this.props.dispatcher.getUpdateCounter()
      };
    };

    _this._onChangeHandler = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var prevChildCount = (_this.state.children || []).length;
      var state = _this._getState();

      _this.setState(state, function () {
        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
      });
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // click works only on hovered item
          _this.props.onChildClick(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseDown = function () {
      if (_this.props.onChildMouseDown) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // works only on hovered item
          _this.props.onChildMouseDown(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseEnter = function (hoverKey, childProps) {
      if (!_this.dimensionsCache_) {
        return;
      }

      if (_this.props.onChildMouseEnter) {
        _this.props.onChildMouseEnter(hoverKey, childProps);
      }

      _this.hoverChildProps_ = childProps;
      _this.hoverKey_ = hoverKey;
      _this.setState({ hoverKey: hoverKey });
    };

    _this._onChildMouseLeave = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var hoverKey = _this.hoverKey_;
      var childProps = _this.hoverChildProps_;

      if (hoverKey !== undefined && hoverKey !== null) {
        if (_this.props.onChildMouseLeave) {
          _this.props.onChildMouseLeave(hoverKey, childProps);
        }

        _this.hoverKey_ = null;
        _this.hoverChildProps_ = null;
        _this.setState({ hoverKey: null });
      }
    };

    _this._onMouseAllow = function (value) {
      if (!value) {
        _this._onChildMouseLeave();
      }

      _this.allowMouse_ = value;
    };

    _this._onMouseChangeHandler = function () {
      if (_this.allowMouse_) {
        _this._onMouseChangeHandlerRaf();
      }
    };

    _this._onMouseChangeHandlerRaf = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var mp = _this.props.dispatcher.getMousePosition();

      if (mp) {
        var distances = [];
        var hoverDistance = _this.props.getHoverDistance();

        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
          if (!child) return;
          // layers
          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
            return;
          }

          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
          var dist = _this.props.distanceToMouse(_this.dimensionsCache_[childKey], mp, child.props);
          if (dist < hoverDistance) {
            distances.push({
              key: childKey,
              dist: dist,
              props: child.props
            });
          }
        });

        if (distances.length) {
          distances.sort(function (a, b) {
            return a.dist - b.dist;
          });
          var hoverKey = distances[0].key;
          var childProps = distances[0].props;

          if (_this.hoverKey_ !== hoverKey) {
            _this._onChildMouseLeave();

            _this._onChildMouseEnter(hoverKey, childProps);
          }
        } else {
          _this._onChildMouseLeave();
        }
      } else {
        _this._onChildMouseLeave();
      }
    };

    _this._getDimensions = function (key) {
      var childKey = key;
      return _this.dimensionsCache_[childKey];
    };

    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);

    _this.dimensionsCache_ = {};
    _this.hoverKey_ = null;
    _this.hoverChildProps_ = null;
    _this.allowMouse_ = true;

    _this.state = _extends({}, _this._getState(), { hoverKey: null });
    return _this;
  }
  /* eslint-enable react/forbid-prop-types */

  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.experimental === true) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
    }

    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);

    this.dimensionsCache_ = null;
  };

  GoogleMapMarkers.prototype.render = function render() {
    var _this2 = this;

    var mainElementStyle = this.props.style || mainStyle;
    this.dimensionsCache_ = {};

    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
      if (!child) return undefined;
      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
        return _react2.default.cloneElement(child, {
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        });
      }

      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };

      var pt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(latLng) : _this2.props.geoService.fromLatLngToCenterPixel(latLng);

      var stylePtPos = {
        left: pt.x,
        top: pt.y
      };

      // If the component has a southeast corner defined (either as a LatLng, or a separate
      // lat and lng pair), set the width and height based on the distance between the northwest
      // and the southeast corner to lock the overlay to the correct geographic bounds.
      if (child.props.seLatLng !== undefined || child.props.seLat !== undefined && child.props.seLng !== undefined) {
        var seLatLng = child.props.seLatLng !== undefined ? child.props.seLatLng : { lat: child.props.seLat, lng: child.props.seLng };

        var sePt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(seLatLng) : _this2.props.geoService.fromLatLngToCenterPixel(seLatLng);

        stylePtPos.width = sePt.x - pt.x;
        stylePtPos.height = sePt.y - pt.y;
      }

      var containerPt = _this2.props.geoService.fromLatLngToContainerPixel(latLng);

      // to prevent rerender on child element i need to pass
      // const params $getDimensions and $dimensionKey instead of dimension object
      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;

      _this2.dimensionsCache_[childKey] = _extends({
        x: containerPt.x,
        y: containerPt.y
      }, latLng);

      return _react2.default.createElement('div', {
        key: childKey,
        style: _extends({}, style, stylePtPos),
        className: child.props.$markerHolderClassName
      }, _react2.default.cloneElement(child, {
        $hover: childKey === _this2.state.hoverKey,
        $getDimensions: _this2._getDimensions,
        $dimensionKey: childKey,
        $geoService: _this2.props.geoService,
        $onMouseAllow: _this2._onMouseAllow,
        $prerender: _this2.props.prerender
      }));
    });

    return _react2.default.createElement('div', { style: mainElementStyle }, markers);
  };

  return GoogleMapMarkers;
}(_react.Component);

GoogleMapMarkers.propTypes = {
  geoService: _propTypes2.default.any,
  style: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  dispatcher: _propTypes2.default.any,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  getHoverDistance: _propTypes2.default.func,
  insideMapPanes: _propTypes2.default.bool,
  prerender: _propTypes2.default.bool
};
GoogleMapMarkers.defaultProps = {
  insideMapPanes: false,
  prerender: false
};
exports.default = GoogleMapMarkers;

/***/ }),

/***/ "tMOH":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 (c) 2015, Vladimir Agafonkin
 RBush, a JavaScript library for high-performance 2D spatial indexing of points and rectangles.
 https://github.com/mourner/rbush
*/

(function () {
    'use strict';

    function rbush(maxEntries, format) {
        if (!(this instanceof rbush)) return new rbush(maxEntries, format);

        // max entries in a node is 9 by default; min node fill is 40% for best performance
        this._maxEntries = Math.max(4, maxEntries || 9);
        this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));

        if (format) {
            this._initFormat(format);
        }

        this.clear();
    }

    rbush.prototype = {

        all: function all() {
            return this._all(this.data, []);
        },

        search: function search(bbox) {

            var node = this.data,
                result = [],
                toBBox = this.toBBox;

            if (!intersects(bbox, node.bbox)) return result;

            var nodesToSearch = [],
                i,
                len,
                child,
                childBBox;

            while (node) {
                for (i = 0, len = node.children.length; i < len; i++) {

                    child = node.children[i];
                    childBBox = node.leaf ? toBBox(child) : child.bbox;

                    if (intersects(bbox, childBBox)) {
                        if (node.leaf) result.push(child);else if (contains(bbox, childBBox)) this._all(child, result);else nodesToSearch.push(child);
                    }
                }
                node = nodesToSearch.pop();
            }

            return result;
        },

        collides: function collides(bbox) {

            var node = this.data,
                toBBox = this.toBBox;

            if (!intersects(bbox, node.bbox)) return false;

            var nodesToSearch = [],
                i,
                len,
                child,
                childBBox;

            while (node) {
                for (i = 0, len = node.children.length; i < len; i++) {

                    child = node.children[i];
                    childBBox = node.leaf ? toBBox(child) : child.bbox;

                    if (intersects(bbox, childBBox)) {
                        if (node.leaf || contains(bbox, childBBox)) return true;
                        nodesToSearch.push(child);
                    }
                }
                node = nodesToSearch.pop();
            }

            return false;
        },

        load: function load(data) {
            if (!(data && data.length)) return this;

            if (data.length < this._minEntries) {
                for (var i = 0, len = data.length; i < len; i++) {
                    this.insert(data[i]);
                }
                return this;
            }

            // recursively build the tree with the given data from stratch using OMT algorithm
            var node = this._build(data.slice(), 0, data.length - 1, 0);

            if (!this.data.children.length) {
                // save as is if tree is empty
                this.data = node;
            } else if (this.data.height === node.height) {
                // split root if trees have the same height
                this._splitRoot(this.data, node);
            } else {
                if (this.data.height < node.height) {
                    // swap trees if inserted one is bigger
                    var tmpNode = this.data;
                    this.data = node;
                    node = tmpNode;
                }

                // insert the small tree into the large tree at appropriate level
                this._insert(node, this.data.height - node.height - 1, true);
            }

            return this;
        },

        insert: function insert(item) {
            if (item) this._insert(item, this.data.height - 1);
            return this;
        },

        clear: function clear() {
            this.data = {
                children: [],
                height: 1,
                bbox: empty(),
                leaf: true
            };
            return this;
        },

        remove: function remove(item) {
            if (!item) return this;

            var node = this.data,
                bbox = this.toBBox(item),
                path = [],
                indexes = [],
                i,
                parent,
                index,
                goingUp;

            // depth-first iterative tree traversal
            while (node || path.length) {

                if (!node) {
                    // go up
                    node = path.pop();
                    parent = path[path.length - 1];
                    i = indexes.pop();
                    goingUp = true;
                }

                if (node.leaf) {
                    // check current node
                    index = node.children.indexOf(item);

                    if (index !== -1) {
                        // item found, remove the item and condense tree upwards
                        node.children.splice(index, 1);
                        path.push(node);
                        this._condense(path);
                        return this;
                    }
                }

                if (!goingUp && !node.leaf && contains(node.bbox, bbox)) {
                    // go down
                    path.push(node);
                    indexes.push(i);
                    i = 0;
                    parent = node;
                    node = node.children[0];
                } else if (parent) {
                    // go right
                    i++;
                    node = parent.children[i];
                    goingUp = false;
                } else node = null; // nothing found
            }

            return this;
        },

        toBBox: function toBBox(item) {
            return item;
        },

        compareMinX: function compareMinX(a, b) {
            return a[0] - b[0];
        },
        compareMinY: function compareMinY(a, b) {
            return a[1] - b[1];
        },

        toJSON: function toJSON() {
            return this.data;
        },

        fromJSON: function fromJSON(data) {
            this.data = data;
            return this;
        },

        _all: function _all(node, result) {
            var nodesToSearch = [];
            while (node) {
                if (node.leaf) result.push.apply(result, node.children);else nodesToSearch.push.apply(nodesToSearch, node.children);

                node = nodesToSearch.pop();
            }
            return result;
        },

        _build: function _build(items, left, right, height) {

            var N = right - left + 1,
                M = this._maxEntries,
                node;

            if (N <= M) {
                // reached leaf level; return leaf
                node = {
                    children: items.slice(left, right + 1),
                    height: 1,
                    bbox: null,
                    leaf: true
                };
                calcBBox(node, this.toBBox);
                return node;
            }

            if (!height) {
                // target height of the bulk-loaded tree
                height = Math.ceil(Math.log(N) / Math.log(M));

                // target number of root entries to maximize storage utilization
                M = Math.ceil(N / Math.pow(M, height - 1));
            }

            node = {
                children: [],
                height: height,
                bbox: null,
                leaf: false
            };

            // split the items into M mostly square tiles

            var N2 = Math.ceil(N / M),
                N1 = N2 * Math.ceil(Math.sqrt(M)),
                i,
                j,
                right2,
                right3;

            multiSelect(items, left, right, N1, this.compareMinX);

            for (i = left; i <= right; i += N1) {

                right2 = Math.min(i + N1 - 1, right);

                multiSelect(items, i, right2, N2, this.compareMinY);

                for (j = i; j <= right2; j += N2) {

                    right3 = Math.min(j + N2 - 1, right2);

                    // pack each entry recursively
                    node.children.push(this._build(items, j, right3, height - 1));
                }
            }

            calcBBox(node, this.toBBox);

            return node;
        },

        _chooseSubtree: function _chooseSubtree(bbox, node, level, path) {

            var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;

            while (true) {
                path.push(node);

                if (node.leaf || path.length - 1 === level) break;

                minArea = minEnlargement = Infinity;

                for (i = 0, len = node.children.length; i < len; i++) {
                    child = node.children[i];
                    area = bboxArea(child.bbox);
                    enlargement = enlargedArea(bbox, child.bbox) - area;

                    // choose entry with the least area enlargement
                    if (enlargement < minEnlargement) {
                        minEnlargement = enlargement;
                        minArea = area < minArea ? area : minArea;
                        targetNode = child;
                    } else if (enlargement === minEnlargement) {
                        // otherwise choose one with the smallest area
                        if (area < minArea) {
                            minArea = area;
                            targetNode = child;
                        }
                    }
                }

                node = targetNode || node.children[0];
            }

            return node;
        },

        _insert: function _insert(item, level, isNode) {

            var toBBox = this.toBBox,
                bbox = isNode ? item.bbox : toBBox(item),
                insertPath = [];

            // find the best node for accommodating the item, saving all nodes along the path too
            var node = this._chooseSubtree(bbox, this.data, level, insertPath);

            // put the item into the node
            node.children.push(item);
            extend(node.bbox, bbox);

            // split on node overflow; propagate upwards if necessary
            while (level >= 0) {
                if (insertPath[level].children.length > this._maxEntries) {
                    this._split(insertPath, level);
                    level--;
                } else break;
            }

            // adjust bboxes along the insertion path
            this._adjustParentBBoxes(bbox, insertPath, level);
        },

        // split overflowed node into two
        _split: function _split(insertPath, level) {

            var node = insertPath[level],
                M = node.children.length,
                m = this._minEntries;

            this._chooseSplitAxis(node, m, M);

            var splitIndex = this._chooseSplitIndex(node, m, M);

            var newNode = {
                children: node.children.splice(splitIndex, node.children.length - splitIndex),
                height: node.height,
                bbox: null,
                leaf: false
            };

            if (node.leaf) newNode.leaf = true;

            calcBBox(node, this.toBBox);
            calcBBox(newNode, this.toBBox);

            if (level) insertPath[level - 1].children.push(newNode);else this._splitRoot(node, newNode);
        },

        _splitRoot: function _splitRoot(node, newNode) {
            // split root node
            this.data = {
                children: [node, newNode],
                height: node.height + 1,
                bbox: null,
                leaf: false
            };
            calcBBox(this.data, this.toBBox);
        },

        _chooseSplitIndex: function _chooseSplitIndex(node, m, M) {

            var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;

            minOverlap = minArea = Infinity;

            for (i = m; i <= M - m; i++) {
                bbox1 = distBBox(node, 0, i, this.toBBox);
                bbox2 = distBBox(node, i, M, this.toBBox);

                overlap = intersectionArea(bbox1, bbox2);
                area = bboxArea(bbox1) + bboxArea(bbox2);

                // choose distribution with minimum overlap
                if (overlap < minOverlap) {
                    minOverlap = overlap;
                    index = i;

                    minArea = area < minArea ? area : minArea;
                } else if (overlap === minOverlap) {
                    // otherwise choose distribution with minimum area
                    if (area < minArea) {
                        minArea = area;
                        index = i;
                    }
                }
            }

            return index;
        },

        // sorts node children by the best axis for split
        _chooseSplitAxis: function _chooseSplitAxis(node, m, M) {

            var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
                compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
                xMargin = this._allDistMargin(node, m, M, compareMinX),
                yMargin = this._allDistMargin(node, m, M, compareMinY);

            // if total distributions margin value is minimal for x, sort by minX,
            // otherwise it's already sorted by minY
            if (xMargin < yMargin) node.children.sort(compareMinX);
        },

        // total margin of all possible split distributions where each node is at least m full
        _allDistMargin: function _allDistMargin(node, m, M, compare) {

            node.children.sort(compare);

            var toBBox = this.toBBox,
                leftBBox = distBBox(node, 0, m, toBBox),
                rightBBox = distBBox(node, M - m, M, toBBox),
                margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
                i,
                child;

            for (i = m; i < M - m; i++) {
                child = node.children[i];
                extend(leftBBox, node.leaf ? toBBox(child) : child.bbox);
                margin += bboxMargin(leftBBox);
            }

            for (i = M - m - 1; i >= m; i--) {
                child = node.children[i];
                extend(rightBBox, node.leaf ? toBBox(child) : child.bbox);
                margin += bboxMargin(rightBBox);
            }

            return margin;
        },

        _adjustParentBBoxes: function _adjustParentBBoxes(bbox, path, level) {
            // adjust bboxes along the given tree path
            for (var i = level; i >= 0; i--) {
                extend(path[i].bbox, bbox);
            }
        },

        _condense: function _condense(path) {
            // go through the path, removing empty nodes and updating bboxes
            for (var i = path.length - 1, siblings; i >= 0; i--) {
                if (path[i].children.length === 0) {
                    if (i > 0) {
                        siblings = path[i - 1].children;
                        siblings.splice(siblings.indexOf(path[i]), 1);
                    } else this.clear();
                } else calcBBox(path[i], this.toBBox);
            }
        },

        _initFormat: function _initFormat(format) {
            // data format (minX, minY, maxX, maxY accessors)

            // uses eval-type function compilation instead of just accepting a toBBox function
            // because the algorithms are very sensitive to sorting functions performance,
            // so they should be dead simple and without inner calls

            var compareArr = ['return a', ' - b', ';'];

            this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
            this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));

            this.toBBox = new Function('a', 'return [a' + format.join(', a') + '];');
        }
    };

    // calculate node's bbox from bboxes of its children
    function calcBBox(node, toBBox) {
        node.bbox = distBBox(node, 0, node.children.length, toBBox);
    }

    // min bounding rectangle of node children from k to p-1
    function distBBox(node, k, p, toBBox) {
        var bbox = empty();

        for (var i = k, child; i < p; i++) {
            child = node.children[i];
            extend(bbox, node.leaf ? toBBox(child) : child.bbox);
        }

        return bbox;
    }

    function empty() {
        return [Infinity, Infinity, -Infinity, -Infinity];
    }

    function extend(a, b) {
        a[0] = Math.min(a[0], b[0]);
        a[1] = Math.min(a[1], b[1]);
        a[2] = Math.max(a[2], b[2]);
        a[3] = Math.max(a[3], b[3]);
        return a;
    }

    function compareNodeMinX(a, b) {
        return a.bbox[0] - b.bbox[0];
    }
    function compareNodeMinY(a, b) {
        return a.bbox[1] - b.bbox[1];
    }

    function bboxArea(a) {
        return (a[2] - a[0]) * (a[3] - a[1]);
    }
    function bboxMargin(a) {
        return a[2] - a[0] + (a[3] - a[1]);
    }

    function enlargedArea(a, b) {
        return (Math.max(b[2], a[2]) - Math.min(b[0], a[0])) * (Math.max(b[3], a[3]) - Math.min(b[1], a[1]));
    }

    function intersectionArea(a, b) {
        var minX = Math.max(a[0], b[0]),
            minY = Math.max(a[1], b[1]),
            maxX = Math.min(a[2], b[2]),
            maxY = Math.min(a[3], b[3]);

        return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
    }

    function contains(a, b) {
        return a[0] <= b[0] && a[1] <= b[1] && b[2] <= a[2] && b[3] <= a[3];
    }

    function intersects(a, b) {
        return b[0] <= a[2] && b[1] <= a[3] && b[2] >= a[0] && b[3] >= a[1];
    }

    // sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
    // combines selection algorithm with binary divide & conquer approach

    function multiSelect(arr, left, right, n, compare) {
        var stack = [left, right],
            mid;

        while (stack.length) {
            right = stack.pop();
            left = stack.pop();

            if (right - left <= n) continue;

            mid = left + Math.ceil((right - left) / n / 2) * n;
            select(arr, left, right, mid, compare);

            stack.push(left, mid, mid, right);
        }
    }

    // Floyd-Rivest selection algorithm:
    // sort an array between left and right (inclusive) so that the smallest k elements come first (unordered)
    function select(arr, left, right, k, compare) {
        var n, i, z, s, sd, newLeft, newRight, t, j;

        while (right > left) {
            if (right - left > 600) {
                n = right - left + 1;
                i = k - left + 1;
                z = Math.log(n);
                s = 0.5 * Math.exp(2 * z / 3);
                sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (i - n / 2 < 0 ? -1 : 1);
                newLeft = Math.max(left, Math.floor(k - i * s / n + sd));
                newRight = Math.min(right, Math.floor(k + (n - i) * s / n + sd));
                select(arr, newLeft, newRight, k, compare);
            }

            t = arr[k];
            i = left;
            j = right;

            swap(arr, left, k);
            if (compare(arr[right], t) > 0) swap(arr, left, right);

            while (i < j) {
                swap(arr, i, j);
                i++;
                j--;
                while (compare(arr[i], t) < 0) {
                    i++;
                }while (compare(arr[j], t) > 0) {
                    j--;
                }
            }

            if (compare(arr[left], t) === 0) swap(arr, left, j);else {
                j++;
                swap(arr, j, right);
            }

            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
    }

    function swap(arr, i, j) {
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }

    // export as AMD/CommonJS module or global variable
    if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return rbush;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if (typeof module !== 'undefined') module.exports = rbush;else if (typeof self !== 'undefined') self.rbush = rbush;else window.rbush = rbush;
})();

/***/ }),

/***/ "tsWd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("mI+K");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),

/***/ "uWKE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}

/***/ }),

/***/ "uz6X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");
var transformData = __webpack_require__("woEt");
var isCancel = __webpack_require__("V3+0");
var defaults = __webpack_require__("BXyq");
var isAbsoluteURL = __webpack_require__("7/2Y");
var combineURLs = __webpack_require__("a2Uu");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "v9xj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// longitude/latitude to spherical mercator in [0..1] range
var lngX = exports.lngX = function lngX(lng) {
  return lng / 360 + 0.5;
};

var latY = exports.latY = function latY(lat) {
  var sin = Math.sin(lat * Math.PI / 180);
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;

  return y < 0 ? 0 : y > 1 ? 1 : y;
};

var TILE_SIZE = 256;

var screenDist2LatLngDist = exports.screenDist2LatLngDist = function screenDist2LatLngDist(dist, zoom) {
  var scale = Math.pow(2, zoom);
  var distW = dist / scale / TILE_SIZE;
  var distLatLng = distW * 360;
  return distLatLng;
};

/*
// spherical mercator to longitude/latitude
export const xLng = (x) => (x - 0.5) * 360;

export const yLat = (y) =>
  360 * Math.atan(Math.exp((180 - y * 360) * Math.PI / 180)) / Math.PI - 90;
*/

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "woEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("S1cf");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),

/***/ "x3VB":
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__("CFBi");

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate);
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date');
  }
}

module.exports = isValid;

/***/ }),

/***/ "z+C4":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("7L22");
var startOfISOWeek = __webpack_require__("Rrov");

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear(dirtyDate) {
  var year = getISOYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

module.exports = startOfISOYear;

/***/ }),

/***/ "zroV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
  var positions = _ref.positions;
  return new instance.visualization.HeatmapLayer({
    data: positions.reduce(function (acc, _ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng,
          _ref2$weight = _ref2.weight,
          weight = _ref2$weight === undefined ? 1 : _ref2$weight;

      acc.push({
        location: new instance.LatLng(lat, lng),
        weight: weight
      });
      return acc;
    }, [])
  });
};

var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === undefined ? {} : _ref3$options;
  return Object.keys(options).map(function (option) {
    return instance.set(option, options[option]);
  });
};

/***/ }),

/***/ "zszy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("eW0v");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _google_map_map = __webpack_require__("3f5l");

var _google_map_map2 = _interopRequireDefault(_google_map_map);

var _marker_dispatcher = __webpack_require__("2xOb");

var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);

var _google_map_markers = __webpack_require__("tGIC");

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

var _google_map_markers_prerender = __webpack_require__("b+X3");

var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);

var _google_heatmap = __webpack_require__("zroV");

var _google_map_loader = __webpack_require__("TKCF");

var _google_map_loader2 = _interopRequireDefault(_google_map_loader);

var _geo = __webpack_require__("mKb8");

var _geo2 = _interopRequireDefault(_geo);

var _raf = __webpack_require__("MoY7");

var _raf2 = _interopRequireDefault(_raf);

var _pick = __webpack_require__("UJg9");

var _pick2 = _interopRequireDefault(_pick);

var _omit = __webpack_require__("1Jly");

var _omit2 = _interopRequireDefault(_omit);

var _log = __webpack_require__("2aWH");

var _log2 = _interopRequireDefault(_log);

var _isEmpty = __webpack_require__("sGQd");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNumber = __webpack_require__("LcGr");

var _isNumber2 = _interopRequireDefault(_isNumber);

var _detect = __webpack_require__("dLWn");

var _detect2 = _interopRequireDefault(_detect);

var _shallowEqual = __webpack_require__("CnKR");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _isPlainObject = __webpack_require__("dIHR");

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArraysEqualEps = __webpack_require__("ddNZ");

var _isArraysEqualEps2 = _interopRequireDefault(_isArraysEqualEps);

var _detectElementResize = __webpack_require__("lJnv");

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

var _passiveEvents = __webpack_require__("aos0");

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */

// helpers


// loaders


// utils


// consts
var kEPS = 0.00001;
var K_GOOGLE_TILE_SIZE = 256;
// real minZoom calculated here _getMinZoom
var K_IDLE_TIMEOUT = 100;
var K_IDLE_CLICK_TIMEOUT = 300;
var DEFAULT_MIN_ZOOM = 3;
// Starting with version 3.32, the maps API calls `draw()` each frame during
// a zoom animation.
var DRAW_CALLED_DURING_ANIMATION_VERSION = 32;
var IS_REACT_16 = _reactDom2.default.createPortal !== undefined;

var createPortal = IS_REACT_16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function defaultOptions_() /* maps */{
  return {
    overviewMapControl: false,
    streetViewControl: false,
    rotateControl: true,
    mapTypeControl: false,
    // disable poi
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    }],
    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
  };
}

var latLng2Obj = function latLng2Obj(latLng) {
  return (0, _isPlainObject2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
};

var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
  if (false) {
    if (zoom < minZoom) {
      console.warn('GoogleMap: ' + // eslint-disable-line
      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
    }
  }

  if (minZoom < zoom) {
    return zoom;
  }
  return minZoom;
};

var isFullScreen = function isFullScreen() {
  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
};

var GoogleMap = function (_Component) {
  _inherits(GoogleMap, _Component);

  // eslint-disable-line

  function GoogleMap(props) {
    _classCallCheck(this, GoogleMap);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getMinZoom = function () {
      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
        return Math.ceil((0, _log2.default)(maxTilesPerDim));
      }
      return DEFAULT_MIN_ZOOM;
    };

    _this._computeMinZoom = function (minZoom) {
      if (!(0, _isEmpty2.default)(minZoom)) {
        return minZoom;
      }
      return _this._getMinZoom();
    };

    _this._mapDomResizeCallback = function () {
      _this.resetSizeOnIdle_ = true;
      if (_this.maps_) {
        var originalCenter = _this.props.center || _this.props.defaultCenter;
        var currentCenter = _this.map_.getCenter();
        _this.maps_.event.trigger(_this.map_, 'resize');
        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
      }
    };

    _this._setLayers = function (layerTypes) {
      layerTypes.forEach(function (layerType) {
        _this.layers_[layerType] = new _this.maps_[layerType]();
        _this.layers_[layerType].setMap(_this.map_);
      });
    };

    _this._renderPortal = function () {
      return _react2.default.createElement(_google_map_markers2.default, {
        experimental: _this.props.experimental,
        onChildClick: _this._onChildClick,
        onChildMouseDown: _this._onChildMouseDown,
        onChildMouseEnter: _this._onChildMouseEnter,
        onChildMouseLeave: _this._onChildMouseLeave,
        geoService: _this.geoService_,
        insideMapPanes: true,
        distanceToMouse: _this.props.distanceToMouse,
        getHoverDistance: _this._getHoverDistance,
        dispatcher: _this.markersDispatcher_
      });
    };

    _this._initMap = function () {
      // only initialize the map once
      if (_this.initialized_) {
        return;
      }
      _this.initialized_ = true;

      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);

      _this._onBoundsChanged(); // now we can calculate map bounds center etc...

      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);

      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
        if (!_this.mounted_) {
          return;
        }

        var centerLatLng = _this.geoService_.getCenter();

        var propsOptions = {
          zoom: _this.props.zoom || _this.props.defaultZoom,
          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
        };

        // Start Heatmap
        if (_this.props.heatmap.positions) {
          _extends2(_this, {
            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
          });
          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
        }
        // End Heatmap

        // prevent to exapose full api
        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
        // "SymbolPath", "ZoomControlStyle",
        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
        // "DistanceMatrixStatus",
        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
        // "GeocoderStatus", "KmlLayerStatus",
        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
        // "TravelMode", "UnitSystem"
        var mapPlainObjects = (0, _pick2.default)(maps, _isPlainObject2.default);
        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
        var defaultOptions = defaultOptions_(mapPlainObjects);

        var draggableOptions = !(0, _isEmpty2.default)(_this.props.draggable) && {
          draggable: _this.props.draggable
        };

        var minZoom = _this._computeMinZoom(options.minZoom);
        _this.minZoom_ = minZoom;

        var preMapOptions = _extends({}, defaultOptions, {
          minZoom: minZoom
        }, options, propsOptions);

        _this.defaultDraggableOption_ = !(0, _isEmpty2.default)(preMapOptions.draggable) ? preMapOptions.draggable : _this.defaultDraggableOption_;

        var mapOptions = _extends({}, preMapOptions, draggableOptions);

        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);

        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);

        _this.map_ = map;
        _this.maps_ = maps;

        _this._setLayers(_this.props.layerTypes);

        // Parse `google.maps.version` to capture the major version number.
        var versionMatch = maps.version.match(/^3\.(\d+)\./);
        // The major version is the first (and only) captured group.
        var mapsVersion = versionMatch && Number(versionMatch[1]);

        // render in overlay
        var this_ = _this;
        var overlay = _extends2(new maps.OverlayView(), {
          onAdd: function onAdd() {
            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';

            var div = document.createElement('div');
            div.style.backgroundColor = 'transparent';
            div.style.position = 'absolute';
            div.style.left = '0px';
            div.style.top = '0px';
            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
            div.style.height = K_MAX_HEIGHT;

            if (this_.props.overlayViewDivStyle) {
              var overlayViewDivStyle = this_.props.overlayViewDivStyle;

              if ((typeof overlayViewDivStyle === 'undefined' ? 'undefined' : _typeof(overlayViewDivStyle)) === 'object') {
                Object.keys(overlayViewDivStyle).forEach(function (property) {
                  div.style[property] = overlayViewDivStyle[property];
                });
              }
            }

            var panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(div);
            this_.geoService_.setMapCanvasProjection(maps, overlay.getProjection());

            if (!IS_REACT_16) {
              createPortal(this_, this_._renderPortal(), div,
              // remove prerendered markers
              function () {
                return this_.setState({ overlay: div });
              });
            } else {
              this_.setState({ overlay: div });
            }
          },
          onRemove: function onRemove() {
            var renderedOverlay = this_.state.overlay;
            if (renderedOverlay && !IS_REACT_16) {
              _reactDom2.default.unmountComponentAtNode(renderedOverlay);
            }
            this_.setState({ overlay: null });
          },
          draw: function draw() {
            this_.updateCounter_++;
            this_._onBoundsChanged(map, maps, !this_.props.debounced);

            if (!this_.googleApiLoadedCalled_) {
              this_._onGoogleApiLoaded({ map: map, maps: maps, ref: this_.googleMapDom_ });
              this_.googleApiLoadedCalled_ = true;
            }

            if (this_.mouse_) {
              var latLng = this_.geoService_.fromContainerPixelToLatLng(this_.mouse_);
              this_.mouse_.lat = latLng.lat;
              this_.mouse_.lng = latLng.lng;
            }

            this_._onChildMouseMove();

            if (this_.markersDispatcher_) {
              this_.markersDispatcher_.emit('kON_CHANGE');
              if (this_.fireMouseEventOnIdle_) {
                this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
              }
            }
          }
        });

        _this.overlay_ = overlay;

        overlay.setMap(map);
        if (_this.props.heatmap.positions) {
          _this.heatmap.setMap(map);
        }

        if (_this.props.onTilesLoaded) {
          maps.event.addListener(map, 'tilesloaded', function () {
            this_._onTilesLoaded();
          });
        }

        maps.event.addListener(map, 'zoom_changed', function () {
          // recalc position at zoom start
          if (this_.geoService_.getZoom() !== map.getZoom()) {
            if (!this_.zoomAnimationInProgress_) {
              this_.zoomAnimationInProgress_ = true;
              this_._onZoomAnimationStart(map.zoom);
            }

            // If draw() is not called each frame during a zoom animation,
            // simulate it.
            if (mapsVersion < DRAW_CALLED_DURING_ANIMATION_VERSION) {
              var TIMEOUT_ZOOM = 300;

              if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
                // there is strange Google Map Api behavior in chrome when zoom animation of map
                // is started only on second raf call, if was click on zoom control
                // or +- keys pressed, so i wait for two rafs before change state

                // this does not fully prevent animation jump
                // but reduce it's occurence probability
                (0, _raf2.default)(function () {
                  return (0, _raf2.default)(function () {
                    this_.updateCounter_++;
                    this_._onBoundsChanged(map, maps);
                  });
                });
              } else {
                this_.updateCounter_++;
                this_._onBoundsChanged(map, maps);
              }
            }
          }
        });

        maps.event.addListener(map, 'idle', function () {
          if (_this.resetSizeOnIdle_) {
            _this._setViewSize();
            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);

            if (currMinZoom !== _this.minZoom_) {
              _this.minZoom_ = currMinZoom;
              map.setOptions({ minZoom: currMinZoom });
            }

            _this.resetSizeOnIdle_ = false;
          }

          if (this_.zoomAnimationInProgress_) {
            this_.zoomAnimationInProgress_ = false;
            this_._onZoomAnimationEnd(map.zoom);
          }

          this_.updateCounter_++;
          this_._onBoundsChanged(map, maps);

          this_.dragTime_ = 0;

          if (this_.markersDispatcher_) {
            this_.markersDispatcher_.emit('kON_CHANGE');
          }
        });

        maps.event.addListener(map, 'mouseover', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = true;
        });

        // an alternative way to know the mouse is back within the map
        // This would not fire when clicking/interacting with google maps
        // own on-map countrols+markers. This handles an edge case for touch devices
        // + 'draggable:false' custom option. See #332 for more details.
        maps.event.addListener(map, 'click', function () {
          this_.mouseInMap_ = true;
        });

        maps.event.addListener(map, 'mouseout', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = false;
          this_.mouse_ = null;
          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        });

        maps.event.addListener(map, 'drag', function () {
          this_.dragTime_ = new Date().getTime();
          this_._onDrag(map);
        });

        maps.event.addListener(map, 'dragend', function () {
          // 'dragend' fires on mouse release.
          // 'idle' listener waits until drag inertia ends before firing `onDragEnd`
          var idleListener = maps.event.addListener(map, 'idle', function () {
            maps.event.removeListener(idleListener);
            this_._onDragEnd(map);
          });
        });
        // user choosing satellite vs roads, etc
        maps.event.addListener(map, 'maptypeid_changed', function () {
          this_._onMapTypeIdChange(map.getMapTypeId());
        });
      }).catch(function (e) {
        // notify callback of load failure
        _this._onGoogleApiLoaded({
          map: null,
          maps: null,
          ref: _this.googleMapDom_
        });
        console.error(e); // eslint-disable-line no-console
        throw e;
      });
    };

    _this._onGoogleApiLoaded = function () {
      if (_this.props.onGoogleApiLoaded) {
        var _this$props;

        if (false) {
          console.warn('GoogleMap: ' + // eslint-disable-line
          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
        }

        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
      }
    };

    _this._getHoverDistance = function () {
      return _this.props.hoverDistance;
    };

    _this._onDrag = function () {
      var _this$props2;

      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
    };

    _this._onDragEnd = function () {
      var _this$props3;

      return _this.props.onDragEnd && (_this$props3 = _this.props).onDragEnd.apply(_this$props3, arguments);
    };

    _this._onMapTypeIdChange = function () {
      var _this$props4;

      return _this.props.onMapTypeIdChange && (_this$props4 = _this.props).onMapTypeIdChange.apply(_this$props4, arguments);
    };

    _this._onZoomAnimationStart = function () {
      var _this$props5;

      return _this.props.onZoomAnimationStart && (_this$props5 = _this.props).onZoomAnimationStart.apply(_this$props5, arguments);
    };

    _this._onZoomAnimationEnd = function () {
      var _this$props6;

      return _this.props.onZoomAnimationEnd && (_this$props6 = _this.props).onZoomAnimationEnd.apply(_this$props6, arguments);
    };

    _this._onTilesLoaded = function () {
      return _this.props.onTilesLoaded && _this.props.onTilesLoaded();
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        var _this$props7;

        return (_this$props7 = _this.props).onChildClick.apply(_this$props7, arguments);
      }
      return undefined;
    };

    _this._onChildMouseDown = function (hoverKey, childProps) {
      _this.childMouseDownArgs_ = [hoverKey, childProps];
      if (_this.props.onChildMouseDown) {
        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
      }
    };

    _this._onChildMouseUp = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseUp) {
          var _this$props8;

          (_this$props8 = _this.props).onChildMouseUp.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
        _this.childMouseDownArgs_ = null;
        _this.childMouseUpTime_ = new Date().getTime();
      }
    };

    _this._onChildMouseMove = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseMove) {
          var _this$props9;

          (_this$props9 = _this.props).onChildMouseMove.apply(_this$props9, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
      }
    };

    _this._onChildMouseEnter = function () {
      if (_this.props.onChildMouseEnter) {
        var _this$props10;

        return (_this$props10 = _this.props).onChildMouseEnter.apply(_this$props10, arguments);
      }
      return undefined;
    };

    _this._onChildMouseLeave = function () {
      if (_this.props.onChildMouseLeave) {
        var _this$props11;

        return (_this$props11 = _this.props).onChildMouseLeave.apply(_this$props11, arguments);
      }
      return undefined;
    };

    _this._setViewSize = function () {
      if (!_this.mounted_) return;
      if (isFullScreen()) {
        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
      } else {
        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
      }
      _this._onBoundsChanged();
    };

    _this._onWindowResize = function () {
      _this.resetSizeOnIdle_ = true;
    };

    _this._onMapMouseMove = function (e) {
      if (!_this.mouseInMap_) return;

      var currTime = new Date().getTime();
      var K_RECALC_CLIENT_RECT_MS = 50;

      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
      }
      _this.mouseMoveTime_ = currTime;

      var mousePosX = e.clientX - _this.boundingRect_.left;
      var mousePosY = e.clientY - _this.boundingRect_.top;

      if (!_this.mouse_) {
        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
      }

      _this.mouse_.x = mousePosX;
      _this.mouse_.y = mousePosY;

      var latLng = _this.geoService_.fromContainerPixelToLatLng(_this.mouse_);
      _this.mouse_.lat = latLng.lat;
      _this.mouse_.lng = latLng.lng;

      _this._onChildMouseMove();

      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
        _this.fireMouseEventOnIdle_ = true;
      } else {
        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        _this.fireMouseEventOnIdle_ = false;
      }
    };

    _this._onClick = function () {
      var _this$props12;

      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props12 = _this.props).onClick.apply(_this$props12, arguments);
    };

    _this._onMapClick = function (event) {
      if (_this.markersDispatcher_) {
        // support touch events and recalculate mouse position on click
        _this._onMapMouseMove(event);
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          if (_this.mouse_) {
            _this._onClick(_extends({}, _this.mouse_, {
              event: event
            }));
          }

          _this.markersDispatcher_.emit('kON_CLICK', event);
        }
      }
    };

    _this._onMapMouseDownNative = function (event) {
      if (!_this.mouseInMap_) return;

      _this._onMapMouseDown(event);
    };

    _this._onMapMouseDown = function (event) {
      if (_this.markersDispatcher_) {
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          // Hovered marker detected at mouse move could be deleted at mouse down time
          // so it will be good to force hovered marker recalculation
          _this._onMapMouseMove(event);
          _this.markersDispatcher_.emit('kON_MDOWN', event);
        }
      }
    };

    _this._onMapMouseDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        // to fix strange zoom in chrome
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._onKeyDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._isCenterDefined = function (center) {
      return center && ((0, _isPlainObject2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
    };

    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
      if (map) {
        var gmC = map.getCenter();
        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
      }

      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
        var zoom = _this.geoService_.getZoom();
        var bounds = _this.geoService_.getBounds();
        var centerLatLng = _this.geoService_.getCenter();

        if (!(0, _isArraysEqualEps2.default)(bounds, _this.prevBounds_, kEPS)) {
          if (callExtBoundsChange !== false) {
            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
            if (_this.props.onBoundsChange) {
              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
            }

            if (_this.props.onChange) {
              _this.props.onChange({
                center: _extends({}, centerLatLng),
                zoom: zoom,
                bounds: {
                  nw: {
                    lat: bounds[0],
                    lng: bounds[1]
                  },
                  se: {
                    lat: bounds[2],
                    lng: bounds[3]
                  },
                  sw: {
                    lat: bounds[4],
                    lng: bounds[5]
                  },
                  ne: {
                    lat: bounds[6],
                    lng: bounds[7]
                  }
                },
                marginBounds: {
                  nw: {
                    lat: marginBounds[0],
                    lng: marginBounds[1]
                  },
                  se: {
                    lat: marginBounds[2],
                    lng: marginBounds[3]
                  },
                  sw: {
                    lat: marginBounds[4],
                    lng: marginBounds[5]
                  },
                  ne: {
                    lat: marginBounds[6],
                    lng: marginBounds[7]
                  }
                },

                size: _this.geoService_.hasSize() ? {
                  width: _this.geoService_.getWidth(),
                  height: _this.geoService_.getHeight()
                } : {
                  width: 0,
                  height: 0
                }
              });
            }

            _this.prevBounds_ = bounds;
          }
        }
      }
    };

    _this._registerChild = function (ref) {
      _this.googleMapDom_ = ref;
    };

    _this.mounted_ = false;
    _this.initialized_ = false;
    _this.googleApiLoadedCalled_ = false;

    _this.map_ = null;
    _this.maps_ = null;
    _this.prevBounds_ = null;
    _this.heatmap = null;

    _this.layers_ = {};

    _this.mouse_ = null;
    _this.mouseMoveTime_ = 0;
    _this.boundingRect_ = null;
    _this.mouseInMap_ = true;

    _this.dragTime_ = 0;
    _this.fireMouseEventOnIdle_ = false;
    _this.updateCounter_ = 0;

    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
    _this.centerIsObject_ = (0, _isPlainObject2.default)(_this.props.center);

    _this.minZoom_ = DEFAULT_MIN_ZOOM;
    _this.defaultDraggableOption_ = true;

    _this.zoomControlClickTime_ = 0;

    _this.childMouseDownArgs_ = null;
    _this.childMouseUpTime_ = 0;

    _this.googleMapDom_ = null;

    if (false) {
      if (_this.props.apiKey) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
      }

      if (_this.props.onBoundsChange) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
      }

      if ((0, _isEmpty2.default)(_this.props.center) && (0, _isEmpty2.default)(_this.props.defaultCenter)) {
        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
        );
      }

      if ((0, _isEmpty2.default)(_this.props.zoom) && (0, _isEmpty2.default)(_this.props.defaultZoom)) {
        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
        );
      }
    }

    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
    }

    _this.zoomAnimationInProgress_ = false;

    _this.state = {
      overlay: null
    };
    return _this;
  }

  GoogleMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted_ = true;
    (0, _passiveEvents2.default)(window, 'resize', this._onWindowResize, false);
    (0, _passiveEvents2.default)(window, 'keydown', this._onKeyDownCapture, true);
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    // gmap can't prevent map drag if mousedown event already occured
    // the only workaround I find is prevent mousedown native browser event

    if (mapDom) {
      (0, _passiveEvents2.default)(mapDom, 'mousedown', this._onMapMouseDownNative, true);
    }

    (0, _passiveEvents2.default)(window, 'mouseup', this._onChildMouseUp, false);
    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);

    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly

    setTimeout(function () {
      // to detect size
      _this2._setViewSize();
      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
        _this2._initMap();
      }
    }, 0, this);
    if (this.props.resetBoundsOnResize) {
      var that = this;
      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
    }
  };

  GoogleMap.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (false) {
      if (!(0, _shallowEqual2.default)(this.props.defaultCenter, nextProps.defaultCenter)) {
        console.warn("GoogleMap: defaultCenter prop changed. You can't change default props.");
      }

      if (!(0, _shallowEqual2.default)(this.props.defaultZoom, nextProps.defaultZoom)) {
        console.warn("GoogleMap: defaultZoom prop changed. You can't change default props.");
      }
    }

    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
      setTimeout(function () {
        return _this3._initMap();
      }, 0);
    }

    if (this.map_) {
      var centerLatLng = this.geoService_.getCenter();
      if (this._isCenterDefined(nextProps.center)) {
        var nextPropsCenter = latLng2Obj(nextProps.center);
        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;

        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
            this.map_.panTo({
              lat: nextPropsCenter.lat,
              lng: nextPropsCenter.lng
            });
          }
        }
      }

      if (!(0, _isEmpty2.default)(nextProps.zoom)) {
        // if zoom chaged by user
        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
          this.map_.setZoom(nextProps.zoom);
        }
      }

      if (!(0, _isEmpty2.default)(this.props.draggable) && (0, _isEmpty2.default)(nextProps.draggable)) {
        // reset to default
        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
      } else if (!(0, _shallowEqual2.default)(this.props.draggable, nextProps.draggable)) {
        // also prevent this on window 'mousedown' event to prevent map move
        this.map_.setOptions({ draggable: nextProps.draggable });
      }

      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
      if (!(0, _isEmpty2.default)(nextProps.options) && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
        var mapPlainObjects = (0, _pick2.default)(this.maps_, _isPlainObject2.default);
        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
        // remove zoom, center and draggable options as these are managed by google-maps-react
        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);

        if ('minZoom' in options) {
          var minZoom = this._computeMinZoom(options.minZoom);
          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
        }

        this.map_.setOptions(options);
      }

      if (!(0, _shallowEqual2.default)(nextProps.layerTypes, this.props.layerTypes)) {
        Object.keys(this.layers_).forEach(function (layerKey) {
          _this3.layers_[layerKey].setMap(null);
          delete _this3.layers_[layerKey];
        });
        this._setLayers(nextProps.layerTypes);
      }

      if (this.heatmap && !(0, _shallowEqual2.default)(nextProps.heatmap.positions, this.props.heatmap.positions)) {
        this.heatmap.setData(nextProps.heatmap.positions.map(function (p) {
          return {
            location: new _this3.maps_.LatLng(p.lat, p.lng),
            weight: p.weight
          };
        }));
      }
    }
  };

  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // draggable does not affect inner components
    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.markersDispatcher_.emit('kON_CHANGE');

    if (!(0, _shallowEqual2.default)(this.props.hoverDistance, prevProps.hoverDistance)) {
      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
    }
  };

  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted_ = false;
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    if (mapDom) {
      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
    }
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('keydown', this._onKeyDownCapture);
    window.removeEventListener('mouseup', this._onChildMouseUp, false);
    if (this.props.resetBoundsOnResize) {
      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
    }

    if (this.overlay_) {
      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
      this.overlay_.setMap(null);
    }

    if (this.maps_ && this.map_ && this.props.shouldUnregisterMapOnUnmount) {
      // fix google, as otherwise listeners works even without map
      this.map_.setOptions({ scrollwheel: false });
      this.maps_.event.clearInstanceListeners(this.map_);
    }

    if (this.props.shouldUnregisterMapOnUnmount) {
      this.map_ = null;
      this.maps_ = null;
    }
    this.markersDispatcher_.dispose();

    this.resetSizeOnIdle_ = false;

    if (this.props.shouldUnregisterMapOnUnmount) {
      delete this.map_;
      delete this.markersDispatcher_;
    }
  };
  // calc minZoom if map size available
  // it's better to not set minZoom less than this calculation gives
  // otherwise there is no homeomorphism between screen coordinates and map
  // (one map coordinate can have different screen coordinates)


  // this method works only if this.props.onChildMouseDown was called


  // this method works only if this.props.onChildMouseDown was called


  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough


  // gmap can't prevent map drag if mousedown event already occured
  // the only workaround I find is prevent mousedown native browser event


  GoogleMap.prototype.render = function render() {
    var overlay = this.state.overlay;
    var mapMarkerPrerender = !overlay ? _react2.default.createElement(_google_map_markers_prerender2.default, {
      experimental: this.props.experimental,
      onChildClick: this._onChildClick,
      onChildMouseDown: this._onChildMouseDown,
      onChildMouseEnter: this._onChildMouseEnter,
      onChildMouseLeave: this._onChildMouseLeave,
      geoService: this.geoService_,
      insideMapPanes: false,
      distanceToMouse: this.props.distanceToMouse,
      getHoverDistance: this._getHoverDistance,
      dispatcher: this.markersDispatcher_
    }) : null;

    return _react2.default.createElement('div', {
      style: this.props.style,
      onMouseMove: this._onMapMouseMove,
      onMouseDownCapture: this._onMapMouseDownCapture,
      onClick: this._onMapClick
    }, _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }), IS_REACT_16 && overlay && createPortal(this._renderPortal(), overlay), mapMarkerPrerender);
  };

  return GoogleMap;
}(_react.Component);

GoogleMap.propTypes = {
  apiKey: _propTypes2.default.string,
  bootstrapURLKeys: _propTypes2.default.any,

  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  defaultZoom: _propTypes2.default.number,
  zoom: _propTypes2.default.number,
  onBoundsChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseUp: _propTypes2.default.func,
  onChildMouseMove: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onZoomAnimationStart: _propTypes2.default.func,
  onZoomAnimationEnd: _propTypes2.default.func,
  onDrag: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  onMapTypeIdChange: _propTypes2.default.func,
  onTilesLoaded: _propTypes2.default.func,
  options: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  hoverDistance: _propTypes2.default.number,
  debounced: _propTypes2.default.bool,
  margin: _propTypes2.default.array,
  googleMapLoader: _propTypes2.default.any,
  onGoogleApiLoaded: _propTypes2.default.func,
  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  style: _propTypes2.default.any,
  resetBoundsOnResize: _propTypes2.default.bool,
  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string), // ['TransitLayer', 'TrafficLayer']
  shouldUnregisterMapOnUnmount: _propTypes2.default.bool
};
GoogleMap.defaultProps = {
  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
  },

  hoverDistance: 30,
  debounced: true,
  options: defaultOptions_,
  googleMapLoader: _google_map_loader2.default,
  yesIWantToUseGoogleMapApiInternals: false,
  style: {
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    position: 'relative'
  },
  layerTypes: [],
  heatmap: {},
  heatmapLibrary: false,
  shouldUnregisterMapOnUnmount: true
};
GoogleMap.googleMapLoader = _google_map_loader2.default;
exports.default = GoogleMap;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js